(function() {
  'use strict';

  angular
    .module('inspinia', 
      [
        'ngAnimate', 
        'ngCookies', 
        'ngTouch', 
        'ngSanitize', 
        'ngMessages', 
        'ngAria', 
        'ngResource', 
        'ui.router',           
        'ui.bootstrap',
        'ngStorage',
        'ngMask',
        'toastr',
        'ui-leaflet',
        'summernote',
        'chart.js',
        'ui.select',
        'datePicker',
        'cgBusy',
        'ui.utils.masks'
      ]);
})();

'use strict';

angular.module('inspinia')
  .controller('ConsultarDetalhesTituloController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'titulo', '$http', 'APP_API_FRND',
      function($scope, $state, toastr, $uibModalInstance, titulo, $http, APP_API_FRND)
  {
    var vm = this;

    vm.init = function()
    {
      vm.consultarPromise = $http.get(APP_API_FRND + "/invoice/titulo/consultar/" + titulo.viewId)
      .then(function(response)
      { 
          vm.titulo = response.data;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.excluir = function() {
      if (confirm('Deseja realmente excluir este registro?'))
      {
        vm.inserirPessoa = $http.delete(APP_API_FRND + "/invoice/titulo/delete/" + vm.titulo.viewId).success(function(response){
          $uibModalInstance.close('excluido');
          toastr.info('Registro excluído com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
      }
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('BoletoVencidoItauGerarController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'codigo', 'antecipacao', '$http', 'APP_API_FRND',
      function($scope, $state, toastr, $uibModalInstance, codigo, antecipacao, $http, APP_API_FRND)
  {
    var vm = this;
    vm.codigo = codigo;
    vm.antecipacao = antecipacao;

    vm.init = function()
    {
      /*
      vm.consultaPromise = $http.get(APP_API_FRND + "/ccb/antecipacaodetalhe/" + antecipacao.viewId)
      .then(function(response)
      { 
        vm.registro = response.data;
      });
      */
    }

    vm.visualizarBoleto = function() {
      vm.consultaPromise = $http.post(APP_API_FRND + "/EmailCarteiraDinamica/verboleto", antecipacao).success(function(response){
          
          vm.download(response, 'application/pdf', 'boleto.pdf');

          return response;
      }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoConsultarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'sacado', '$http', 'APP_API_FRND', 'usuario',
      function($scope, $state, toastr, $uibModalInstance, sacado, $http, APP_API_FRND, usuario)
  {
    var vm = this;
    vm.sacado = sacado;
    vm.usuarioParam = usuario;

    vm.init = function()
    {
        vm.consultar();
    }

    vm.consultar = function()
    {
        return $http.get(APP_API_FRND + "/sacado/consultarUsuario/" + vm.usuarioParam.viewId)
        .then(function(response)
        { 
            vm.usuario = response.data;
        }); 
    }

    vm.atualizar = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }

        if (vm.usuario.login == null || vm.usuario.login == '')
        {
            toastr.error('Favor informar o Login.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.sacadoViewId = vm.sacado.viewId;

        $http.post(APP_API_FRND + "/sacado/alterarUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário atualizado com sucesso.', 'Alerta');
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoCadastrarUsuarioController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'sacado', '$http', 'APP_API_FRND',
      function($scope, $state, toastr, $uibModalInstance, sacado, $http, APP_API_FRND)
  {
    var vm = this;
    vm.sacado = sacado;

    vm.init = function()
    {
    }

    vm.incluir = function()
    {
        if (vm.usuario.nome == null || vm.usuario.nome == '')
        {
            toastr.error('Favor informar o Nome.');
            return;
        }
        
        if (vm.usuario.email == null || vm.usuario.email == '')
        {
            toastr.error('Favor informar o E-mail.');
            return;
        }

        if (vm.usuario.senha == null || vm.usuario.senha == '')
        {
            toastr.error('Favor informar a Senha.');
            return;
        }

        vm.usuario.sacadoViewId = vm.sacado.viewId;

        $http.post(APP_API_FRND + "/sacado/incluirUsuario", vm.usuario).success(function(response){
            toastr.info('Usuário cadastrado com sucesso.', 'Alerta');
            $uibModalInstance.close();
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('FaturasDisponiveisAnteciparController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'registros', '$http', 'APP_API_FRND','AuthService',
      function($scope, $state, toastr, $uibModalInstance, registros, $http, APP_API_FRND, AuthService)
  {
    var vm = this;
    vm.registros = registros;
    vm.total = {
      valorTotal : 0,
      quantidade : 0
    };

    vm.init = function()
    {
      vm.calcularTotal();
      vm.codigoCedenteVmoney = AuthService.getCodigoVmoney();
      //console.log("vm.codigoCedenteVmoney:",vm.codigoCedenteVmoney)
      console.log("codigoVmoney:",vm.registros[0].codigoVmoney)
     //console.log("vm.registros:",vm.registros)
    }

    vm.enviar = function()
    {
      var antecipacao = {
        itens: vm.registros
      };

      if (vm.codigoCedenteVmoney == null || vm.codigoCedenteVmoney == '')
       {
           toastr.error('Cedente não Possui Codigo do Vmoney, Solicite ao ADM que o insira antes de Continuar', 'AÇÃO BLOQUEADA');
           return;
       };

      vm.inserirPessoa = $http.post(APP_API_FRND + "/invoice/antecipacao/antecipar", antecipacao).success(function(response){
          vm.fechar();
          toastr.info('Operação enviada com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
    }

    vm.calcularTotal = function()
    {
        var total = 0;
        var quantidade = 0;

        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.registros[i].selecionadoAntecipar)
            {

                total += vm.registros[i].valor;
                quantidade++;
            }
        }

        vm.total.valorTotal = total;
        vm.total.quantidade = quantidade;
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('ConsultarTitulosPropostaController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'antecipacao', '$http', 'APP_API_FRND',
      function($scope, $state, toastr, $uibModalInstance, antecipacao, $http, APP_API_FRND)
  {
    var vm = this;
    vm.antecipacao = antecipacao;
    vm.propostas = [];

    vm.init = function()
    {
      vm.consultaPromise = $http.get(APP_API_FRND + "/invoice/antecipacao/consultartitulos/" + antecipacao.viewId)
      .then(function(response)
      { 
          vm.titulos = response.data;
          //vm.registros = response.data;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('ConsultarRetornoPropostaController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'antecipacao', '$http', 'APP_API_FRND',
      function($scope, $state, toastr, $uibModalInstance, antecipacao, $http, APP_API_FRND)
  {
    var vm = this;
    vm.antecipacao = antecipacao;
    vm.proposta = {};

    vm.init = function()
    {
      vm.consultarPromise = $http.get(APP_API_FRND + "/invoice/antecipacao/consultarproposta/" + antecipacao.viewId)
      .then(function(response)
      { 
          vm.proposta = response.data;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('AprovarPropostaController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'antecipacao', '$http', 'APP_API_FRND',
      function($scope, $state, toastr, $uibModalInstance, antecipacao, $http, APP_API_FRND)
  {
    var vm = this;
    vm.antecipacao = antecipacao;
    vm.proposta = {};

    vm.init = function()
    {
      return $http.get(APP_API_FRND + "/invoice/antecipacao/consultarproposta/" + antecipacao.viewId)
      .then(function(response)
      { 
          vm.proposta = response.data;
      });
    }

    vm.enviar = function()
    {
      vm.aprovarProposta = $http.post(APP_API_FRND + "/invoice/antecipacao/aprovarProposta", vm.proposta).success(function(response){
          vm.fechar();
          toastr.info('Proposta aprovada com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
    }

    vm.recusar = function()
    {
      vm.aprovarProposta = $http.post(APP_API_FRND + "/invoice/antecipacao/reprovarProposta", vm.proposta).success(function(response){
          vm.fechar();
          toastr.info('Proposta recusada com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('CarteiraModalBoletoController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_API_FRND', 'item', '$sce',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_API_FRND, item, $sce)
  {
    var vm = this;
    vm.item = item;

    vm.init = function()
    {
      vm.filePdf = $sce.trustAsResourceUrl('data:application/pdf;base64,' + vm.item);
    }

    vm.visualizarBoleto = function() {
      $uibModalInstance.close(false);
    }

    vm.visualizarBoletoAtualizado = function() {
      $uibModalInstance.close(true);
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia') 
  .controller('BoletoVencidoGerarController', ['$scope', '$state', 'toastr', '$uibModalInstance', 'antecipacao', '$http', 'APP_API_FRND', '$uibModal', 'AuthService',
      function($scope, $state, toastr, $uibModalInstance, antecipacao, $http, APP_API_FRND, $uibModal, AuthService)
  {
    var vm = this;
    vm.antecipacao = antecipacao;
    vm.usoDeBoleto = AuthService.getUsoDeBoleto();


    vm.init = function()
    {
      /*
      vm.consultaPromise = $http.get(APP_API_FRND + "/ccb/antecipacaodetalhe/" + antecipacao.viewId)
      .then(function(response)
      { 
        vm.registro = response.data;
      });
      */
    }

    vm.visualizarBoleto = function() {
      antecipacao.isGerarAtualizado = false;
      
      vm.consultaPromise = $http.post(APP_API_FRND + "/EmailCarteiraDinamica/verboleto", antecipacao).success(function(response){
          
          //vm.download(response, 'application/pdf', 'boleto.pdf');
          var modalInstance = $uibModal.open({
              templateUrl: 'app/email/carteira/modal/boleto/index.html',
              controller: 'CarteiraModalBoletoController',
              controllerAs: 'controller',
              windowClass: 'inmodal',
              size: 'lg',
              resolve: {
                  item: function () {
                      return response;
                  },
              }
          }).closed.then(function(){
              //vm.listar();
          });

          return response;
      }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
      });
    }

    vm.visualizarBoletoAtualizado = function() {
      antecipacao.isGerarAtualizado = true;

      vm.consultaPromise = $http.post(APP_API_FRND + "/EmailCarteiraDinamica/verboleto", antecipacao).success(function(response){
          
          //vm.download(response, 'application/pdf', 'boleto.pdf');
          var modalInstance = $uibModal.open({
            templateUrl: 'app/email/carteira/modal/boleto/index.html',
            controller: 'CarteiraModalBoletoController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                item: function () {
                    return response;
                },
            }
        }).closed.then(function(){
            //vm.listar();
        });

          return response;
      }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoSelecionarNovoController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_API_FRND', '$compile', 'AuthService',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_API_FRND, $compile, AuthService)
  {
    
    var vm = this;
    vm.sacado = {
        endereco: {}
    };

    vm.init = function()
    {

    }

    vm.salvar = function()
    {
        var tipoDocumentoDescricao = AuthService.getTipoDocumentoDescricao();

        if (vm.sacado.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.cnpj == null || (vm.sacado.cnpj.toString().length != 18 && vm.sacado.cnpj.toString().length != 14))
        {
            toastr.error('CPF/CNPJ de tamanho irregular', 'Cliente');
            return;
        }
            // Exemplo de uso na sua função
        if (vm.sacado.cnpj == null || !verificarCPFCNPJ(vm.sacado.cnpj)) 
        {
            toastr.error('CPF/CNPJ inválido.', 'Cliente');
            return;
        }

        if (vm.sacado.razaoSocial == null || vm.sacado.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Cliente');
            return;
        }

        if (tipoDocumentoDescricao !== 'Cheque')
        {
            if (vm.sacado.endereco.cep == null || vm.sacado.endereco.cep == '') 
                {
                    toastr.error('CEP é obrigatório, Documento escolhido é ' + tipoDocumentoDescricao, 'Cliente');
                    return;
                }
        
                if (vm.sacado.endereco.logradouro == null || vm.sacado.endereco.logradouro == '')
                {
                    toastr.error('Logradouro é obrigatório.', 'Cliente');
                    return;
                }
        
                if (vm.sacado.endereco.cidade == null || vm.sacado.endereco.cidade == '')
                {
                    toastr.error('Cidade é obrigatório.', 'Cliente');
                    return;
                }
        
                if (vm.sacado.endereco.uf == null || vm.sacado.endereco.uf == '')
                {
                    toastr.error('Estado é obrigatório.', 'Cliente');
                    return;
                }

        }



        vm.salvarPromise = $http.post(APP_API_FRND + "/sacado/incluir", vm.sacado).success(function(response){
            toastr.info('Sacado cadastrado com sucesso.', 'Alerta');
            $uibModalInstance.close(vm.sacado);
            return response;
        }).error(function(error){
            toastr.error(error, 'Cliente');
            return error;
        });

        /*
        vm.salvarPromise = CedenteService.cadastrar(vm.cedente);

        vm.salvarPromise.then(function(result) {  
            if (result.status)
            {
                toastr.info('Cedente cadastrada com sucesso!', 'Cedente');
                $state.go('index.pesquisar_cedente');
            }
            else
            {
                alert('Ocorreu um erro na solicitação.');
            }
        });
        */
    }

    vm.init();

    /*
    function validarCNPJ(s) {
        var cnpj = s.replace(/[^\d]+/g, '')
    
        // Valida a quantidade de caracteres
        if (cnpj.length !== 14)
            return false
    
        // Elimina inválidos com todos os caracteres iguais
        if (/^(\d)\1+$/.test(cnpj))
            return false
    
        // Cáculo de validação
        var t = cnpj.length - 2,
            d = cnpj.substring(t),
            d1 = parseInt(d.charAt(0)),
            d2 = parseInt(d.charAt(1)),
            calc = x => {
                var n = cnpj.substring(0, x),
                    y = x - 7,
                    s = 0,
                    r = 0
    
                    for (var i = x; i >= 1; i--) {
                        s += n.charAt(x - i) * y--;
                        if (y < 2)
                            y = 9
                    }
    
                    r = 11 - s % 11
                    return r > 9 ? 0 : r
            }
    
        return calc(t) === d1 && calc(t + 1) === d2
    }
    */

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    // Função para validar CPF
    function validarCPF(cpf) {
        cpf = cpf.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos
        if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
            return false; // Verifica se o CPF tem 11 dígitos e não é uma sequência repetida
        }

        var soma = 0, resto;
        for (var i = 1; i <= 9; i++) {
            soma += parseInt(cpf.substring(i-1, i)) * (11 - i);
        }
        resto = (soma * 10) % 11;
        if ((resto === 10) || (resto === 11)) resto = 0;
        if (resto !== parseInt(cpf.substring(9, 10))) return false;

        soma = 0;
        for (var i = 1; i <= 10; i++) {
            soma += parseInt(cpf.substring(i-1, i)) * (12 - i);
        }
        resto = (soma * 10) % 11;
        if ((resto === 10) || (resto === 11)) resto = 0;
        if (resto !== parseInt(cpf.substring(10, 11))) return false;
        
        return true;
    }

    // Função para validar CNPJ
    function validarCNPJ(cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos
        if (cnpj.length !== 14) {
            return false; // Verifica se o CNPJ tem 14 dígitos
        }

        var tamanho = cnpj.length - 2;
        var numeros = cnpj.substring(0, tamanho);
        var digitos = cnpj.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;
        for (var i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
        }
        var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== parseInt(digitos.charAt(0))) {
            return false;
        }

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (var i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== parseInt(digitos.charAt(1))) {
            return false;
        }
        
        return true;
    }

    // Função principal para verificar CPF/CNPJ
    function verificarCPFCNPJ(cnpjCpf) {
        cnpjCpf = cnpjCpf.toString();
        if (cnpjCpf.length === 14) {
            return validarCPF(cnpjCpf);
        } else if (cnpjCpf.length === 18) {
            return validarCNPJ(cnpjCpf);
        } else {
            return false;
        }
    }



}]);
'use strict';

angular.module('inspinia')
  .controller('EsqueciMinhaSenhaController', ['$scope', '$state', 'toastr', '$uibModalInstance', '$http', 'APP_API_FRND',
      function($scope, $state, toastr, $uibModalInstance, $http, APP_API_FRND)
  {
    var vm = this;    
    vm.usuario = {};

    vm.init = function()
    {

    }

    vm.enviar = function()
    {
      vm.esqueciSenhaPromise = $http.post(APP_API_FRND + "/cedente/esquecisenha", vm.usuario).success(function(response){
          vm.fechar();
          toastr.info('Solicitação enviada com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoInvoiceDigitacaoTituloCadastroController', ['$scope', '$state', 'toastr', '$uibModal', '$uibModalInstance', 'APP_API_FRND', '$http', 'titulos',
      function($scope, $state, toastr, $uibModal, $uibModalInstance, APP_API_FRND, $http, titulos)
{
    var vm = this;
    vm.titulos = titulos;
    vm.isUpdate = false;
    vm.editCedente = true;

    vm.registro = {
      dataRecebimento: new Date(new Date().setHours(18)),
      dataVencimento: new Date(new Date().setHours(18)),
    };

    vm.init = function()
    {
      vm.consultarTipoDocumento();

      if (vm.titulos.length > 0)
      {
        vm.editCedente = false;
        vm.registro.cedente = vm.titulos[vm.titulos.length-1].cedente;
        vm.registro.sacado = vm.titulos[vm.titulos.length-1].sacado;        
      }

      /*
      if (empresa != null)
      {
        vm.empresa = empresa;
      }
      */
    }

    vm.consultarTipoDocumento = function()
    {
      vm.consultaTipoDocumentoPromise = $http.get(APP_API_FRND + "/invoice/tituloTipoDocumento/pesquisar")
      .then(function(response)
      { 
          vm.tiposDocumento = response.data; 
          
          if (vm.tiposDocumento.length > 0)
          {
            if (vm.titulos.length > 0)
            {
              var viewId = vm.titulos[vm.titulos.length-1].tipoDocumento.viewId;

              for (var i=0;i<vm.tiposDocumento.length;i++)
              {
                if (vm.tiposDocumento[i].viewId == viewId)
                {
                  vm.registro.tipoDocumento = vm.tiposDocumento[i];    
                }
              }
            }
            else
            {
              vm.registro.tipoDocumento = vm.tiposDocumento[0];
            }            
          }
      });
    }

    vm.salvar = function()
    {
      if (!vm.isUpdate)
      {
        // Numero
        if (vm.registro.numero == null || vm.registro.numero == '')
        {
          toastr.error('Favor informar o número do Título.', 'Alerta');
          return;
        }

        // Verificar Numero
        /*
        for (var i=0;i<vm.titulos.length;i++)
        {
          if (vm.registro.numero == vm.titulos[i].numero)
          {
            toastr.error('Número do Título já cadastrado.', 'Alerta');
            return;
          }
        }
        */

        if (vm.registro.dataVencimento < new Date(new Date().setHours(0)))
        {
          toastr.error('Data de vencimento deve ser maior que a data atual.', 'Alerta');
          return;
        }

        // Cedente
        /*
        if (vm.registro.cedente == null)
        {
          toastr.error('Favor selecionar o Cedente.', 'Alerta');
          return;
        }
        */

        // Sacado
        if (vm.registro.sacado == null)
        {
          toastr.error('Favor selecionar o Sacado.', 'Alerta');
          return;
        }

        // Sacaco - Endereco
        if (
          vm.registro.sacado.enderecoCep == null || 
          vm.registro.sacado.enderecoCep == '' || 
          vm.registro.sacado.enderecoLogradouro == null || 
          vm.registro.sacado.enderecoLogradouro == '' || 
          vm.registro.sacado.enderecoCidade == null || 
          vm.registro.sacado.enderecoCidade == '' || 
          vm.registro.sacado.enderecoUf == null || 
          vm.registro.sacado.enderecoUf == ''
          )
        {
          toastr.error('Sacado selecionado não possui endereço.', 'Alerta');
          return;
        }

        // Valor
        if (vm.registro.valor == null || vm.registro.valor == '')
        {
          toastr.error('Favor informar o Valor.', 'Alerta');
          return;
        }

        // Verificar o tipo de documento
        if (vm.registro.tipoDocumento == null)
        {
          toastr.error('Favor informar o Tipo do Documento.', 'Alerta');
          return;
        }

        // Verificar se e nota fiscal
        if (vm.registro.tipoDocumento.descricao == 'Duplicata')
        {
          if (vm.registro.notaFiscalNumero == null || vm.registro.notaFiscalNumero == '')
          {
            toastr.error('Favor informar o Número da Nota Fiscal.', 'Alerta');
          return;
          }
        }

        try 
        {
          vm.registro.valor = parseFloat(vm.registro.valor.toString().replaceAll('R$ ','0').replaceAll('.','').replaceAll(',','.'));
        }
        catch (erro) {
          toastr.error('Favor informar corretamente o Valor.', 'Alerta');
          return;
        }

        // Valor
        if (vm.registro.valor <= 0)
        {
          toastr.error('Favor informar o Valor.', 'Alerta');
          return;
        }

        // GUID
        vm.registro.viewId = uuidv4();

        // Cadastro
        vm.titulos.push(vm.registro);

        vm.fechar();
      }

      /*
      vm.incluirPromise = $http.post(APP_API_FRND + "/fornecedor/adicionarempresa", vm.empresa).success(function(response){        
        
        vm.empresa.viewId = response;

        toastr.info('Registro cadastrado com sucesso.', 'Alerta');
        vm.fornecedor.empresas.push(vm.empresa);
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
      */
    }

    function uuidv4() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    }

    /*
    vm.atualizar = function()
    {
      vm.incluirPromise = $http.post(APP_API_FRND + "/fornecedor/atualizarempresa", vm.empresa).success(function(response){        
        
        vm.empresa.viewId = response;

        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        vm.fornecedor.empresas.splice(indice, 1);
        vm.fornecedor.empresas.push(vm.empresa);
        vm.fechar();

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }
    */

    vm.selecionarCedenteModal = function()
    {    
      if (vm.editCedente)
      {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/cadastro/cedente/selecionar/index.html',
          controller: 'CedenteSelecionarController',
          controllerAs: 'controller',
          windowClass: 'inmodal',
          size: 'lg',
          }).result.then(function(data){
              vm.registro.cedente = null;
              if (data != null)
              {
                  vm.registro.cedente = data;
              }      
          });
      } 
    }

    vm.selecionarSacadoModal = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/sacado/selecionar/index.html',
        controller: 'SacadoSelecionarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            vm.registro.sacado = null;
            if (data != null)
            {
                vm.registro.sacado = data;
            }      
        });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('InvoiceDigitacaoTituloCadastroController', ['$scope', '$state', 'toastr', '$uibModal', '$uibModalInstance', 'APP_API_FRND', '$http', 'titulos', 'AuthService',
    function ($scope, $state, toastr, $uibModal, $uibModalInstance, APP_API_FRND, $http, titulos, AuthService) {
      var vm = this;
      vm.titulos = titulos;
      vm.isUpdate = false;
      vm.editCedente = true;

      vm.registro = {
        //dataRecebimento: new Date(new Date().setHours(18)),
        //dataVencimento: new Date(new Date().setHours(18)),
        dataRecebimento: new Date(),
        dataVencimento: new Date(),
        bancoCheque: null // Aqui você adiciona a propriedade para armazenar o banco selecionado
      };

      vm.init = function () {
        vm.consultarTipoDocumento();
        vm.consultarBancos(); // Chamar para carregar a lista de bancos      

        if (vm.titulos.length > 0) {
          vm.editCedente = false;
          vm.registro.cedente = vm.titulos[vm.titulos.length - 1].cedente;
          vm.registro.sacado = vm.titulos[vm.titulos.length - 1].sacado;
        }

        /*
        if (empresa != null)
        {
          vm.empresa = empresa;
        }
        */
      }

      vm.consultarBancos = function () {

        vm.consultaBancosPromise = $http.get(APP_API_FRND + "/banco/pesquisar")
          .then(function (response) {
            vm.bancos = response.data;


          })
          .catch(function (error) {
            toastr.error('Erro ao consultar bancos: ' + error.message);
          });
      };

      vm.bancoChequeEscolhido = function () {
        if (vm.registro.bancoCheque) {


        }
      };


      vm.tipoDocumentoEscolhido = function () {
        AuthService.setTipoDocumentoDescricao(vm.registro.tipoDocumento.descricao);


      }

      vm.consultarTipoDocumento = function () {
        vm.consultaTipoDocumentoPromise = $http.get(APP_API_FRND + "/invoice/tituloTipoDocumento/pesquisar")
          .then(function (response) {
            vm.tiposDocumento = response.data;

            if (vm.tiposDocumento.length > 0) {
              if (vm.titulos.length > 0) {
                var viewId = vm.titulos[vm.titulos.length - 1].tipoDocumento.viewId;

                for (var i = 0; i < vm.tiposDocumento.length; i++) {
                  if (vm.tiposDocumento[i].viewId == viewId) {
                    vm.registro.tipoDocumento = vm.tiposDocumento[i];
                  }
                }
              }
              else {
                vm.registro.tipoDocumento = vm.tiposDocumento[0];
              }
              AuthService.setTipoDocumentoDescricao(vm.registro.tipoDocumento.descricao);
            }
          });
      }

      vm.salvar = function () {
        if (!vm.isUpdate) {
          // Numero
          if (vm.registro.numero == null || vm.registro.numero == '') {
            toastr.error('Favor informar o número do Título.', 'Alerta');
            return;
          }

          // Verificar Numero
          /*
          for (var i=0;i<vm.titulos.length;i++)
          {
            if (vm.registro.numero == vm.titulos[i].numero)
            {
              toastr.error('Número do Título já cadastrado.', 'Alerta');
              return;
            }
          }
          */

          if (vm.registro.dataVencimento < new Date(new Date().setHours(0))) {
            toastr.error('Data de vencimento deve ser maior que a data atual.', 'Alerta');
            return;
          }

          // Cedente
          /*
          if (vm.registro.cedente == null)
          {
            toastr.error('Favor selecionar o Cedente.', 'Alerta');
            return;
          }
          */

          // Sacado
          if (vm.registro.sacado == null) {
            toastr.error('Favor selecionar o Sacado.', 'Alerta');
            return;
          }

          // Sacaco - Endereco
          if (
            (vm.registro.sacado.enderecoCep == null ||
              vm.registro.sacado.enderecoCep.trim() == '' ||
              vm.registro.sacado.enderecoLogradouro == null ||
              vm.registro.sacado.enderecoLogradouro.trim() == '' ||
              vm.registro.sacado.enderecoCidade == null ||
              vm.registro.sacado.enderecoCidade.trim() == '' ||
              vm.registro.sacado.enderecoUf == null ||
              vm.registro.sacado.enderecoUf.trim() == '') && vm.registro.tipoDocumento.descricao != 'Cheque'
          ) {
            toastr.error('Sacado selecionado não possui endereço e Documento não é um Cheque.', 'Alerta');
            return;
          }

          // Valor
          if (vm.registro.valor == null || vm.registro.valor == '') {
            toastr.error('Favor informar o Valor.', 'Alerta');
            return;
          }

          // Verificar o tipo de documento
          if (vm.registro.tipoDocumento == null) {
            toastr.error('Favor informar o Tipo do Documento.', 'Alerta');
            return;
          }

          // Verificar se e nota fiscal
          if (vm.registro.tipoDocumento.descricao == 'Duplicata') {
            if (vm.registro.notaFiscalNumero == null || vm.registro.notaFiscalNumero == '') {
              toastr.error('Favor informar o Número da Nota Fiscal.', 'Alerta');
              return;
            }
            // Verificar se notaFiscalNumero é um número
            if (!/^\d+$/.test(vm.registro.notaFiscalNumero)) {
              toastr.error('Favor informar um Número da Nota Fiscal válido.', 'Alerta');
              return;
            }
          }
          // Verificar se Banco Cheque foi escolhido
          if (vm.registro.tipoDocumento.descricao == 'Cheque') {
            if (vm.registro.bancoCheque == null || vm.registro.bancoCheque == '') {
              toastr.error('Favor informar o Banco do Cheque.', 'Alerta');
              return;
            }
          }
          // Verificar se Chave NFe é maior que 44 caracteres
          if (vm.registro.notaFiscalChave && vm.registro.notaFiscalChave.length > 44) {
            toastr.error('A chave NFe não pode ter mais de 44 caracteres.', 'Alerta');
            return;
          }


          try {
            vm.registro.valor = parseFloat(vm.registro.valor.toString().replaceAll('R$ ', '0').replaceAll('.', '').replaceAll(',', '.'));
          }
          catch (erro) {
            toastr.error('Favor informar corretamente o Valor.', 'Alerta');
            return;
          }

          // Valor
          if (vm.registro.valor <= 0) {
            toastr.error('Favor informar o Valor.', 'Alerta');
            return;
          }


          // GUID
          vm.registro.viewId = uuidv4();

          // Cadastro
          vm.titulos.push(vm.registro);

          vm.fechar();
        }

        /*
        vm.incluirPromise = $http.post(APP_API_FRND + "/fornecedor/adicionarempresa", vm.empresa).success(function(response){        
          
          vm.empresa.viewId = response;
  
          toastr.info('Registro cadastrado com sucesso.', 'Alerta');
          vm.fornecedor.empresas.push(vm.empresa);
          vm.fechar();
          return response;
        }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
        });
        */
      }

      function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
          var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
          return v.toString(16);
        });
      }

      /*
      vm.atualizar = function()
      {
        vm.incluirPromise = $http.post(APP_API_FRND + "/fornecedor/atualizarempresa", vm.empresa).success(function(response){        
          
          vm.empresa.viewId = response;
  
          toastr.info('Registro atualizado com sucesso.', 'Alerta');
          vm.fornecedor.empresas.splice(indice, 1);
          vm.fornecedor.empresas.push(vm.empresa);
          vm.fechar();
  
          return response;
        }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
        });
      }
      */

      vm.selecionarCedenteModal = function () {
        if (vm.editCedente) {
          var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/cedente/selecionar/index.html',
            controller: 'CedenteSelecionarController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
          }).result.then(function (data) {
            vm.registro.cedente = null;
            if (data != null) {
              vm.registro.cedente = data;
            }
          });
        }
      }

      vm.selecionarSacadoModal = function () {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/cadastro/sacado/selecionar/index.html',
          controller: 'SacadoSelecionarController',
          controllerAs: 'controller',
          windowClass: 'inmodal',
          size: 'lg',
        }).result.then(function (data) {
          vm.registro.sacado = null;
          if (data != null) {
            vm.registro.sacado = data;
          }
        });
      }

      vm.fechar = function () {
        $uibModalInstance.close();
      }

      vm.init();

    }]);

'use strict';

angular.module('inspinia')
  .controller('RecebiveisImportacaoController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_API_FRND', 'AuthService',
      function($scope, $state, toastr, $uibModal, $http, APP_API_FRND, AuthService)
  {
    var vm = this;
    
    vm.selectedTempFile = [];
    vm.filesSelected = [];
    vm.nfe = [];
    vm.duplicatas = [];

    vm.init = function()
    {
        vm.horarioLimite = AuthService.getHorarioLimite();

        //alert('ok');
    }
    
    vm.validarHorarioLimite = function() 
    {
        // Verificar a hora atual
        var currentTime = new Date();
        var currentHours = currentTime.getHours();
        var currentMinutes = currentTime.getMinutes();

        var horarioEmpresa = parseFloat(vm.horarioLimite.replace(":", "."));
        var currentHourMinute = parseFloat(currentHours + '.' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes));
     
            
        if ( currentHourMinute > horarioEmpresa ) {
            toastr.error('Horário inválido para envio. Horário permitido até às ' + vm.horarioLimite + 'h', 'Horário Determinado');
            return false;
        }
        return true;

    }

    vm.validarEPrevenir = function(event) {
        if (!vm.validarHorarioLimite()) {
            event.preventDefault(); // Impede o comportamento padrão de abrir o file picker
            return false;
        }
    };      

    vm.adicionarItem = function()
    {
        var nfe = {};
        nfe.Id = vm.fileId++;
        nfe.Nome = vm.selectedTempFile[0].name;
        
        //readAsDataURL        

        var reader = new FileReader();
        reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {

            vm.validarPromise = $http.post(APP_API_FRND + "/invoice/nfe/validar", { file : evt.target.result })
                .then(function(response){
                    var result = response.data;
                    if (result && result.length > 0) {
                        var nfeAtual = result[0].notaFiscal;
                        nfeAtual.TextoXML = nfe.XMLText;
                        var existeNfe = vm.nfe.filter(function(item) { return item.chaveNfe === nfeAtual.chaveNfe; });
                        if (existeNfe.length === 0) {
                            if (vm.nfe.length == 0) vm.nfeInicial = nfeAtual;
                            else if (nfeAtual.cedente.cnpj != vm.emitente.cnpj) { alert('As notas devem pertencer ao mesmo cedente/emitente.'); return; }
                            vm.nfe = vm.nfe.concat(nfeAtual);
                            vm.emitente = nfeAtual.cedente;
                            vm.duplicatas = vm.duplicatas.concat(result);
                        } else {
                            alert('Nota Fiscal já enviada.');
                        }
                    } else {
                        // Nenhum título retornado -> mensagem customizada
                        toastr.error('Nota inválida para importação por falta de informações sobre o Título no XML.', 'Erro de validação');
                    }
                })
                .catch(function(err){
                    var msg = (err && err.data) ? err.data : 'Erro inesperado na validação.';
                    toastr.error(msg, 'Erro no processamento');
                });
        };

        vm.selectedTempFile = [];
        angular.element("input[type='file']").val(null);

        /*
        var reader = new FileReader();
        reader.readAsText(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {
            //alert(evt.target.result);
            //vm.filesSelected.push(evt.target.result);
            nfe.TextoXML = evt.target.result;

            vm.validarPromise = NfeService.validar(nfe.TextoXML);

            vm.validarPromise.then(function(result) {  
                if (result.data.status)
                {
                    var nfeAtual = result.data.data;
                    nfeAtual.TextoXML = nfe.TextoXML; 

                    //var existeNfe = vm.nfe.find(x => x.chaveNfe === nfeAtual.chaveNfe);
                    var existeNfe = vm.nfe.filter(function(item) {
                        return item.chaveNfe === nfeAtual.chaveNfe;
                    });

                    if (existeNfe == 0)
                    {
                        if (vm.nfe.length == 0)
                        {
                            vm.nfeInicial = nfeAtual;
                        }

                        vm.nfe = vm.nfe.concat(nfeAtual);
                        vm.emitente = nfeAtual.emitente;
                        vm.duplicatas = vm.duplicatas.concat(nfeAtual.duplicatas); 
                    }
                    else
                    {
                        alert('Nota Fiscal já enviada.');
                    }
                }
                else
                {
                    toastr.error(result.data.text, 'Nfe');
                }
            });
        }
        vm.selectedTempFile = [];
        angular.element("input[type='file']").val(null);
        */
    }

    vm.concluir = function()
    {
        if (vm.duplicatas.length == null || vm.duplicatas.length == 0)
        {
            alert('É necessário informar as duplicatas.');
            return;
        }

        vm.concluirPromise = $http.post(APP_API_FRND + "/invoice/titulo/registrar", vm.duplicatas).success(function(response){            
            toastr.info('Títulos válidos enviados para o estoque.', 'Alerta');
            vm.nfe = [];
            vm.duplicatas = [];
            vm.emitente = null;
            //$state.go('index.home');
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });

        /*
        if (vm.duplicatas.length == null || vm.duplicatas.length == 0)
        {
            alert('É necessário informar as duplicatas.');
            return;
        }

        var antecipar = 
        {
            notasFiscais : vm.nfe,
            titulos : vm.duplicatas
        };

        vm.concluirPromise = AntecipacaoService.post(antecipar);

        vm.concluirPromise.then(function(result) {  
            if (result.data.status)
            {
                toastr.info('Antecipação cadastrada com sucesso!', 'Antecipação');
                $state.go('index.pesquisar_antecipacao');
            }
            else
            {
                toastr.error(result.data.exception, 'Falha');
                //alert('Ocorreu um erro na solicitação.');
            }
        });
        */
    }

    vm.getTotalDuplicatas = function(){
        var total = 0;
        for(var i = 0; i < vm.duplicatas.length; i++){
            var duplicata = vm.duplicatas[i];
            total += duplicata.valor;
        }
        return total;
    }

    vm.getTotalDuplicatasInvalidas = function(){
        var total = 0;
        for(var i = 0; i < vm.duplicatas.length; i++){
            var duplicata = vm.duplicatas[i];
            if (duplicata.situacao == 3)
            {
                total++;
            }  
        }
        return total;
    }    

    vm.openIncluirDuplicata = function()
    {
        /*
        var modalInstance = $uibModal.open({
            templateUrl: 'app/antecipacao/modal/inserir-duplicata.html',
            controller: 'AntecipacaoInserirDuplicataController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
               nfes: function () {
                 return vm.nfe;
               }
             }
         });

         modalInstance.result.then(function(data) {
            if (data.viewId != null && data.numeroTitulo != null && data.numeroTitulo != '')
            {
                vm.duplicatas.push(data);
            }
        })
        */
    }

    vm.removerNfe = function(nfeParam)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var i = 0; i < vm.nfe.length; i++)
            {
                if (vm.nfe[i].viewId == nfeParam.viewId)
                {
                    vm.nfe.splice(i, 1);
                    break;
                }
            }

            var tamanho = vm.duplicatas.length;

            for (var j = 0; j < tamanho; j++)
            {
                if (vm.duplicatas[j] != null && vm.duplicatas[j].notaFiscal.viewId == nfeParam.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                    j = 0;
                }
            }

            if (vm.duplicatas.length > 0 && vm.duplicatas[0] != null && vm.duplicatas[0].notaFiscal.viewId == nfeParam.viewId)
            {
                vm.duplicatas.splice(0, 1);
            }

            if (vm.duplicatas.length == 0)
            {
                vm.emitente = null;
            }
        }
    }

    vm.removerDuplicata = function(dup)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var j = 0; j < vm.duplicatas.length; j++)
            {
                if (vm.duplicatas[j].viewId == dup.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                }
            }
        }
    }

    vm.exibirMotivoTitulo = function(t)
    {
        alert(t.situacaoMotivo);
    }

    vm.init();

  }]);
angular
.module('inspinia').factory("FornecedorRecebiveisFaturaService", ['$http', 'APP_API_FRND', 
    function ($http, APP_API_FRND) {
    return {
        faturasDisponiveis: function () {
            return $http.get(APP_API_FRND + "/fatura/disponiveis")
            .then(function(response)
            { 
                return response.data;
            });
        },
    }
}]);
'use strict';

angular.module('inspinia')
    .controller('FaturasDisponiveisController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModal', '$http', 'APP_API_FRND', 'AuthService',
        function ($scope, $state, toastr, PagerService, $uibModal, $http, APP_API_FRND, AuthService) {
            var vm = this;
            vm.pager = {};
            vm.setPage = setPage;
            vm.total = {
                valorTotal: 0,
                quantidade: 0
            };
            vm.filtro = {};
            vm.registrosOriginal = [];
            vm.lastOrder = '';
            vm.orderSelected = '';
            vm.filtro = {
                status: 1
            };

            vm.init = function () {
                vm.horarioLimite = AuthService.getHorarioLimite();

                vm.listar();
            }

            vm.existemTitulosPendentesCorrecao = false;

            vm.validarHorarioLimite = function () {
                // Verificar a hora atual
                var currentTime = new Date();
                var currentHours = currentTime.getHours();
                var currentMinutes = currentTime.getMinutes();

                var horarioEmpresa = parseFloat(vm.horarioLimite.replace(":", "."));
                var currentHourMinute = parseFloat(currentHours + '.' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes));


                if (currentHourMinute > horarioEmpresa) {
                    toastr.error('Horário inválido para envio. Horário permitido até às ' + vm.horarioLimite + 'h', 'Horário Determinado');
                    return false;
                }
                return true;

            }




            vm.validarEPrevenir = function (event) {
                if (!vm.validarHorarioLimite()) {
                    event.preventDefault(); // Impede o comportamento padrão de abrir o file picker
                    return false;
                }
                else {
                    vm.anteciparRegistros()
                }
            };



            vm.filtrarPesquisaStatus = function () {
                vm.listar();
            }

            vm.listar = function () {
                vm.registros = null;
                vm.items = null;

                vm.listarPromise = $http.get(APP_API_FRND + "/invoice/titulo/disponiveis/" + vm.filtro.status);

                /*
                .then(function(response)
                { 
                    return response.data;
                });
                */

                vm.listarPromise.then(function (result) {
                    vm.registrosOriginal = result.data;
                    console.log('DEBUG: Dados recebidos:', result.data);
                    if (result.data && result.data.length > 0) {
                        console.log('DEBUG: Exemplo StatusCartaCorrecao:', result.data[0].statusCartaCorrecao);
                    }
                    vm.registros = result.data;
                    vm.calcularTotal();
                    vm.filtrarPesquisa();
                    vm.atualizarStatusCartaCorrecao();
                });
            }

            vm.filtrarPesquisa = function () {
                vm.registros = [];

                for (var i = 0; i < vm.registrosOriginal.length; i++) {
                    var incluir = true;

                    if (vm.filtro.nfe != null && vm.filtro.nfe != '') {
                        if (!vm.registrosOriginal[i].numero.includes(vm.filtro.nfe)) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.titulo != null && vm.filtro.titulo != '') {
                        if (!vm.registrosOriginal[i].titulo.includes(vm.filtro.titulo)) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.sacado != null && vm.filtro.sacado != '') {
                        if (!vm.registrosOriginal[i].sacado.toUpperCase().includes(vm.filtro.sacado.toUpperCase())) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '') {
                        if (vm.filtro.vencimentoDe > new Date(vm.registrosOriginal[i].dataVencimentoDate)) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.vencimentoAte != null && vm.filtro.vencimentoAte != '') {
                        if (vm.filtro.vencimentoAte < new Date(vm.registrosOriginal[i].dataVencimentoDate)) {
                            incluir = false;
                        }
                    }
                    if (vm.filtro.dataCadastro != null && vm.filtro.dataCadastro != '') {


                        // Converter as datas para o formato YYYY-MM-DD
                        var filtroData = new Date(vm.filtro.dataCadastro).toISOString().split('T')[0];
                        var registroData = new Date(vm.registrosOriginal[i].dataCadastro).toISOString().split('T')[0];
                        console.log("filtro:", filtroData, registroData);

                        if (filtroData != registroData) {
                            incluir = false;
                        }
                    }
                    if (vm.filtro.valorDe != null && vm.filtro.valorDe != '') {
                        if (vm.filtro.valorDe > vm.registrosOriginal[i].valor) {
                            incluir = false;
                        }
                    }

                    if (vm.filtro.valorAte != null && vm.filtro.valorAte != '') {
                        if (vm.filtro.valorAte < vm.registrosOriginal[i].valor) {
                            incluir = false;
                        }
                    }

                    /*
                    if (vm.filtro.status != null && vm.filtro.status != '')
                    {
                        if (vm.filtro.status != vm.registrosOriginal[i].status)
                        {
                            incluir = false;
                        }
                    }
                    */

                    if (incluir) {
                        vm.registros.push(vm.registrosOriginal[i]);
                    }
                }

                vm.desmarcarTodos();
                vm.pager.totalPages = 1;
                vm.setPage(1);
                vm.calcularTotal();
                vm.atualizarStatusCartaCorrecao();
            }

            vm.atualizarStatusCartaCorrecao = function () {
                vm.existemTitulosPendentesCorrecao = false;
                for (var i = 0; i < vm.registros.length; i++) {
                    var p = vm.registros[i];
                    if (p.isPossuiCartaoCorrecao && p.checarCartaCorrecao && (!p.statusCartaCorrecao || p.statusCartaCorrecao == 0 || p.statusCartaCorrecao == '0')) {
                        vm.existemTitulosPendentesCorrecao = true;
                        break;
                    }
                }
            }

            vm.anteciparRegistros = function () {
                if (vm.registros != null) {
                    var selecionados = [];
                    for (var i = 0; i < vm.registros.length; i++) {
                        if (vm.registros[i].selecionadoAntecipar) {
                            selecionados.push(vm.registros[i]);
                        }
                    }

                    if (selecionados.length == 0) {
                        alert('Selecione pelo menos um registro.');
                        return;
                    }

                    var modalInstance = $uibModal.open({
                        templateUrl: 'app/fornecedor/recebiveis/faturas/modal/antecipar.html',
                        controller: 'FaturasDisponiveisAnteciparController',
                        controllerAs: 'controller',
                        windowClass: 'inmodal',
                        size: 'lg',
                        resolve: {
                            registros: function () {
                                return selecionados;
                            },
                        }
                    }).closed.then(function () {
                        vm.listar();
                    });
                }
            }

            vm.marcarTodos = function () {
                for (var i = 0; i < vm.registros.length; i++) {
                    if (vm.filtro.status == vm.registros[i].status) {
                        if (vm.registros[i].status == 1) {
                            vm.registros[i].selecionadoAntecipar = true;
                        }
                    }
                }
                vm.calcularTotal();
            }

            vm.desmarcarTodos = function () {
                for (var i = 0; i < vm.registros.length; i++) {
                    vm.registros[i].selecionadoAntecipar = false;
                }
                vm.calcularTotal();
            }

            vm.calcularTotal = function () {
                var total = 0;
                var quantidade = 0;

                for (var i = 0; i < vm.registros.length; i++) {
                    if (vm.registros[i].selecionadoAntecipar) {
                        total += vm.registros[i].valor;
                        quantidade++;
                    }
                }

                vm.total.valorTotal = total;
                vm.total.quantidade = quantidade;
            }

            vm.consultarTitulo = function (p) {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/fornecedor/recebiveis/faturas/modal/detalhar_titulo/index.html',
                    controller: 'ConsultarDetalhesTituloController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                    resolve: {
                        titulo: function () {
                            return p;
                        },
                    }
                }).result.then(function (res) {
                    if (res == 'excluido') {
                        vm.listar();
                    }
                });
            }


            function setPage(page) {
                if (page < 1 || page > vm.pager.totalPages) {
                    return;
                }
                vm.pager = PagerService.GetPager(vm.registros.length, page);
                vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
            }

            vm.showhide = function (icon, box) {
                var icon = angular.element(document.getElementById(icon));
                icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
                var elm = angular.element(document.getElementById(box));
                elm.slideToggle(200);
            };

            vm.init();

        }]);
'use strict';

angular.module('inspinia')
  .controller('MinhasAntecipacoesController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_API_FRND',
      function($scope, $state, toastr, $uibModal, $http, APP_API_FRND)
  {
    var vm = this;
    vm.filtro = {};
    vm.registrosOriginal = [];
    vm.lastOrder = '';
    vm.orderSelected = '';

    vm.init = function()
    {
        vm.listar();
    }

    vm.listar = function()
    {
        vm.registros = null;
        
        return $http.get(APP_API_FRND + "/invoice/antecipacao/disponiveis")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }

    vm.aprovarProposta = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/fornecedor/antecipacao/minhas_antecipacoes/modal/aprovar_proposta.html',
            controller: 'AprovarPropostaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            vm.listar();
        });
    }

    vm.verDetalhes = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/fornecedor/antecipacao/minhas_antecipacoes/modal/consultar_titulos.html',
            controller: 'ConsultarTitulosPropostaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            //vm.listar();
        });
    }

    vm.verProposta = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/fornecedor/antecipacao/minhas_antecipacoes/modal/consultar_retorno.html',
            controller: 'ConsultarRetornoPropostaController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            //vm.listar();
        });
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        var dataVencimentoAte = vm.filtro.vencimentoAte;

        if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
        {
            dataVencimentoAte = addDays(vm.filtro.vencimentoAte, 1);
        }

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.fornecedor != null && vm.filtro.fornecedor != '')
            {
                if (!vm.registrosOriginal[i].fornecedor.toUpperCase().includes(vm.filtro.fornecedor.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.numeroAntecipacao != null && vm.filtro.numeroAntecipacao != '')
            {
                if (vm.registrosOriginal[i].numero != vm.filtro.numeroAntecipacao)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoDe != null && vm.filtro.vencimentoDe != '')
            {
                if (vm.filtro.vencimentoDe > new Date(vm.registrosOriginal[i].data))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.vencimentoAte != null && vm.filtro.vencimentoAte != '')
            {
                if (dataVencimentoAte < new Date(vm.registrosOriginal[i].data))
                {
                    incluir = false;
                }
            }
            
            if (vm.filtro.valorDe != null && vm.filtro.valorDe != '')
            {
                if (vm.filtro.valorDe > vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.valorAte != null && vm.filtro.valorAte != '')
            {
                if (vm.filtro.valorAte < vm.registrosOriginal[i].valor)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'cliente':
                    vm.registros.reverse(function(a, b){
                        if(a.ic.nome < b.ic.nome) { return -1; }
                        if(a.ic.nome > b.ic.nome) { return 1; }
                        return 0;
                    })
                    break;
                case 'solicitacao':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
                case 'valor':
                    vm.registros.reverse(function(a, b){
                        if(a.valor < b.valor) { return -1; }
                        if(a.valor > b.valor) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'solicitacao':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.status < b.status) { return -1; }
                        if(a.status > b.status) { return 1; }
                        return 0;
                    })
                    break;
                case 'valor':
                    vm.registros.sort(function(a, b){
                        if(a.valor < b.valor) { return -1; }
                        if(a.valor > b.valor) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.init();

  }]);
'use strict';

angular.module('inspinia')
  .controller('EmailCarteiraDinamicaController', ['$scope', '$state', 'toastr', '$http','APP_API_FRND', 'PagerService', '$uibModal', 'AuthService', 'modalService',
      function($scope, $state, toastr, $http, APP_API_FRND, PagerService, $uibModal, AuthService, modalService)
{
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        cedente: null,
        sacado: null,
        operacaoInicial: null,
        operacaoFinal: null,
        vencimentoInicial: null,
        vencimentoFinal: null,
        tipoSacado: 0,
    };
    vm.pager = {};
    vm.setPage = setPage;
    vm.cedente = null;
    vm.email = '';
    vm.cedenteViewId = '';
    vm.selecionadoTodos = false;
    vm.opcaoAtualizarBoleto = true;
    vm.empresaId = AuthService.getEmpresaMainId();
    vm.userEmail = AuthService.getUserEmail();

    // Adicione a função redirectToURL ao vm
    vm.redirectToURL = function() {
        var url = 'https://venturenegocios.com.br/wp-content/uploads/2024/12/IF-GERAÇÃO-DE-BOLETOS.pdf';
        modalService.openModal(url);
    };

    vm.selecionarTodos = function() {
        var selecionado = vm.selecionadoTodos;
        for (var i=0; i<vm.registros.length;i++) {
            vm.registros[i].selecionado = selecionado;
        }
    }

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.registros.length, page);
        vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
        if (vm.empresaId == '836c9e79-3d37-4a9c-a618-9925f1136e3d') {
            // Desabilitar atualizacao de boleto
            vm.opcaoAtualizarBoleto = false;
        }
        //vm.pesquisar(); 
        vm.email = vm.userEmail;
    }

    vm.selecionarSacadoModal = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/sacado/selecionar/index.html',
        controller: 'SacadoSelecionarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            vm.registrosOriginal = null;
            vm.registros = null;
            vm.filtro.sacado = null;
            vm.filtro.sacadoViewId = null;
            if (data != null)
            {
                vm.filtro.sacado = data;
                vm.filtro.sacadoViewId = data.viewId;
            }      
        });
    }

    vm.pesquisar = function()
    {
        var dataOperacaoInformado = vm.filtro.operacaoInicial != null && vm.filtro.operacaoFinal != null;
        var dataVencimentoInformado = vm.filtro.vencimentoInicial != null && vm.filtro.vencimentoFinal != null;

        if (dataOperacaoInformado == false && dataVencimentoInformado == false)
        {
            toastr.error('Selecione um período.', 'Alerta');
            return;
        }

        // sacados
        /*
        if ((vm.filtro.sacado == null) && (vm.filtro.grupoSacado == null || vm.filtro.grupoSacado == '')) {
            toastr.error('Selecione um sacado.', 'Alerta');
            return;
        }
        */

        vm.registrosOriginal = null;
        vm.registros = null;

        vm.consultarPromise = $http.post(APP_API_FRND + "/EmailCarteiraDinamica/listar", vm.filtro).success(function(response){
            vm.registrosOriginal = response.response;
            vm.registros = response.response;
            //vm.email = response.email;
            //vm.cedenteViewId = vm.filtro.cedente.viewId;

            if (vm.registros == null || vm.registros.length == 0)
            {
                toastr.warning('Não foram encontrados lançamentos.', 'Alerta');
            }
            else
            {
                for (var i=0;i<vm.registros.length;i++)
                {
                    vm.registros[i].selecionado = true;
                }
            }

            vm.filtrarPesquisa();

            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.baixarPdf = function() {
        if (!confirm('Deseja baixar os registros selecionados?')) {
            return;
        }

        var lancamentos = [];

        for (var i=0;i<vm.registros.length;i++)
        {
            if (vm.registros[i].selecionado)
            {
                lancamentos.push(vm.registros[i]);
            }
        }

        if (lancamentos.length == 0) {
            toastr.error('Selecione um lançamento.', 'Alerta');
            return;
        }

        /*
        if (lancamentos.length > 10) {
            toastr.error('Não é permitido o envio acima de 10 boletos.', 'Alerta');
            return;
        }
        */

        for (var i=0;i<lancamentos.length;i++) {
            vm.acaoTabelaPromise = $http.post(APP_API_FRND + "/EmailCarteiraDinamica/verboleto", lancamentos[i]).success(function(response, teste, teste1, req){
                vm.download(response, 'application/pdf', 'boleto_'+ req.data.numeroDocumento + '.pdf');
                //vm.download(response, 'application/pdf', 'boleto.pdf');
                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
        
        vm.desmarcarTodos();
        vm.selecionadoTodos = false;
    }

    vm.enviarEmail = function() 
    {
        if (!confirm('Deseja enviar o e-mail para os registros selecionados?')) {
            return;
        }

        var lancamentos = [];
        var sacadoCnpj = '';
        var sacadoGrupo = '';

        if (vm.filtro.tipoSacado == 0) {
            if (vm.filtro.sacado != null) {
                sacadoCnpj = vm.filtro.cnpj;
            }
        }
        else {
            if (vm.filtro.grupoSacado != null) {
                sacadoGrupo = vm.filtro.grupoSacado;
            }
        }

        for (var i=0;i<vm.registros.length;i++)
        {
            if (vm.registros[i].selecionado)
            {
                lancamentos.push(vm.registros[i]);
            }
        }

        if (lancamentos.length == 0) {
            toastr.error('Selecione um lançamento.', 'Alerta');
            return;
        }
        if (lancamentos.length > 10) {
            toastr.error('Não é permitido o envio acima de 10 boletos.', 'Alerta');
            return;
        }

        var request = {
            email: vm.email,
            lancamentos: lancamentos,
            cedenteViewId: vm.cedenteViewId,
            sacadoViewId: vm.sacadoViewId,
            sacadoCnpj: sacadoCnpj,
            sacadoGrupo: sacadoGrupo,
        };

        vm.consultarPromise = $http.post(APP_API_FRND + "/EmailCarteiraDinamica/enviarEmailAgrupamento", request).success(function(response){
            
            //vm.items = null;
            //vm.registrosOriginal = null;
            //vm.registros = null;

            toastr.info('E-mail enviado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.cedente_consultar', {obj: fornecedor.viewId});
    }
    
    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        /*
        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }
        */

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;
            /*
            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }
            */

            if (vm.filtro.fantasia != null && vm.filtro.fantasia != '')
            {
                if (!vm.registrosOriginal[i].nomeFantasia.toUpperCase().includes(vm.filtro.fantasia.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }
            
            /*
            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].status)
                {
                    incluir = false;
                }
            }
            */

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }

        vm.desmarcarTodos();
        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'lancamento':
                    vm.registros.reverse(function(a, b){
                        if(a.lancamento < b.lancamento) { return -1; }
                        if(a.lancamento > b.lancamento) { return 1; }
                        return 0;
                    })
                    break;codBanco
                case 'banco':
                    vm.registros.reverse(function(a, b){
                        if(a.codBanco < b.codBanco) { return -1; }
                        if(a.codBanco > b.codBanco) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.reverse(function(a, b){
                        if(a.nomeSacado < b.nomeSacado) { return -1; }
                        if(a.nomeSacado > b.nomeSacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'diasvencido':
                    vm.registros.reverse(function(a, b){
                        if(a.diasVencido < b.diasVencido) { return -1; }
                        if(a.diasVencido > b.diasVencido) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'vencimento':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataVencimento);
                        var dateB = new Date(b.dataVencimento);
                        return dateA - dateB;
                    });
                    break;
                case 'valortitulo':
                    vm.registros.reverse(function(a, b){
                        if(a.valorTitulo < b.valorTitulo) { return -1; }
                        if(a.valorTitulo > b.valorTitulo) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'lancamento':
                    vm.registros.sort(function(a, b){
                        if(a.lancamento < b.lancamento) { return -1; }
                        if(a.lancamento > b.lancamento) { return 1; }
                        return 0;
                    })
                    break;
                case 'banco':
                    vm.registros.sort(function(a, b){
                        if(a.codBanco < b.codBanco) { return -1; }
                        if(a.codBanco > b.codBanco) { return 1; }
                        return 0;
                    })
                    break;
                case 'sacado':
                    vm.registros.sort(function(a, b){
                        if(a.nomeSacado < b.nomeSacado) { return -1; }
                        if(a.nomeSacado > b.nomeSacado) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'diasvencido':
                    vm.registros.sort(function(a, b){
                        if(a.diasVencido < b.diasVencido) { return -1; }
                        if(a.diasVencido > b.diasVencido) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'vencimento':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataVencimento);
                        var dateB = new Date(b.dataVencimento);
                        return dateA - dateB;
                    });
                    break;
                case 'valortitulo':
                    vm.registros.sort(function(a, b){
                        if(a.valorTitulo < b.valorTitulo) { return -1; }
                        if(a.valorTitulo > b.valorTitulo) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }

        vm.pager.totalPages = 1;
        vm.setPage(1);
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    vm.marcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            if (vm.filtro.status == vm.registros[i].status)
            {
                vm.registros[i].selecionado = true;
            }
        }
    }

    vm.desmarcarTodos = function()
    {
        for (var i = 0; i < vm.registros.length; i++)
        {
            vm.registros[i].selecionado = false;
        }
    }

    vm.visualizarBoleto = function(item) {
        // verificar boleto vencido itau
        if (vm.opcaoAtualizarBoleto && item.codBanco == 341 && item.isVencido)
        {
            vm.verItauBoletoVencido(item);
        }
        else if (vm.opcaoAtualizarBoleto && item.isVencido) {
            vm.verBoletoVencido(item);
        }
        else {
            item.isGerarAtualizado = false;
            vm.acaoTabelaPromise = $http.post(APP_API_FRND + "/EmailCarteiraDinamica/verboleto", item).success(function(response){
            
                //vm.download(response, 'application/pdf', 'boleto.pdf');
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/email/carteira/modal/boleto/index.html',
                    controller: 'CarteiraModalBoletoController',
                    controllerAs: 'controller',
                    windowClass: 'inmodal',
                    size: 'lg',
                    resolve: {
                        item: function () {
                            return response;
                        },
                    }
                }).closed.then(function(){
                    //vm.listar();
                });

                return response;
            }).error(function(error){
                toastr.error(error, 'Alerta');
                return error;
            });
        }
    }

    vm.verBoletoVencido = function(antecipacao)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/email/carteira/dinamica/vencido/index.html',
            controller: 'BoletoVencidoGerarController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'md',
            resolve: {
                antecipacao: function () {
                    return antecipacao;
                },
            }
        }).closed.then(function(){
            //vm.listar();
        });
    }

    vm.verItauBoletoVencido = function(antecipacao)
    {
        vm.acaoTabelaPromise = $http.post(APP_API_FRND + "/emailCarteiraDinamica/itauboletovencidotoken", antecipacao)
        .then(function(response)
        { 
            var codigo = response.data;
            var modalInstance = $uibModal.open({
                templateUrl: 'app/email/carteira/dinamica/itau/boletovencido/index.html',
                controller: 'BoletoVencidoItauGerarController',
                controllerAs: 'controller',
                windowClass: 'inmodal',
                size: 'md',
                resolve: {
                    antecipacao: function () {
                        return antecipacao;
                    },
                    codigo: function () {
                        return codigo;
                    },
                }
            }).closed.then(function(){
                //vm.listar();
            });
        });
        
    }

    vm.download = function(dados, tipo, nome)
    {
      var file = vm.b64toBlob(dados, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoSelecionarController', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_API_FRND', '$compile', '$uibModal',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_API_FRND, $compile, $uibModal)
  {
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        codigo: '',
        nome: '',
        cnpj: ''
    }

    vm.indexPage = 1;

    $scope.pagination = {
        current: 1,
        perPage: 15,
        maxSize: 5,
        totalItems: 0,
    };

    vm.init = function()
    {
      vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.pesquisar = function(perPage, index, orderBy, filter)
    {
        vm.registros = null;

        var codigo = "0";
        var nome = "0";
        var cnpj = "0";

        if (vm.filtro == null)
        {
            vm.filtro = {
                codigo: '',
                nome: '',
                cnpj: '',
                index: index,
                page: perPage
            }
        }

        if (vm.filtro.codigo != null && vm.filtro.codigo != '')
        {
            codigo = vm.filtro.codigo;
        }
        if (vm.filtro.nome != null && vm.filtro.nome != '')
        {
            nome = vm.filtro.nome;
        }
        if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
        {
            cnpj = vm.filtro.cnpj;
        }

        vm.filtro.page = index;
        vm.filtro.perPage = perPage;
        
        // /sacado/pesquisarPage
        ///sacado/pesquisarPagePorCedente
        vm.pesquisarPromise = $http.post(APP_API_FRND + "/sacado/pesquisarPagePorCedente", vm.filtro).success(function(response){
            vm.registros = response.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = (response.pages * perPage);
        }).error(function(error){
            return error;
        });
    }

    $scope.onSearch = function() {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPerPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.filtrarPesquisa = function()
    {
      $scope.pagination.perPage,$scope.pagination.current = 1;
      
      vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.cadastrarSacado = function() {        
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/sacado/selecionar/novo/index.html',
        controller: 'SacadoSelecionarNovoController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            if (data != null)
            {
                vm.filtro = {
                    nome: data.razaoSocial
                };

                $scope.pagination.perPage,$scope.pagination.current = 1;
      
                vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
            }            
        });
    }

    vm.init();

    vm.getTotalPages = function() {
      return new Array(7);   
    }

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('AdminUsuarioPesquisarController', ['$scope', '$state', 'UsuarioService', 'toastr', 'PagerService',
      function($scope, $state, UsuarioService, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.usuarios.length, page);
      vm.items = vm.usuarios.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.pesquisar = function()
    {
        vm.registros = null;
        
        return $http.get(APP_API_FRND + "/invoice/antecipacao/disponiveis")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
            vm.filtrarPesquisa();
        });
    }

    vm.incluir = function()
    {
      $state.go('index.cadastrarusuario');
    }

    vm.visualizar = function(usuario)
    {
      $state.go('index.consultarusuario', {obj: usuario});
    }

    vm.alterar = function(usuario)
    {
      $state.go('index.alterarusuario', {obj: usuario});
    }    

    vm.pesquisar();

  }]);
'use strict';

angular.module('inspinia')
  .controller('SacadoSelecionarController2', ['$scope', '$state', 'toastr', 'PagerService', '$uibModalInstance', '$http', 'APP_API_FRND', '$compile',
      function($scope, $state, toastr, PagerService, $uibModalInstance, $http, APP_API_FRND, $compile)
  {
    var vm = this;
    vm.registros = null;
    vm.filtro = {
        codigo: '',
        nome: '',
        cnpj: ''
    }

    vm.indexPage = 1;

    $scope.pagination = {
        current: 1,
        perPage: 15,
        maxSize: 5,
        totalItems: 0,
    };

    vm.init = function()
    {
      vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.selecionar = function(registro)
    {
      $uibModalInstance.close(registro);
    }

    vm.pesquisar = function(perPage, index, orderBy, filter)
    {
        vm.registros = null;

        var codigo = "0";
        var nome = "0";
        var cnpj = "0";

        if (vm.filtro == null)
        {
            vm.filtro = {
                codigo: '',
                nome: '',
                cnpj: '',
                index: index,
                page: perPage
            }
        }

        if (vm.filtro.codigo != null && vm.filtro.codigo != '')
        {
            codigo = vm.filtro.codigo;
        }
        if (vm.filtro.nome != null && vm.filtro.nome != '')
        {
            nome = vm.filtro.nome;
        }
        if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
        {
            cnpj = vm.filtro.cnpj;
        }

        vm.filtro.page = index;
        vm.filtro.perPage = perPage;
        
        vm.pesquisarPromise = $http.post(APP_API_FRND + "/sacado/pesquisarPage", vm.filtro).success(function(response){
            vm.registros = response.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = (response.pages * perPage);
        }).error(function(error){
            return error;
        });
    }

    $scope.onSearch = function() {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPerPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.filtrarPesquisa = function()
    {
      $scope.pagination.perPage,$scope.pagination.current = 1;
      
      vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.selecionarSacadoModal = function()
    {    
        var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/sacado/selecionar/index.html',
        controller: 'SacadoSelecionarController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        size: 'lg',
        }).result.then(function(data){
            vm.registro.sacado = null;
            if (data != null)
            {
                vm.registro.sacado = data;
            }      
        });
    }

    vm.init();

    vm.getTotalPages = function() {
      return new Array(7);   
    }

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.registros.length, page);
      vm.items = vm.registros.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoConsultaController', ['$scope', '$state', 'toastr', '$http','APP_API_FRND', '$uibModal',
      function($scope, $state, toastr, $http, APP_API_FRND, $uibModal)
{
    var vm = this;
    vm.sacadoParam = $state.params.obj;

    vm.init = function()
    {
        if (vm.sacadoParam == null || vm.sacadoParam == '')
        {
            $state.go('index.cadastro_sacado_pesquisa');
        }
        else
        {
            vm.pesquisar();        
        }
    }

    vm.pesquisar = function()
    {
        return $http.get(APP_API_FRND + "/sacado/consultar/" + vm.sacadoParam.viewId)
        .then(function(response)
        { 
            vm.sacado = response.data;
            vm.listarUsuarios();
        });
    }

    vm.atualizar = function()
    {
        if (vm.sacado.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Alerta');
            return;
        }

        if (vm.sacado.cnpj.toString().length != 18 && vm.sacado.cnpj.toString().length != 14)
        {
            toastr.error('CNPJ inválido.', 'Alerta');
            return;
        }

        if (vm.sacado.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Alerta');
            return;
        }

        vm.atualizarPromise = $http.post(APP_API_FRND + "/sacado/alterar", vm.sacado).success(function(response){
            toastr.info('Sacado atualizado com sucesso.', 'Alerta');
            return response;
        }).error(function(error){
            return error;
        });
    }

    vm.init();

    vm.adicionarUsuario = function()
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/sacado/consulta/usuario/cadastro/index.html',
            controller: 'SacadoCadastrarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                sacado: function () {
                    return vm.sacadoParam;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }

    vm.editarUsuario = function(usuario)
    {
        var modalInstance = $uibModal.open({
            templateUrl: 'app/cadastro/sacado/consulta/usuario/consulta/index.html',
            controller: 'SacadoConsultarUsuarioController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
                sacado: function () {
                    return vm.sacadoParam;
                },
                usuario: function () {
                    return usuario;
                },
            }
        }).closed.then(function(){
            vm.listarUsuarios();
        });
    }
    
    vm.listarUsuarios = function()
    {
        return $http.get(APP_API_FRND + "/sacado/listarUsuarios/" + vm.sacado.viewId)
        .then(function(response)
        { 
            vm.usuarios = response.data;
        });
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('SacadoCadastroController', ['$scope', '$state', 'toastr', '$http','APP_API_FRND',
      function($scope, $state, toastr, $http, APP_API_FRND)
{
    var vm = this;
    vm.sacado = {
        endereco: {}
    };

    vm.init = function()
    {

    }

    vm.salvar = function()
    {
        if (vm.sacado.cnpj == '')
        {
            toastr.error('CNPJ é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.cnpj == null || (vm.sacado.cnpj.toString().length != 18 && vm.sacado.cnpj.toString().length != 14))
        {
            toastr.error('CPF/CNPJ de tamanho irregular', 'Cliente');
            return;
        }
        // Exemplo de uso na sua função
        if (vm.sacado.cnpj == null || !verificarCPFCNPJ(vm.sacado.cnpj)) 
        {
            toastr.error('CPF/CNPJ inválido.', 'Cliente');
            return;
        }

        if (vm.sacado.razaoSocial == null || vm.sacado.razaoSocial == '')
        {
            toastr.error('Razão Social é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.endereco.cep == null || vm.sacado.endereco.cep == '')
        {
            toastr.error('CEP é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.endereco.logradouro == null || vm.sacado.endereco.logradouro == '')
        {
            toastr.error('Logradouro é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.endereco.cidade == null || vm.sacado.endereco.cidade == '')
        {
            toastr.error('Cidade é obrigatório.', 'Cliente');
            return;
        }

        if (vm.sacado.endereco.uf == null || vm.sacado.endereco.uf == '')
        {
            toastr.error('Estado é obrigatório.', 'Cliente');
            return;
        }

        $http.post(APP_API_FRND + "/sacado/incluir", vm.sacado).success(function(response){
            toastr.info('Sacado cadastrado com sucesso.', 'Alerta');
            $state.go('index.cadastro_sacado_pesquisa');
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            return error;
        });

        /*
        vm.salvarPromise = CedenteService.cadastrar(vm.cedente);

        vm.salvarPromise.then(function(result) {  
            if (result.status)
            {
                toastr.info('Cedente cadastrada com sucesso!', 'Cedente');
                $state.go('index.pesquisar_cedente');
            }
            else
            {
                alert('Ocorreu um erro na solicitação.');
            }
        });
        */
    }

    vm.init();

    /*
    function validarCNPJ(s) {
        var cnpj = s.replace(/[^\d]+/g, '')
    
        // Valida a quantidade de caracteres
        if (cnpj.length !== 14)
            return false
    
        // Elimina inválidos com todos os caracteres iguais
        if (/^(\d)\1+$/.test(cnpj))
            return false
    
        // Cáculo de validação
        var t = cnpj.length - 2,
            d = cnpj.substring(t),
            d1 = parseInt(d.charAt(0)),
            d2 = parseInt(d.charAt(1)),
            calc = x => {
                var n = cnpj.substring(0, x),
                    y = x - 7,
                    s = 0,
                    r = 0
    
                    for (var i = x; i >= 1; i--) {
                        s += n.charAt(x - i) * y--;
                        if (y < 2)
                            y = 9
                    }
    
                    r = 11 - s % 11
                    return r > 9 ? 0 : r
            }
    
        return calc(t) === d1 && calc(t + 1) === d2
    }
    */

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    // Função para validar CPF
    function validarCPF(cpf) {
        cpf = cpf.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos
        if (cpf.length !== 11 || /^(\d)\1+$/.test(cpf)) {
            return false; // Verifica se o CPF tem 11 dígitos e não é uma sequência repetida
        }

        var soma = 0, resto;
        for (var i = 1; i <= 9; i++) {
            soma += parseInt(cpf.substring(i-1, i)) * (11 - i);
        }
        resto = (soma * 10) % 11;
        if ((resto === 10) || (resto === 11)) resto = 0;
        if (resto !== parseInt(cpf.substring(9, 10))) return false;

        soma = 0;
        for (var i = 1; i <= 10; i++) {
            soma += parseInt(cpf.substring(i-1, i)) * (12 - i);
        }
        resto = (soma * 10) % 11;
        if ((resto === 10) || (resto === 11)) resto = 0;
        if (resto !== parseInt(cpf.substring(10, 11))) return false;
        
        return true;
    }

    // Função para validar CNPJ
    function validarCNPJ(cnpj) {
        cnpj = cnpj.replace(/[^\d]+/g, ''); // Remove caracteres não numéricos
        if (cnpj.length !== 14) {
            return false; // Verifica se o CNPJ tem 14 dígitos
        }

        var tamanho = cnpj.length - 2;
        var numeros = cnpj.substring(0, tamanho);
        var digitos = cnpj.substring(tamanho);
        var soma = 0;
        var pos = tamanho - 7;
        for (var i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
        }
        var resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== parseInt(digitos.charAt(0))) {
            return false;
        }

        tamanho = tamanho + 1;
        numeros = cnpj.substring(0, tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (var i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2) pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado !== parseInt(digitos.charAt(1))) {
            return false;
        }
        
        return true;
    }

    // Função principal para verificar CPF/CNPJ
    function verificarCPFCNPJ(cnpjCpf) {
        cnpjCpf = cnpjCpf.toString();
        if (cnpjCpf.length === 14) {
            return validarCPF(cnpjCpf);
        } else if (cnpjCpf.length === 18) {
            return validarCNPJ(cnpjCpf);
        } else {
            return false;
        }
    }



}]);
'use strict';

angular.module('inspinia')
  .controller('RelatorioTesteController', ['$scope', '$state', 'toastr', '$http','APP_API_FRND', '$sce', 'AuthService',
      function($scope, $state, toastr, $http, APP_API_FRND, $sce, AuthService)
{
    var vm = this;
    vm.registros = null;
    vm.iFrameUrl = "";
    vm.relatorio = $state.params.report;
    vm.name = $state.params.name;

    vm.init = function()
    {
        vm.pesquisar();
        
        vm.pentahoCodigoCliente = AuthService.getPentahoCodigo();
        vm.codigoCedenteVmoney = AuthService.getCodigoVmoney();
        vm.pentahoLogo = AuthService.getPentahoLogo();
        vm.urlPentaho = AuthService.getUrlPentaho();
        
        if (vm.relatorio == '')
        {
            toastr.error('Relatório não encontrado.', 'Alerta');
        }

        if (vm.codigoCedenteVmoney == null || vm.codigoCedenteVmoney == '')
        {
            toastr.error('Código do cedente não cadastrado.', 'Alerta');
        }
        else
        {            
            if (vm.pentahoCodigoCliente == null || vm.pentahoCodigoCliente == '')
            {
                toastr.error('Código de Integração não cadastrado.', 'Alerta');
            }
            else
            {
                //vm.iFrameUrl = $sce.trustAsResourceUrl("https://homolog.moneynow.com.br/pentaho/api/repos/%3Apublic%3Aventure%3Ahomologacao%3A" + vm.relatorio + ".prpt/viewer?userid=padilha&password=12345&dbFilterSelector=" + vm.pentahoCodigoCliente + "&dbFilterCed=" + vm.codigoCedenteVmoney);
                if (vm.pentahoLogo != null && vm.pentahoLogo != '') {
                    //vm.iFrameUrl = $sce.trustAsResourceUrl("https://homolog.moneynow.com.br/pentaho/api/repos/%3Apublic%3Aventure%3Ahomologacao%3A" + vm.relatorio + "_" + vm.pentahoCodigoCliente + ".prpt/viewer?userid=padilha&password=12345&dbFilterSelector=" + vm.pentahoCodigoCliente + "&dbFilterCed=" + vm.codigoCedenteVmoney + "&logo=" + vm.pentahoLogo);
                    vm.iFrameUrl = $sce.trustAsResourceUrl(vm.urlPentaho + "repos/%3Apublic%3Aventure%3Ahomologacao%3A" + vm.relatorio + "_" + vm.pentahoCodigoCliente + ".prpt/viewer?userid=padilha&password=12345&dbFilterSelector=" + vm.pentahoCodigoCliente + "&dbFilterCed=" + vm.codigoCedenteVmoney + "&logo=" + vm.pentahoLogo);
                } else {
                    vm.iFrameUrl = $sce.trustAsResourceUrl(vm.urlPentaho + "repos/%3Apublic%3Aventure%3Ahomologacao%3A" + vm.relatorio + "_" + vm.pentahoCodigoCliente + ".prpt/viewer?userid=padilha&password=12345&dbFilterSelector=" + vm.pentahoCodigoCliente + "&dbFilterCed=" + vm.codigoCedenteVmoney);
                    //vm.iFrameUrl = $sce.trustAsResourceUrl("https://homolog.moneynow.com.br/pentaho/api/repos/%3Apublic%3Aventure%3Ahomologacao%3A" + vm.relatorio + "_" + vm.pentahoCodigoCliente + ".prpt/viewer?userid=padilha&password=12345&dbFilterSelector=" + vm.pentahoCodigoCliente + "&dbFilterCed=" + vm.codigoCedenteVmoney);
                }
            }        
        }
    }

    vm.pesquisar = function()
    {
        vm.registros = null;
        
        return $http.get(APP_API_FRND + "/antecipacao/minhasantecipacoes")
        .then(function(response)
        { 
            vm.registrosOriginal = response.data;
            vm.registros = response.data;
        });
    }

    vm.consultar = function(fornecedor)
    {
        $state.go('index.analisar_cadastro_fornecedor', {obj: fornecedor});
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_fornecedor');
    }

    vm.filtrarPesquisa = function()
    {
        vm.registros = [];

        var dataCadastroAte = vm.filtro.dataCadastroAte;

        if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
        {
            dataCadastroAte = addDays(vm.filtro.dataCadastroAte, 1);
        }

        for (var i = 0; i < vm.registrosOriginal.length; i++)
        {
            var incluir = true;

            if (vm.filtro.dataCadastroDe != null && vm.filtro.dataCadastroDe != '')
            {
                if (vm.filtro.dataCadastroDe > new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.dataCadastroAte != null && vm.filtro.dataCadastroAte != '')
            {
                if (dataCadastroAte < new Date(vm.registrosOriginal[i].dataCadastro))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.nome != null && vm.filtro.nome != '')
            {
                if (!vm.registrosOriginal[i].razaoSocial.toUpperCase().includes(vm.filtro.nome.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.codigo != null && vm.filtro.codigo != '')
            {
                if (vm.registrosOriginal[i].id != vm.filtro.codigo)
                {
                    incluir = false;
                }
            }

            if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
            {
                if (!vm.registrosOriginal[i].cnpj.toUpperCase().includes(vm.filtro.cnpj.toUpperCase()))
                {
                    incluir = false;
                }
            }

            if (vm.filtro.status != null && vm.filtro.status != '')
            {
                if (vm.filtro.status != vm.registrosOriginal[i].statusCadastro)
                {
                    incluir = false;
                }
            }

            if (incluir)
            {
                vm.registros.push(vm.registrosOriginal[i]);
            }
        }
    }

    vm.ordenarResultado = function(coluna)
    {
        vm.orderSelected = coluna;

        if (vm.lastOrder == coluna)
        {
            vm.lastOrder = '';

            switch (coluna)
            {
                case 'numero':
                    vm.registros.reverse(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.reverse(function(a, b){
                        if(a.razaosocial < b.razaosocial) { return -1; }
                        if(a.razaosocial > b.razaosocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.reverse(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.reverse(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.reverse(function(a, b){
                        if(a.statusCadastro < b.statusCadastro) { return -1; }
                        if(a.statusCadastro > b.statusCadastro) { return 1; }
                        return 0;
                    })
                    break;
            }
        }
        else
        {
            vm.lastOrder = coluna;

            switch (coluna)
            {
                case 'numero':
                    vm.registros.sort(function(a, b){
                        if(a.id < b.id) { return -1; }
                        if(a.id > b.id) { return 1; }
                        return 0;
                    })
                    break;
                case 'razaosocial':
                    vm.registros.sort(function(a, b){
                        if(a.razaoSocial < b.razaoSocial) { return -1; }
                        if(a.razaoSocial > b.razaoSocial) { return 1; }
                        return 0;
                    })
                    break;
                case 'cnpj':
                    vm.registros.sort(function(a, b){
                        if(a.cnpj < b.cnpj) { return -1; }
                        if(a.cnpj > b.cnpj) { return 1; }
                        return 0;
                    })
                    break;
                case 'datacadastro':
                    vm.registros.sort(function compare(a, b) {
                        var dateA = new Date(a.dataCadastro);
                        var dateB = new Date(b.dataCadastro);
                        return dateA - dateB;
                    });
                    break;
                case 'status':
                    vm.registros.sort(function(a, b){
                        if(a.statusCadastro < b.statusCadastro) { return -1; }
                        if(a.statusCadastro > b.statusCadastro) { return 1; }
                        return 0;
                    })
                    break;
            } 
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

    function addDays(date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

}]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceNfeImportarLoteController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_API_FRND', 'AuthService',
      function($scope, $state, toastr, $uibModal, $http, APP_API_FRND, AuthService)
  {
    var vm = this;
    
    vm.selectedTempFile = [];
    vm.filesSelected = [];
    vm.nfe = [];
    vm.duplicatas = [];

    vm.init = function()
    {
        vm.horarioLimite = AuthService.getHorarioLimite();

        //alert('ok');
    }

    vm.validarHorarioLimite = function() 
    {
        // Verificar a hora atual
        var currentTime = new Date();
        var currentHours = currentTime.getHours();
        var currentMinutes = currentTime.getMinutes();

        var horarioEmpresa = parseFloat(vm.horarioLimite.replace(":", "."));
        var currentHourMinute = parseFloat(currentHours + '.' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes));
     
            
        if ( currentHourMinute > horarioEmpresa ) {
            toastr.error('Horário inválido para envio. Horário permitido até às ' + vm.horarioLimite + 'h', 'Horário Determinado');
            return false;
        }
        return true;

    }

    vm.validarEPrevenir = function(event) {
        if (!vm.validarHorarioLimite()) {
            event.preventDefault(); // Impede o comportamento padrão de abrir o file picker
            return false;
        }
    };      

    vm.adicionarItem = function()
    {
        var nfe = {};
        nfe.Id = vm.fileId++;
        nfe.Nome = vm.selectedTempFile[0].name;
        
        //readAsDataURL        

        var reader = new FileReader();
        reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {

            vm.validarPromise = $http.post(APP_API_FRND + "/invoice/nfe/validarLote", { file : evt.target.result }).success(function(response){
                return response;
            }).error(function(error){
                toastr.error(error, 'Erro no processamento');
                return error;
            })

             //= NfeService.validar(evt.target.result);
            vm.validarPromise.then(function(result) {  
                if (result.data != null)
                {
                    vm.duplicatas = result.data.resultado; 
                    vm.falhas = result.data.falhas;

                    vm.getTotalDuplicatas();

                    /*
                    var nfeAtual = result.data[0].notaFiscal;
                    nfeAtual.TextoXML = nfe.XMLText; 

                    //var existeNfe = vm.nfe.find(x => x.chaveNfe === nfeAtual.chaveNfe);
                    var existeNfe = vm.nfe.filter(function(item) {
                        return item.chaveNfe === nfeAtual.chaveNfe;
                    });

                    if (existeNfe == 0)
                    {
                        if (vm.nfe.length == 0)
                        {
                            vm.nfeInicial = nfeAtual;
                        }
                        else
                        {
                            if (nfeAtual.cedente.cnpj.substring(0, 8) != vm.emitente.cnpj.substring(0, 8))
                            {
                                alert('As notas devem pertencer ao mesmo cedente/emitente.');
                                return;
                            }
                        }

                        vm.nfe = vm.nfe.concat(nfeAtual);
                        vm.emitente = nfeAtual.cedente;
                        vm.duplicatas = vm.duplicatas.concat(result.data); 
                    }
                    else
                    {
                        alert('Nota Fiscal já enviada.');
                    }
                    */
                }
                else
                {
                    toastr.error(result.data.text, 'Nfe');
                }
            });
        };

        vm.selectedTempFile = [];
        angular.element("input[type='file']").val(null);
    }

    vm.removerTitulo = function(p)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var i = 0; i < vm.duplicatas.length; i++)
            {
                if (vm.duplicatas[i].viewId == p.viewId)
                {
                    vm.duplicatas.splice(i, 1);
                    break;
                }
            }

            vm.getTotalDuplicatas();
        }
    }

    vm.concluir = function()
    {
        if (vm.duplicatas.length == null || vm.duplicatas.length == 0)
        {
            alert('É necessário informar as duplicatas.');
            return;
        }

        var registros = [];

        for (var i = 0; i < vm.duplicatas.length; i++)
        {
            registros.push(vm.duplicatas[i].titulo);
        }

        vm.concluirPromise = $http.post(APP_API_FRND + "/invoice/titulo/registrar", registros).success(function(response){            
            toastr.info('Títulos válidos enviados para o estoque.', 'Alerta');
            vm.duplicatas = [];
            vm.falhas = [];
            vm.nfe = [];
            vm.emitente = null;
            //$state.go('index.home');
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
    }

    vm.getTotalDuplicatas = function(){
        var total = 0;
        for(var i = 0; i < vm.duplicatas.length; i++){
            var duplicata = vm.duplicatas[i];
            total += duplicata.titulo.valor;
        }
        return total;
    }

    vm.getTotalDuplicatasInvalidas = function(){
        var total = 0;
        for(var i = 0; i < vm.duplicatas.length; i++){
            var duplicata = vm.duplicatas[i];
            if (duplicata.titulo.situacao == 3)
            {
                total++;
            }  
        }
        return total;
    }    

    vm.openIncluirDuplicata = function()
    {
        /*
        var modalInstance = $uibModal.open({
            templateUrl: 'app/antecipacao/modal/inserir-duplicata.html',
            controller: 'AntecipacaoInserirDuplicataController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
               nfes: function () {
                 return vm.nfe;
               }
             }
         });

         modalInstance.result.then(function(data) {
            if (data.viewId != null && data.numeroTitulo != null && data.numeroTitulo != '')
            {
                vm.duplicatas.push(data);
            }
        })
        */
    }

    vm.removerNfe = function(nfeParam)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var i = 0; i < vm.nfe.length; i++)
            {
                if (vm.nfe[i].viewId == nfeParam.viewId)
                {
                    vm.nfe.splice(i, 1);
                    break;
                }
            }
            
            var tamanho = vm.duplicatas.length;

            for (var j = 0; j < tamanho; j++)
            {
                if (vm.duplicatas[j] != null && vm.duplicatas[j].notaFiscal.viewId == nfeParam.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                    j = 0;
                }
            }

            if (vm.duplicatas.length > 0 && vm.duplicatas[0] != null && vm.duplicatas[0].notaFiscal.viewId == nfeParam.viewId)
            {
                vm.duplicatas.splice(0, 1);
            }

            if (vm.duplicatas.length == 0)
            {
                vm.emitente = null;
            }
        }
    }

    vm.removerDuplicata = function(dup)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var j = 0; j < vm.duplicatas.length; j++)
            {
                if (vm.duplicatas[j].viewId == dup.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                }
            }
        }
    }

    vm.exibirMotivoTitulo = function(t)
    {
        alert(t.titulo.situacaoMotivo);
    }

    vm.novo = function()
    {
        if (confirm('Deseja descartar a importação atual?'))
        {
            vm.duplicatas = [];
            vm.falhas = [];
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('ImportarCnabController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_API_FRND',  'AuthService',
      function($scope, $state, toastr, $uibModal, $http, APP_API_FRND, AuthService)
  {
    var vm = this;
    
    vm.selectedTempFile = [];
    vm.filesSelected = [];
    vm.nfe = [];
    vm.duplicatas = [];
    vm.headerarquivo = []

    vm.init = function()
    {
        vm.horarioLimite = AuthService.getHorarioLimite();
       // console.log("hora limite:",vm.horarioLimite)

        //vm.horarioLimite = '15:00'        
        //alert('ok');
    }
   // vm.validarHorarioLimite = function() 
   // {
   //     // Verificar a hora atual
   //     var currentTime = new Date();
   //     var currentHours = currentTime.getHours();
   //     var currentMinutes = currentTime.getMinutes();
//
   //     var horarioEmpresa = vm.horarioLimite.replace(":", ".");
   //     var currentHourMinute = currentHours + '.' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes);
   //  console.log("horarioEmpresa:", horarioEmpresa)
   //  console.log("currentHourMinute:", currentHourMinute)
   //         
   //     if ( currentHourMinute > horarioEmpresa ) {
   //         toastr.error('Horário inválido para envio. Horário permitido até às ' + vm.horarioLimite + 'h', 'Horário Determinado');
   //         return false;
   //     }
   //     return true;
//
   // }
   vm.validarHorarioLimite = function() 
    {
        // Verificar a hora atual
        var currentTime = new Date();
        var currentHours = currentTime.getHours();
        var currentMinutes = currentTime.getMinutes();

        // Converter o horário limite da empresa (formato "HH:mm") para minutos totais
        var horarioParts = vm.horarioLimite.split(":");
        var limiteHoras = parseInt(horarioParts[0], 10);
        var limiteMinutos = parseInt(horarioParts[1], 10);
        var limiteTotalMinutos = (limiteHoras * 60) + limiteMinutos;

        // Calcular os minutos atuais
        var currentTotalMinutos = (currentHours * 60) + currentMinutes;

        console.log("limiteTotalMinutos:", limiteTotalMinutos);
        console.log("currentTotalMinutos:", currentTotalMinutos);

        // Verifica se o horário atual ultrapassou o limite
        if (currentTotalMinutos > limiteTotalMinutos) {
            toastr.error('Horário inválido para envio. Horário permitido até às ' + vm.horarioLimite + 'h', 'Horário Determinado');
            return false;
        }

        return true;
    }


    vm.validarEPrevenir = function(event) {
        if (!vm.validarHorarioLimite()) {
            event.preventDefault(); // Impede o comportamento padrão de abrir o file picker
            return false;
        }
    };  

    vm.adicionarItem = function()
    {
        var nfe = {};
        nfe.Id = vm.fileId++;
        nfe.Nome = vm.selectedTempFile[0].name;
        
        //readAsDataURL        

        var reader = new FileReader();
        reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
        reader.onload = function (evt) {

            vm.validarPromise = $http.post(APP_API_FRND + "/invoice/nfe/validarLoteCnab", { file : evt.target.result }).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })

             //= NfeService.validar(evt.target.result);
            vm.validarPromise.then(function(result) {  

                if (result.data != null)
                {
                    vm.headerarquivo = result.data;
                    vm.duplicatas = result.data.itens; 
                    vm.falhas = result.data; //.falhas;

                    vm.getTotalDuplicatas();

                }
                else
                {
                    toastr.error(result.data.text, 'Nfe');
                }
            });
        };

        vm.selectedTempFile = [];
        angular.element("input[type='file']").val(null);
    }

    vm.removerTitulo = function(p)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var i = 0; i < vm.duplicatas.length; i++)
            {
                if (vm.duplicatas[i].viewId == p.viewId)
                {
                    vm.duplicatas.splice(i, 1);
                    break;
                }
            }

            vm.getTotalDuplicatas();
        }
    }

    vm.concluir = function()
    {
        if (vm.duplicatas.length == null || vm.duplicatas.length == 0)
        {
            alert('É necessário informar as duplicatas.');
            return;
        }

        var registros = [];

        for (var i = 0; i < vm.duplicatas.length; i++)
        {
            registros.push(vm.duplicatas[i]);
            console.log(vm.duplicatas[i]);
        }

        vm.concluirPromise = $http.post(APP_API_FRND + "/invoice/tituloManual/registrarTituloCnab", registros).success(function(response){            
            toastr.info('Títulos válidos enviados para o estoque.', 'Alerta');
            vm.duplicatas = [];
            vm.falhas = [];
            vm.nfe = [];
            vm.emitente = null;
            //$state.go('index.home');
            return response;
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');
            return error;
        });
    }

    vm.getTotalDuplicatas = function(){
        var total = 0;
        for(var i = 0; i < vm.duplicatas.length; i++){
            var duplicata = vm.duplicatas[i];
            
            total += duplicata.valor;
            
        }
        vm.total = total;
        return total;
    }

    vm.openIncluirDuplicata = function()
    {
        /*
        var modalInstance = $uibModal.open({
            templateUrl: 'app/antecipacao/modal/inserir-duplicata.html',
            controller: 'AntecipacaoInserirDuplicataController',
            controllerAs: 'controller',
            windowClass: 'inmodal',
            size: 'lg',
            resolve: {
               nfes: function () {
                 return vm.nfe;
               }
             }
         });

         modalInstance.result.then(function(data) {
            if (data.viewId != null && data.numeroTitulo != null && data.numeroTitulo != '')
            {
                vm.duplicatas.push(data);
            }
        })
        */
    }

    vm.removerNfe = function(nfeParam)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var i = 0; i < vm.nfe.length; i++)
            {
                if (vm.nfe[i].viewId == nfeParam.viewId)
                {
                    vm.nfe.splice(i, 1);
                    break;
                }
            }
            
            var tamanho = vm.duplicatas.length;

            for (var j = 0; j < tamanho; j++)
            {
                if (vm.duplicatas[j] != null && vm.duplicatas[j].notaFiscal.viewId == nfeParam.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                    j = 0;
                }
            }

            if (vm.duplicatas.length > 0 && vm.duplicatas[0] != null && vm.duplicatas[0].notaFiscal.viewId == nfeParam.viewId)
            {
                vm.duplicatas.splice(0, 1);
            }

            if (vm.duplicatas.length == 0)
            {
                vm.emitente = null;
            }
        }
    }

    vm.removerDuplicata = function(dup)
    {
        if (confirm('Deseja realmente excluir?'))
        {
            for (var j = 0; j < vm.duplicatas.length; j++)
            {
                if (vm.duplicatas[j].viewId == dup.viewId)
                {
                    vm.duplicatas.splice(j, 1);
                }
            }
        }
    }

    vm.exibirMotivoTitulo = function(t)
    {
        alert(t.situacaoMotivo);
    }

    vm.novo = function()
    {
        if (confirm('Deseja descartar a importação atual?'))
        {
            vm.duplicatas = [];
            vm.falhas = [];
        }
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';

angular.module('inspinia')
  .controller('InvoiceDigitacaoTituloController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_API_FRND', 'AuthService',
      function($scope, $state, toastr, $uibModal, $http, APP_API_FRND, AuthService)
  {
    var vm = this;
    vm.titulos = [];    
    vm.total = 0;
    
    vm.init = function()
    {
      vm.horarioLimite = AuthService.getHorarioLimite();
      vm.usoDeBoleto = AuthService.getUsoDeBoleto();
      vm.user = AuthService.getUser();


    }

    vm.validarHorarioLimite = function() 
    {
        // Verificar a hora atual
        var currentTime = new Date();
        var currentHours = currentTime.getHours();
        var currentMinutes = currentTime.getMinutes();

        var horarioEmpresa = parseFloat(vm.horarioLimite.replace(":", "."));
        var currentHourMinute = parseFloat(currentHours + '.' + (currentMinutes < 10 ? '0' + currentMinutes : currentMinutes));
     
        //console.log(currentHourMinute,horarioEmpresa)

        if ( currentHourMinute > horarioEmpresa ) {
            toastr.error('Horário inválido para envio. Horário permitido até às ' + vm.horarioLimite + 'h', 'Horário Determinado');
            return false;
        }
        return true;

    }

    vm.validarEPrevenir = function(event) {
        if (!vm.validarHorarioLimite()) {
            event.preventDefault(); // Impede o comportamento padrão de abrir o file picker
            return false;
        }
        else {
          vm.incluirTitulo()
        }
    };     

    vm.incluirTitulo = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/invoice/digitacao/cadastro/index.html',
        controller: 'InvoiceDigitacaoTituloCadastroController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          titulos: function () {
            return vm.titulos;
          },
        }
      }).closed.then(function(){
        vm.calcularTotal();
      });
    }

    vm.calcularTotal = function()
    {
      vm.total = 0;

      for (var i=0;i<vm.titulos.length;i++)
      {
        vm.total += vm.titulos[i].valor;
      }
    }

    vm.removerTitulo = function(dup) {
      if (confirm('Deseja realmente excluir?'))
      {
        for (var j = 0; j < vm.titulos.length; j++)
        {
            if (vm.titulos[j].viewId == dup.viewId)
            {
                vm.titulos.splice(j, 1);
            }
        }
        vm.calcularTotal();
      }
    }

    vm.concluir = function() {
      if (vm.titulos.length == null || vm.titulos.length == 0)
      {
          alert('Não existem títulos para o envio.');
          return;
      }

      vm.concluirPromise = $http.post(APP_API_FRND + "/invoice/tituloManual/registrar", vm.titulos).success(function(response){            
          toastr.info('Títulos cadastrados com sucesso.', 'Alerta');
          vm.titulos = [];
          vm.total = 0;
          return response;
      }).error(function(error){
          toastr.error(error, 'Erro no processamento');
          return error;
      });
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);
'use strict';
angular.module('inspinia')
  .controller('CnabSincronizadoController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_API_FRND', 'AuthService',
      function($scope, $state, toastr, $uibModal, $http, APP_API_FRND, AuthService)
  {
    var vm = this;
    
    // Propriedades
    vm.selectedFile = null;
    vm.nomeArquivo = null;
    vm.processando = false;
    vm.arquivoProcessado = false;
    vm.conexaoAssinaNet = false;
    vm.mostrarLogs = false;
    vm.logs = [];
    
    vm.dadosEmpresa = {
        idCedente: '',
        idCedenteAssinaNet: ''
    };
    
    vm.resultado = {};

    // Inicialização
    vm.init = function() {
        vm.testarConexao();
        vm.carregarLogs();
    };

// Adicionar esta função no controller:
vm.getStatusLabelClass = function(status) {
    switch (status ? status.toUpperCase() : '') {
        case 'SUCESSO':
            return 'label-primary';
        case 'ERRO':
            return 'label-danger';
        case 'PROCESSANDO':
            return 'label-warning';
        default:
            return 'label-default';
    }
};

// Também adicionar uma propriedade para controlar o teste de conexão:
vm.testando = false;

// E ajustar a função de teste de conexão:
vm.testarConexao = function() {
    vm.testando = true;
    $http.get(APP_API_FRND + "/cnab/testar-conexao-assinanet")
        .then(function(response) {
            vm.conexaoAssinaNet = response.data.conexaoAssinaNet;
            if (vm.conexaoAssinaNet) {
                toastr.success('Conexão com AssinaNet OK');
            } else {
                toastr.warning('Conexão com AssinaNet indisponível');
            }
        })
        .catch(function(error) {
            vm.conexaoAssinaNet = false;
            toastr.error('Erro ao testar conexão com AssinaNet');
        })
        .finally(function() {
            vm.testando = false;
        });
};



    // Evento quando arquivo é selecionado
    vm.onArquivoSelecionado = function() {
        if (vm.selectedFile && vm.selectedFile.length > 0) {
            var arquivo = vm.selectedFile[0];
            vm.nomeArquivo = arquivo.name;
            
            // Validar extensão
            var extensoesPermitidas = ['.ret', '.rem', '.cnab'];
            var nomeArquivo = arquivo.name.toLowerCase();
            var extensaoValida = extensoesPermitidas.some(function(ext) {
                return nomeArquivo.endsWith(ext);
            });

            if (!extensaoValida) {
                toastr.error('Formato de arquivo não suportado. Use .ret, .rem ou .cnab');
                vm.limparArquivo();
                return;
            }
            
            toastr.info('Arquivo selecionado: ' + arquivo.name);
        }
    };

    // Limpar arquivo selecionado
    vm.limparArquivo = function() {
        vm.selectedFile = null;
        vm.nomeArquivo = null;
        angular.element("input[type='file']").val(null);
    };

    // Verificar se pode enviar
    vm.podeEnviar = function() {
        return vm.selectedFile && 
               vm.selectedFile.length > 0 && 
               vm.dadosEmpresa.idCedente && 
               vm.dadosEmpresa.idCedenteAssinaNet && 
               vm.conexaoAssinaNet && 
               !vm.processando;
    };

    // Sincronizar CNAB
    vm.sincronizarCnab = function() {
        if (!vm.validarFormulario()) {
            return;
        }

        vm.processando = true;
        vm.processandoPromise = vm.enviarArquivo();
    };

    // Validar formulário
    vm.validarFormulario = function() {
        if (!vm.selectedFile || vm.selectedFile.length === 0) {
            toastr.error('Selecione um arquivo CNAB');
            return false;
        }

        if (!vm.dadosEmpresa.idCedente) {
            toastr.error('Informe o ID do cedente');
            return false;
        }

        if (!vm.dadosEmpresa.idCedenteAssinaNet) {
            toastr.error('Informe o ID do cedente AssinaNet');
            return false;
        }

        if (!vm.conexaoAssinaNet) {
            toastr.error('Conexão com AssinaNet indisponível');
            return false;
        }

        return true;
    };

    // Enviar arquivo
    vm.enviarArquivo = function() {
        var formData = new FormData();
        formData.append('arquivo', vm.selectedFile[0]);
        formData.append('idCedente', vm.dadosEmpresa.idCedente);
        formData.append('idCedenteAssinaNet', vm.dadosEmpresa.idCedenteAssinaNet);

        return $http({
            method: 'POST',
            url: APP_API_FRND + '/cnab/upload-sincronizado',
            data: formData,
            headers: {
                'Content-Type': undefined
            },
            transformRequest: angular.identity
        })
        .then(function(response) {
            vm.processarResposta(response.data);
        })
        .catch(function(error) {
            vm.processarErro(error);
        })
        .finally(function() {
            vm.processando = false;
        });
    };

    // Processar resposta de sucesso
    vm.processarResposta = function(data) {
        vm.arquivoProcessado = true;
        vm.resultado = {
            sucesso: data.sucesso,
            nomeArquivo: data.nomeArquivo || vm.nomeArquivo,
            statusProcessamento: data.statusProcessamento,
            dataHoraEnvio: new Date(),
            dataHoraRetorno: data.dataHoraRetorno ? new Date(data.dataHoraRetorno) : new Date(),
            detalhes: data.detalhes,
            erros: data.erros || [],
            temArquivoProcessado: data.temArquivoProcessado
        };

        if (data.sucesso) {
            toastr.success('Arquivo CNAB sincronizado com sucesso!');
            if (data.detalhes) {
                toastr.info(data.detalhes);
            }
        } else {
            toastr.error(data.mensagem || 'Erro no processamento do arquivo');
            if (data.erros && data.erros.length > 0) {
                data.erros.forEach(function(erro) {
                    toastr.error(erro);
                });
            }
        }

        vm.carregarLogs(); // Recarregar logs
    };

    // Processar erro
    vm.processarErro = function(error) {
        vm.arquivoProcessado = true;
        vm.resultado = {
            sucesso: false,
            nomeArquivo: vm.nomeArquivo,
            statusProcessamento: 'ERRO',
            dataHoraEnvio: new Date(),
            dataHoraRetorno: new Date(),
            detalhes: error.data ? error.data.mensagem : 'Erro na comunicação com o servidor',
            erros: error.data ? error.data.erros || [] : ['Erro interno do servidor'],
            temArquivoProcessado: false
        };

        toastr.error(vm.resultado.detalhes);
    };

    // Obter classe CSS para status
    vm.getStatusClass = function(status) {
        switch (status ? status.toUpperCase() : '') {
            case 'SUCESSO':
                return 'status-success';
            case 'ERRO':
                return 'status-error';
            default:
                return 'status-processing';
        }
    };

    // Baixar arquivo processado
    vm.baixarArquivoProcessado = function() {
        // Implementar download do arquivo processado
        toastr.info('Funcionalidade de download será implementada');
    };

    // Novo processamento
    vm.novoProcessamento = function() {
        if (confirm('Deseja iniciar um novo processamento?')) {
            vm.arquivoProcessado = false;
            vm.resultado = {};
            vm.limparArquivo();
            vm.dadosEmpresa = {
                idCedente: '',
                idCedenteAssinaNet: ''
            };
            vm.mostrarLogs = false;
        }
    };

    // Carregar logs
    vm.carregarLogs = function() {
        $http.get(APP_API_FRND + '/cnab/logs-sincronizado?take=20')
            .then(function(response) {
                vm.logs = response.data;
            })
            .catch(function(error) {
                console.error('Erro ao carregar logs:', error);
            });
    };

    // Ver logs
    vm.verLogs = function() {
        vm.mostrarLogs = !vm.mostrarLogs;
        if (vm.mostrarLogs) {
            vm.carregarLogs();
        }
    };

    // Ver detalhes do log
    vm.verDetalhesLog = function(logId) {
        $http.get(APP_API_FRND + '/cnab/log-detalhes/' + logId)
            .then(function(response) {
                // Abrir modal com detalhes
                vm.abrirModalDetalhes(response.data);
            })
            .catch(function(error) {
                toastr.error('Erro ao carregar detalhes do log');
            });
    };

    // Abrir modal com detalhes
    var modalInstance = $uibModal.open({
    template: 
        '<div class="modal-header">' +
        '<h4 class="modal-title">Detalhes do Log</h4>' +
        '</div>' +
        '<div class="modal-body">' +
        '<pre>{{detalhes | json}}</pre>' +
        '</div>' +
        '<div class="modal-footer">' +
        '<button class="btn btn-primary" ng-click="$close()">Fechar</button>' +
        '</div>',
    controller: function($scope) {
        $scope.detalhes = detalhes;
    },
    size: 'lg'
    });


    // Função para mostrar/esconder seções
    vm.showhide = function(icon, box) {
        var iconElement = angular.element(document.getElementById(icon));
        iconElement.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var boxElement = angular.element(document.getElementById(box));
        boxElement.slideToggle(200);
    };

    // Inicializar
    vm.init();
  }]);


'use strict';

angular.module('inspinia')
  .controller('RetornoCnabsController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_API_FRND',
      function($scope, $state, toastr, $uibModal, $http, APP_API_FRND)
  {
    var vm = this; 
    vm.arquivos  = [];
    vm.arquivos2  = [];

    vm.filtro = {
      data: '',
      nome: ''

    }

    vm.indexPage = 1;

    $scope.pagination = {
        current: 1,
        perPage: 15,
        maxSize: 5,
        totalItems: 0,
    };


    vm.init = function()
    {
      vm.listarArquivos($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.listarArquivos = function(perPage, index, orderBy, filter)
    {
      vm.arquivos = null;

      var data = "0";
      var nome = "0";


      if (vm.filtro == null)
      {
          vm.filtro = {
              data: '',
              nome: '',
              index: index,
              page: perPage
          }
      }

      if (vm.filtro.data != null && vm.filtro.data != '')
      {
          codigo = vm.filtro.data;
      }
      if (vm.filtro.nome != null && vm.filtro.nome != '')
      {
          nome = vm.filtro.nome;
      }

      vm.filtro.page = index;
      vm.filtro.perPage = perPage;

      vm.consultarPromise = $http.post(APP_API_FRND + "/cnabRetornoCliente/listarRetornoCnab", vm.filtro).success(function(response){
        vm.consultarPromise.then(function(response)
        { 
            vm.arquivos  = response.data;
            
        });        
        vm.items = vm.arquivos;


        $scope.pagination.totalItems = (response.pages * perPage);
        }).error(function(error){
            return error;
        });

       // vm.consultarPromise = $http.post(APP_API_FRND + "/cnabRetornoCliente/listarRetornoCnab");
       // 
       // vm.consultarPromise.then(function(response)
       // { 
       //     vm.arquivos  = response.data;
       //     
       // });
    }

    $scope.onSearch = function() {
      vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
  }

  $scope.onPageChange = function(result) {
      vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
  }

  $scope.onPerPageChange = function(result) {
      vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
  }  

    vm.downloadArquivo = function(item)
    {
        vm.gerarRemessaPromise = $http.post(APP_API_FRND + "/cnabRetornoCliente/downloadRetornoCnab/" + item).success(function(response){  
            vm.download(response, 'text/plain', item);                   
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');            
        });
    }

    vm.download = function(dados, tipo, nome)
    {
      //recupera somente o arquivo texto
      var cnab = (dados.retornoCnabs[0].arquivoCnabRetorno);
      var file = vm.b64toBlob(cnab, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);

'use strict';

angular.module('inspinia')
  .controller('RetornoCnabsController', ['$scope', '$state', 'toastr', '$uibModal', '$http', 'APP_API_FRND', 'PagerService', 'modalService',
      function($scope, $state, toastr, $uibModal, $http, APP_API_FRND, PagerService, modalService)
  {
    var vm = this; 
    vm.arquivos  = [];
    vm.arquivos2  = [];
    vm.arquivosPag  = [];

    vm.filtro = {
      data: '',
      nome: ''
    }

    vm.pager = {};
    vm.setPage = setPage;

    // Adicione a função redirectToURL ao vm
    vm.redirectToURL = function() {
      var url = 'https://venturenegocios.com.br/wp-content/uploads/2024/12/MN003-IF-RETORNO-DE-CNAB.pdf';
      modalService.openModal(url);
  };

    function setPage(page) {
        if (page < 1 || page > vm.pager.totalPages) {
            return;
        }
        vm.pager = PagerService.GetPager(vm.arquivos.length, page);
        vm.arquivosPag = vm.arquivos.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.init = function()
    {
      vm.listarArquivos();
    }

    vm.listarArquivos = function()
    {
      vm.arquivos = null;

      var data = "0";
      var nome = "0";


      if (vm.filtro == null)
      {
          vm.filtro = {
              data: '',
              nome: '',
              index: index,
          }
      }

      if (vm.filtro.data != null && vm.filtro.data != '')
      {
          codigo = vm.filtro.data;
      }
      if (vm.filtro.nome != null && vm.filtro.nome != '')
      {
          nome = vm.filtro.nome;
      }

      vm.consultarPromise = $http.post(APP_API_FRND + "/cnabRetornoCliente/listarRetornoCnab", vm.filtro).success(function(response){
        vm.arquivos = response.retornoCnabs;

        // Invertendo a ordem dos arquivos para exibi-los em ordem decrescente pelo índice da array
        vm.arquivos.reverse();        
        console.log(vm.arquivos)       

        vm.pager.totalPages = 1;
        vm.setPage(1);
      });
    }

    vm.downloadArquivo = function(item)
    {
        vm.gerarRemessaPromise = $http.post(APP_API_FRND + "/cnabRetornoCliente/downloadRetornoCnab/" + item).success(function(response){  
            vm.download(response, 'text/plain', item);                   
        }).error(function(error){
            toastr.error(error, 'Erro no processamento');            
        });
    }

    vm.download = function(dados, tipo, nome)
    {
      //recupera somente o arquivo texto
      var cnab = (dados.retornoCnabs[0].arquivoCnabRetorno);
      var file = vm.b64toBlob(cnab, tipo);

      var fileURL = URL.createObjectURL(file);
      var a = document.createElement('a');
      a.href = fileURL;
      a.target = '_blank';
      a.download = nome;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a); 
    }

    vm.b64toBlob = function (b64Data, contentType) {
      var byteCharacters = atob(b64Data);
      var byteArrays = [];
      var sliceSize = 512
      
      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);
      
          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
          }
      
          var byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
      }
      
      var blob = new Blob(byteArrays, {type: contentType});
      return blob;
    }

    vm.init();

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

  }]);

angular.module('inspinia')
  .controller('CadastroSacadoPesquisaController', ['$scope', '$state', 'toastr', 'PagerService', '$http','APP_API_FRND',
      function($scope, $state, toastr, PagerService, $http, APP_API_FRND) 
{
    var vm = this;    
    vm.registros = null;
    vm.filtro = {
        codigo: '',
        nome: '',
        cnpj: ''
    }

    vm.indexPage = 1;

    $scope.pagination = {
        current: 1,
        perPage: 15,
        maxSize: 5,
        totalItems: 0,
    };

    vm.init = function()
    {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.pesquisar = function(perPage, index, orderBy, filter)
    {
        vm.registros = null;

        var codigo = "0";
        var nome = "0";
        var cnpj = "0";

        if (vm.filtro == null)
        {
            vm.filtro = {
                codigo: '',
                nome: '',
                cnpj: '',
                index: index,
                page: perPage
            }
        }

        if (vm.filtro.codigo != null && vm.filtro.codigo != '')
        {
            codigo = vm.filtro.codigo;
        }
        if (vm.filtro.nome != null && vm.filtro.nome != '')
        {
            nome = vm.filtro.nome;
        }
        if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
        {
            cnpj = vm.filtro.cnpj;
        }

        vm.filtro.page = index;
        vm.filtro.perPage = perPage;
        
        //vm.consultarPromise = $http.get(APP_API_FRND + "/sacado/pesquisarPage/" + index + "/" + perPage + "/" + codigo + "/" + nome + "/" + cnpj);
        
        $http.post(APP_API_FRND + "/sacado/pesquisarPage", vm.filtro).success(function(response){
            vm.registros = response.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = (response.pages * perPage);
        }).error(function(error){
            return error;
        });

        /*
        vm.consultarPromise = $http.post(APP_API_FRND + "/sacado/pesquisarPage", vm.filtro);

        vm.consultarPromise.then(function(response)
        {             
            vm.registros = response.data.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = response.data.pages;
        });
        */
    }
    
    $scope.onSearch = function() {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPerPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.consultar = function(sacado)
    {
        $state.go('index.cadastro_sacado_consulta', {obj: sacado});
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_sacado');
    }

    vm.filtrarPesquisa = function()
    {
        $scope.pagination.perPage,$scope.pagination.current = 1;
        
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.init();

    vm.getTotalPages = function() {
        return new Array(7);   
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioResetSenhaController', ['$scope', '$state', 'APP_API_FRND', '$http', 'toastr',
      function($scope, $state, APP_API_FRND, $http, toastr)
{
    var vm = this;
    vm.usuario = {};
    var codigo = $state.params.codigo;

    vm.init = function()
    {
        //vm.confirmarCodigo($state.params.codigo);
    }

    vm.enviar = function()
    {
        if (vm.usuario.senha == '')
        {
            toastr.error('Informe o campo Senha.', 'Alerta');
            return;
        }

        if (vm.usuario.confirmPassword == '')
        {
            toastr.error('Informe o campo Confirmar Senha.', 'Alerta');
            return;
        }

        if (vm.usuario.senha != vm.usuario.confirmPassword)
        {
            toastr.error('Senhas estão divergentes.', 'Alerta');
            return;
        }

        vm.usuario.viewId = codigo;

        vm.resetPromise = $http.post(APP_API_FRND + "/cedente/resetsenha", vm.usuario).success(function(response){
            toastr.info('Sua Senha foi atualizada com sucesso.', 'Alerta');     
            vm.usuario = {};
            $state.go('login.autenticar');
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');            
            return error;
        });
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioAguardarAprovacaoController', ['$scope', '$state', '$uibModal', 'toastr', 'APP_API_FRND', '$http',
      function($scope, $state, $uibModal, toastr, APP_API_FRND, $http)
{
    var vm = this;

    vm.init = function()
    {
        vm.consultar();
    }

    vm.consultar = function()
    {
      vm.fornecedor = null;
      
      return $http.get(APP_API_FRND + "/cedente/consultarsituacaocadastro")
        .then(function(response)
        { 
            vm.fornecedor = response.data;
        }).catch(function (data) {
          $state.go('login.autenticar');
        });
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('CadastroIncluirSocioController', ['$scope', '$state', 'fornecedor', 'toastr', 'tipopessoa', '$uibModalInstance', 'APP_API_FRND', '$http', 'CepService', 'socio', 'indice',
      function($scope, $state, fornecedor, toastr, tipopessoa, $uibModalInstance, APP_API_FRND, $http, CepService, socio, indice)
{
    var vm = this;
    vm.tipoPessoa = tipopessoa;
    vm.fornecedor = fornecedor;
    vm.etapa = 1;

    vm.pessoa = {};

    vm.arquivos = {
      arq1: '',
      arq2: '',
      arq3: '',
      arq4: '',
      arq5: '',
      arq6: '',
      arq7: '',
    };

    vm.init = function()
    {
      if (socio != null)
      {
        vm.pessoa = socio;
        vm.etapa = 3;

        vm.loadDocumentos();
      }
    }

    vm.loadDocumentos = function()
    {
      if (vm.pessoa.documentos != null)
      {
        for (var i = 0; i <= vm.pessoa.documentos.length; i++)
        {
          if (vm.pessoa.documentos[i] != null)
          {
            switch (vm.pessoa.documentos[i].tipo)
            {
              case 1:
                vm.arquivos.arq1 = vm.pessoa.documentos[i].nome;
                break;
              case 2:
                vm.arquivos.arq2 = vm.pessoa.documentos[i].nome;
                break;
              case 3:
                vm.arquivos.arq3 = vm.pessoa.documentos[i].nome;
                break;
              case 4:
                vm.arquivos.arq4 = vm.pessoa.documentos[i].nome;
                break;  
              case 5:
                vm.arquivos.arq5 = vm.pessoa.documentos[i].nome;
                break;
              case 6:
                vm.arquivos.arq6 = vm.pessoa.documentos[i].nome;
                break;
              case 7:
                vm.arquivos.arq7 = vm.pessoa.documentos[i].nome;
                break;
            }
          }
        }
      }
    }

    vm.incluir = function()
    {
      var api = 'adicionarsocio';

      if (vm.tipoPessoa == 'Procurador')
      {
        api = 'adicionarprocurador';
      }

      if (vm.pessoa.assinaPelaEmpresaText != null && vm.pessoa.assinaPelaEmpresaText != '')
      {
        vm.pessoa.assinaPelaEmpresa = parseInt(vm.pessoa.assinaPelaEmpresaText);
      }

      vm.incluirPromise = $http.post(APP_API_FRND + "/cedente/" + api, vm.pessoa).success(function(response){
        //$state.go('confirmar_cadastro.finalizar');
        vm.pessoa.viewId = response;

        if (vm.tipoPessoa == 'Procurador')
        {
          vm.fornecedor.procuradores.push(vm.pessoa);
        }
        else
        {
          vm.fornecedor.socios.push(vm.pessoa);
        }

        toastr.info('Registro cadastrado com sucesso.', 'Alerta');
        vm.fechar();
        //vm.etapa = 2;

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.atualizar = function()
    {
      var api = 'atualizarsocio';

      if (vm.tipoPessoa == 'Procurador')
      {
        api = 'atualizarprocurador';
      }

      if (vm.pessoa.assinaPelaEmpresaText != null && vm.pessoa.assinaPelaEmpresaText != '')
      {
        vm.pessoa.assinaPelaEmpresa = parseInt(vm.pessoa.assinaPelaEmpresaText);
      }

      vm.incluirPromise = $http.post(APP_API_FRND + "/cedente/" + api, vm.pessoa).success(function(response){
        //$state.go('confirmar_cadastro.finalizar');
        vm.pessoa.viewId = response;

        if (vm.tipoPessoa == 'Procurador')
        {
          vm.fornecedor.procuradores.splice(indice, 1);
          vm.fornecedor.procuradores.push(vm.pessoa);
        }
        else
        {
          vm.fornecedor.socios.splice(indice, 1);
          vm.fornecedor.socios.push(vm.pessoa);
        }

        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

    vm.adicionarDocumento = function(tipo)
    {
      var cnab = {};      
      vm.file = {};
      vm.file.nome = vm.selectedTempFile[0].name;
      vm.file.tipo = tipo;
      
      var reader = new FileReader();
      reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
      reader.onload = function (evt) {          
          vm.file.base64 = evt.target.result;          

          var pessoa = vm.pessoa;
          pessoa.documentos = [];
          pessoa.documentos.push(vm.file);

          var api = 'adicionardocumentosocio';

          if (vm.tipoPessoa == 'Procurador')
          {
            api = 'adicionardocumentoprocurador';
          }

          vm.validarPromise = $http.post(APP_API_FRND + "/cedente/" + api, pessoa).success(function(response){
            toastr.info('Arquivo enviado com sucesso.', 'Alerta');

            if (vm.pessoa.documentos != null)
            {
              for (var i = 0; i < vm.pessoa.documentos.length; i++)
              {
                if (vm.pessoa.documentos[i].tipo == vm.file.tipo)
                {
                  vm.pessoa.documentos.splice(i, 1);
                }
              }
            }
            vm.file.base64 = null;
            vm.pessoa.documentos.push(vm.file);

            vm.loadDocumentos();

            vm.file = {};
            return response;
          }).error(function(error){
            vm.file = {};
            toastr.error(error, 'Alerta');
            return error;
          });
      };
      
      vm.selectedTempFile = [];
      angular.element("input[type='file']").val(null);      
    }

    vm.consultarCep = function()
    {
      if (vm.pessoa != null && vm.pessoa.enderecoDados != null && vm.pessoa.enderecoDados.cep != '' && vm.pessoa.enderecoDados.cep.length > 8)
      {
        var cep = vm.pessoa.enderecoDados.cep.replace("-", "");

        vm.cepPromise = CepService.consultarCep(cep);

        vm.cepPromise.then(function(result) { 
          vm.pessoa.enderecoDados.bairro = result.bairro;
          vm.pessoa.enderecoDados.logradouro = result.logradouro;
          vm.pessoa.enderecoDados.cidade = result.localidade;
          vm.pessoa.enderecoDados.complemento = result.complemento;
          vm.pessoa.enderecoDados.uf = result.uf;
        });
      }          
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('CadastroIncluirEmpresaController', ['$scope', '$state', 'fornecedor', 'toastr', '$uibModalInstance', 'APP_API_FRND', '$http', 'empresa', 'indice',
      function($scope, $state, fornecedor, toastr, $uibModalInstance, APP_API_FRND, $http, empresa, indice)
{
    var vm = this;

    vm.empresa = {};
    vm.fornecedor = fornecedor;

    vm.init = function()
    {
      if (empresa != null)
      {
        vm.empresa = empresa;
      }
    }

    vm.incluir = function()
    {
      vm.incluirPromise = $http.post(APP_API_FRND + "/fornecedor/adicionarempresa", vm.empresa).success(function(response){        
        
        vm.empresa.viewId = response;

        toastr.info('Registro cadastrado com sucesso.', 'Alerta');
        vm.fornecedor.empresas.push(vm.empresa);
        vm.fechar();
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.atualizar = function()
    {
      vm.incluirPromise = $http.post(APP_API_FRND + "/fornecedor/atualizarempresa", vm.empresa).success(function(response){        
        
        vm.empresa.viewId = response;

        toastr.info('Registro atualizado com sucesso.', 'Alerta');
        vm.fornecedor.empresas.splice(indice, 1);
        vm.fornecedor.empresas.push(vm.empresa);
        vm.fechar();

        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.fechar = function()
    {
      $uibModalInstance.close();
    }

    vm.init();

}]);

angular
.module('inspinia').factory("UsuarioService", ['$http', 'APP_API_FRND', 'AuthService', 
    function ($http, APP_API_FRND, AuthService) {
    return {
        login: function(login, pwd){
            var data = {
                login: login,
                senha: pwd
            }
            return $http.post(APP_API_FRND + "/Login", data).then(
                function(response){
                    AuthService.setToken(response.data.accessToken);
                    AuthService.setUser(response.data.userName);
                    AuthService.setEmpresa(response.data.empresa);
                    AuthService.setRole(response.data.role);
                    return response;
                },
                function (error) {
                    return error;
                }
            )
        },
        insert: function(usuario){
            return $http.post(APP_API_FRND + "/usuario", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        update: function(viewId, usuario){
            usuario.ViewId = viewId;
            return $http.post(APP_API_FRND + "/usuario/update", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        updatePassword: function(oldPassword, newPassword){
            usuario = {};
            usuario.oldPassword = oldPassword;
            usuario.newPassword = newPassword;
            return $http.post(APP_API_FRND + "/cedente/updatePassword", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },
        delete: function(usuario){
            return $http.post(APP_API_FRND + "/usuario/remove", usuario).success(function(response){
                return response;
            }).error(function(error){
                return error;
            })
        },       
        get: function (viewId) {
            return $http.get(APP_API_FRND + "/usuario/" + viewId)
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAll: function () {
            return $http.get(APP_API_FRND + "/usuario/GetAll")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getMenu: function (viewId) {
            return $http.get(APP_API_FRND + "/menu")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioPesquisaController', ['$scope', '$state', 'UsuarioService', 'toastr', 'PagerService',
      function($scope, $state, UsuarioService, toastr, PagerService)
  {
    var vm = this;
    
    vm.pager = {};
    vm.setPage = setPage;

    function setPage(page) {
      if (page < 1 || page > vm.pager.totalPages) {
          return;
      }
      vm.pager = PagerService.GetPager(vm.usuarios.length, page);
      vm.items = vm.usuarios.slice(vm.pager.startIndex, vm.pager.endIndex + 1);
    }

    vm.pesquisar = function()
    {
      var usuariosPromise = UsuarioService.getAll();

      usuariosPromise.then(function(result) {  
        if (result.status)
        {
          vm.usuarios = result.data;
          vm.pager.totalPages = 1;
          vm.setPage(1);
        }
      });
    }

    vm.incluir = function()
    {
      $state.go('index.cadastrarusuario');
    }

    vm.visualizar = function(usuario)
    {
      $state.go('index.consultarusuario', {obj: usuario});
    }

    vm.alterar = function(usuario)
    {
      $state.go('index.alterarusuario', {obj: usuario});
    }    

    vm.pesquisar();

  }]);
'use strict';

angular.module('inspinia')
  .controller('UsuarioNovaContaController', ['$scope', '$state', 'APP_API_FRND', '$http', 'CepService', '$location',
      'toastr',
      function($scope, $state, APP_API_FRND, $http, CepService, $location, toastr)
{
    var vm = this;
    vm.clienteName = '';
    vm.fornecedor = {
      complemento: {}
    };

    vm.init = function()
    {
      vm.s_subdomain();
    }    

    vm.s_subdomain = function()
    {
        var host = $location.host();
        
        if (host.indexOf('.') < 0) 
        {            
            vm.logoempresa = 'assets/images/icons/logo.png';

            vm.clienteName = 'moneynow';
        }
        else
        {
            var subdomain = host.split('.')[0];

            vm.logoempresa = 'assets/images/icons/logo.png';

            if (subdomain == 'mondocapital')
            {
                vm.logoempresa = 'assets/images/icons/logo_mondo_capital.png';
                vm.autoRegister = true;
                vm.clienteName = 'mondocapital';
            }
            /*
            else if (subdomain == 'mansbank')
            {
                vm.logoempresa = 'assets/images/icons/mansbank.png';
                vm.autoRegister = false;
                vm.isConsultorNegocio = true;
            }
            else if (subdomain == 'cnegocios')
            {
              vm.autoRegister = false;
              vm.isConsultorNegocio = true;
            }
            */
            else if (subdomain == 'araguaya' || subdomain == 'hmgaraguaya')
            {
              vm.autoRegister = true;
              vm.isConsultorNegocio = false;
              vm.clienteName = 'araguaya';
            }
            else if (subdomain == 'mlbank' || subdomain == 'hmgmlbank')
            {
              vm.autoRegister = true;
              vm.isConsultorNegocio = false;
              vm.clienteName = 'mlbank';
            }
            else if (subdomain == 'jpa' || subdomain == 'jpa')
            {
              vm.autoRegister = true;
              vm.isConsultorNegocio = false;
              vm.clienteName = 'jpa';
            }
            else if (subdomain != '')
            {
              vm.autoRegister = true;
              vm.isConsultorNegocio = false;
              vm.clienteName = subdomain;
            }
            else
            {
              toastr.error('Empresa não identificada.', 'Alerta');
            }
        }
    }

    vm.incluir = function()
    {
      if (vm.fornecedor.complemento.emailCadastro == null)
      {
        toastr.error('Favor informar o campo E-mail.', 'Alerta');
        return;
      }

      if (vm.fornecedor.confimarEmailCadastro == null)
      {
        toastr.error('Favor informar o campo Confirmar E-mail.', 'Alerta');
        return;
      }

      if (vm.fornecedor.complemento.emailCadastro != vm.fornecedor.confimarEmailCadastro)
      {
        toastr.error('Favor confirmar novamente o campo Confirmar E-mail.', 'Alerta');
        return;
      }

      if (vm.fornecedor.confirmarSenha == null)
      {
        toastr.error('Favor informar o campo Confirmar Senha.', 'Alerta');
        return;
      }

      if (vm.fornecedor.complemento.senha == null) 
      {
        toastr.error('Favor informar o campo Senha.', 'Alerta');
        return;
      }

      if (vm.fornecedor.complemento.senha != vm.fornecedor.confirmarSenha)
      {
        toastr.error('Favor confirmar novamente o campo Confirmar Senha.', 'Alerta');
        return;
      }

      if (vm.clienteName == '')
      {
        toastr.error('Empresa não identificada.', 'Alerta');
        return;
      }
      
      vm.fornecedor.clienteName = vm.clienteName;

      vm.incluirPromise = $http.post(APP_API_FRND + "/cedente/autocadastro", vm.fornecedor).success(function(response){
          $state.go('confirmar_cadastro.finalizar');
          toastr.info('Cadastro realizado com sucesso.', 'Alerta');
          return response;
      }).error(function(error){
          toastr.error(error, 'Alerta');
          return error;
      });
     
      //$state.go('completar_cadastro.finalizar');
    }

    vm.init();

    vm.consultarCep = function()
    {
      if (vm.fornecedor.endereco.cep != '' && vm.fornecedor.endereco.cep.length > 8)
      {
        var cep = vm.fornecedor.endereco.cep.replace("-", "");

        vm.cepPromise = CepService.consultarCep(cep);

        vm.cepPromise.then(function(result) { 
          vm.fornecedor.endereco.bairro = result.bairro;
          vm.fornecedor.endereco.logradouro = result.logradouro;
          vm.fornecedor.endereco.cidade = result.localidade;
          vm.fornecedor.endereco.complemento = result.complemento;
          vm.fornecedor.endereco.uf = result.uf;
        });
      }          
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioLoginController', ['$scope', '$state', 'toastr', 'AuthService', 
      function($scope, $state, toastr, AuthService)
  {
    var vm = this;

    vm.init = function()
    {
        
    }

    vm.init();

  }]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioConfirmarEmailController', ['$scope', '$state', 'APP_API_FRND', '$http', 'toastr',
      function($scope, $state, APP_API_FRND, $http, toastr)
{
    var vm = this;
    vm.resultado = 0;

    vm.init = function()
    {
        vm.confirmarCodigo($state.params.codigo);
    }

    vm.confirmarCodigo = function(codigo)
    {
        var fornecedor = {
            complemento: {
                codigoAtivacaoEmail: codigo
            }
        };

        vm.verificarPromise = $http.post(APP_API_FRND + "/cedente/verificarconta", fornecedor).success(function(response){
            vm.resultado = 1;
            return response;
        }).error(function(error){
            toastr.error(error, 'Alerta');
            vm.resultado = 2;
            return error;
        });
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioCompletarCadastroController', ['$scope', '$state', '$uibModal', 'toastr', 'APP_API_FRND', '$http',
      function($scope, $state, $uibModal, toastr, APP_API_FRND, $http)
{
    var vm = this;
    vm.file = {};

    vm.arquivos = {
      arq1: '',
      arq2: '',
      arq3: '',
      arq4: '',
      arq5: '',
      arq6: '',
      arq7: '',
      arq8: '',
      arq9: '',
    };

    vm.fornecedor = {
      complemento : {
        pessoaPoliticamenteExposta: 0
      }
    };

    vm.init = function()
    {
      vm.consultar(); 
    }

    vm.consultar = function()
    {
      vm.fornecedor = null;
      
      vm.consultarPromise = $http.get(APP_API_FRND + "/cedente/consultarprecadastro")
        .then(function(response)
        { 
            vm.fornecedor = response.data;
            vm.fornecedor.complemento.pessoaPoliticamenteExposta = '0';

            if (vm.fornecedor.documentos != null)
            {
              for (var i = 0; i <= vm.fornecedor.documentos.length; i++)
              {
                if (vm.fornecedor.documentos[i] != null)
                {
                  switch (vm.fornecedor.documentos[i].tipo)
                  {
                    case 1:
                      vm.arquivos.arq1 = vm.fornecedor.documentos[i].nome;
                      break;
                    case 2:
                      vm.arquivos.arq2 = vm.fornecedor.documentos[i].nome;
                      break;
                    case 3:
                      vm.arquivos.arq3 = vm.fornecedor.documentos[i].nome;
                      break;
                    case 4:
                      vm.arquivos.arq4 = vm.fornecedor.documentos[i].nome;
                      break;  
                    case 5:
                      vm.arquivos.arq5 = vm.fornecedor.documentos[i].nome;
                      break;
                    case 6:
                      vm.arquivos.arq6 = vm.fornecedor.documentos[i].nome;
                      break;
                    case 7:
                      vm.arquivos.arq7 = vm.fornecedor.documentos[i].nome;
                      break;
                    case 8:
                      vm.arquivos.arq8 = vm.fornecedor.documentos[i].nome;
                      break;
                    case 9:
                      vm.arquivos.arq9 = vm.fornecedor.documentos[i].nome;
                      break;
                  }
                }
              }
            }
        }).catch(function (data) {
          $state.go('login.autenticar');
        });
    }

    vm.incluirSocio = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/modal/cadastrar_socio.html',
        controller: 'CadastroIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          tipopessoa: function () {
            return 'Sócio';
          },
          socio: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
          //vm.consultar();
      });
    }

    vm.editarSocio = function(p, index)
    {
      var socio = p;

      var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/modal/cadastrar_socio.html',
        controller: 'CadastroIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          tipopessoa: function () {
            return 'Sócio';
          },
          socio: function () {
            return socio;
          },
          indice: function () {
            return index;
          },
        }
      }).closed.then(function(){
          //vm.consultar();
      });
      
      /*
      return $http.get(APP_API_FRND + "/cedente/consultarsocio/" + p.viewId)
        .then(function(response)
        { 
            var socio = response.data;

            var modalInstance = $uibModal.open({
              templateUrl: 'app/cadastro/modal/cadastrar_socio.html',
              controller: 'CadastroIncluirSocioController',
              controllerAs: 'controller',
              windowClass: 'inmodal',
              backdrop: 'static',
              size: 'lg',
              resolve: {
                fornecedor: function () {
                  return vm.fornecedor;
                },
                tipopessoa: function () {
                  return 'Sócio';
                },
                socio: function () {
                  return socio;
                },
                indice: function () {
                  return index;
                },
              }
            }).closed.then(function(){
                //vm.consultar();
            });
        }).catch(function (data) {
          $state.go('login.autenticar');
        });
      */
    }

    vm.excluirSocio = function(p, index)
    {
      vm.incluirPromise = $http.post(APP_API_FRND + "/cedente/excluirsocio", p).success(function(response){
        toastr.info('Registro excluído com sucesso.', 'Alerta');        
        vm.fornecedor.socios.splice(index, 1);
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.excluirProcurador = function(p, index)
    {
      vm.incluirPromise = $http.post(APP_API_FRND + "/cedente/excluirprocurador", p).success(function(response){
        toastr.info('Registro excluído com sucesso.', 'Alerta');        
        vm.fornecedor.procuradores.splice(index, 1);
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.excluirEmpresa = function(p, index)
    {
      vm.incluirPromise = $http.post(APP_API_FRND + "/cedente/excluirempresa", p).success(function(response){
        toastr.info('Registro excluído com sucesso.', 'Alerta');        
        vm.fornecedor.empresas.splice(index, 1);
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.incluirProcurador = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/modal/cadastrar_socio.html',
        controller: 'CadastroIncluirSocioController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          tipopessoa: function () {
            return 'Procurador';
          },
          socio: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
        //vm.consultar();
      });
    }

    vm.editarProcurador = function(p, index)
    {
      return $http.get(APP_API_FRND + "/cedente/consultarprocurador/" + p.viewId)
        .then(function(response)
        { 
            var procurador = response.data;

            var modalInstance = $uibModal.open({
              templateUrl: 'app/cadastro/modal/cadastrar_socio.html',
              controller: 'CadastroIncluirSocioController',
              controllerAs: 'controller',
              windowClass: 'inmodal',
              backdrop: 'static',
              size: 'lg',
              resolve: {
                fornecedor: function () {
                  return vm.fornecedor;
                },
                tipopessoa: function () {
                  return 'Procurador';
                },
                socio: function () {
                  return procurador;
                },
                indice: function () {
                  return index;
                },
              }
            }).closed.then(function(){
              //vm.consultar();
            });
        }).catch(function (data) {
          $state.go('login.autenticar');
        });
    }

    vm.incluirEmpresa = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/cadastro/modal/cadastrar_empresa.html',
        controller: 'CadastroIncluirEmpresaController',
        controllerAs: 'controller',
        windowClass: 'inmodal',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          fornecedor: function () {
            return vm.fornecedor;
          },
          empresa: function () {
            return null;
          },
          indice: function () {
            return 0;
          },
        }
      }).closed.then(function(){
        //vm.consultar();
      });
    }

    vm.editarEmpresa = function(p, index)
    {
      return $http.get(APP_API_FRND + "/cedente/consultarempresa/" + p.viewId)
        .then(function(response)
        { 
            var empresa = response.data;

            var modalInstance = $uibModal.open({
              templateUrl: 'app/cadastro/modal/cadastrar_empresa.html',
              controller: 'CadastroIncluirEmpresaController',
              controllerAs: 'controller',
              windowClass: 'inmodal',
              backdrop: 'static',
              size: 'lg',
              resolve: {
                fornecedor: function () {
                  return vm.fornecedor;
                },
                empresa: function () {
                  return empresa;
                },
                indice: function () {
                  return index;
                },
              }
            }).closed.then(function(){
              //vm.consultar();
            });

        }).catch(function (data) {
          $state.go('login.autenticar');
        });
    }

    vm.adicionarDocumento = function(tipo)
    {
      var cnab = {};      
      vm.file = {};
      vm.file.nome = vm.selectedTempFile[0].name;
      vm.file.tipo = tipo;
      
      var reader = new FileReader();
      reader.readAsDataURL(vm.selectedTempFile[0], "UTF-8");
      reader.onload = function (evt) {          
          vm.file.base64 = evt.target.result;
          vm.validarPromise = $http.post(APP_API_FRND + "/cedente/adicionardocumento", vm.file).success(function(response){
            toastr.info('Arquivo enviado com sucesso.', 'Alerta');

            switch (tipo)
            {
              case 1:
                vm.arquivos.arq1 = vm.file.nome;
                break;
              case 2:
                vm.arquivos.arq2 = vm.file.nome;
                break;
              case 3:
                vm.arquivos.arq3 = vm.file.nome;
                break;
              case 4:
                vm.arquivos.arq4 = vm.file.nome;
                break;  
              case 5:
                vm.arquivos.arq5 = vm.file.nome;
                break;
              case 6:
                vm.arquivos.arq6 = vm.file.nome;
                break;
              case 7:
                vm.arquivos.arq7 = vm.file.nome;
                break;
              case 8:
                vm.arquivos.arq8 = vm.file.nome;
                break;
              case 9:
                vm.arquivos.arq9 = vm.file.nome;
                break;
            }

            vm.file = {};
            return response;
          }).error(function(error){
            vm.file = {};
            toastr.error(error, 'Alerta');
            return error;
          });
      };
      
      vm.selectedTempFile = [];
      angular.element("input[type='file']").val(null);      
    }

    vm.incluir = function()
    {
      vm.incluirPromise = $http.post(APP_API_FRND + "/cedente/finalizarcadastro", vm.fornecedor).success(function(response){
        
        toastr.info('Cadastro enviado com sucesso.', 'Alerta');
        $state.go('aguardar_aprovacao.finalizar');
        
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

    vm.init();

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioCadastroController', ['$scope', '$state', 'UsuarioService', 
      'toastr',
      function($scope, $state, UsuarioService, toastr)
{
    var vm = this;

    vm.usuario = {};

    vm.incluir = function()
    {
      var usuarioPromise = UsuarioService.insert(vm.usuario);

      usuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário cadastrado com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioAlteracaoSenhaController', ['$scope', '$state', 'toastr', '$http', 'APP_API_FRND',
      function($scope, $state, toastr, $http, APP_API_FRND)
  {
    var vm = this;

    vm.atualizar = function()
    {
      var request = {
        senhaAnterior: vm.oldPassword,
        novaSenha: vm.newPassword
      };

      vm.aprovarAberturaPromise = $http.post(APP_API_FRND + "/cedente/alterarsenha", request).success(function(response){
        toastr.info('Senha atualizada com sucesso.', 'Alerta');   
        $state.go('index.main');          
        return response;
      }).error(function(error){
        toastr.error(error, 'Alerta');
        return error;
      });
    }

}]);

'use strict';

angular.module('inspinia')
  .controller('UsuarioAlteracaoController', ['$scope', '$state', 'UsuarioService', 
      'toastr',
      function($scope, $state, UsuarioService, toastr)
  {
    var vm = this;

    vm.usuario = {};
    vm.usuarioParam = $state.params.obj;

    vm.consultar = function()
    {
      var usuarioConsultaPromise = UsuarioService.get(vm.usuarioParam.ViewId);

      usuarioConsultaPromise.then(function(result) {  
        vm.usuario = result;
      });
    }

    vm.alterar = function()
    {
      var usuarioPromise = UsuarioService.update(vm.usuarioParam.ViewId, vm.usuario);

      usuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário alterado com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

    vm.excluir = function()
    {
      var deleteUsuarioPromise = UsuarioService.delete(vm.usuarioParam);

      deleteUsuarioPromise.then(function(result) {  
        if (result.data.Status)
        {
          toastr.info('Usuário excluído com sucesso!', 'Usuário');
          $state.go('index.pesquisarusuario');
        }
        else
        {
          toastr.error(result.data.Text, 'Usuário');
        }
      });
    }

    vm.init = function()
    {
      if (vm.usuarioParam == null)
      {
        $state.go('index.pesquisarusuario');
      }
      else
      {
        vm.consultar();
      }
    }

    vm.init();

}]);

angular.module('inspinia')
    .factory('AuthService', AuthService);

function AuthService ($localStorage, $q) {
    return {
    getToken : function () {
        return $localStorage.token;
    },
    setToken: function (token) {
        $localStorage.token = token;
    },
    getUser : function () {
        return $localStorage.user;
    },
    setUser: function (user) {
        $localStorage.user = user;
    },
    getEmpresa : function () {
        return $localStorage.empresa;
    },
    setEmpresa: function (empresa) {
        $localStorage.empresa = empresa;
    },
    getEmpresaMainId : function () {
        return $localStorage.empresaMainId;
    },
    setEmpresaMainId: function (empresaMainId) {
        $localStorage.empresaMainId = empresaMainId;
    },
    getRole : function () {
        return $localStorage.role;
    },
    setRole: function (role) {
        $localStorage.role = role;
    },
    getMenu : function () {
        return $localStorage.menu;
    },
    setMenu: function (menu) {
        $localStorage.menu = menu;
    },
    getPentahoCodigo : function () {
        return $localStorage.agfnPentahoCodigo;
    },
    setPentahoCodigo: function (codigo) {
        $localStorage.agfnPentahoCodigo = codigo;
    },
    getPentahoRelatorios : function () {
        return $localStorage.agfnPentahoRelatorios;
    },
    setPentahoRelatorios: function (codigo) {
        $localStorage.agfnPentahoRelatorios = codigo;
    },
    getPentahoLogo : function () {
        return $localStorage.agfnPentahoLogo;
    },
    setPentahoLogo: function (codigo) {
        $localStorage.agfnPentahoLogo = codigo;
    },
    getUrlPentaho : function () {
        return $localStorage.urlPentaho;
    },
    setUrlPentaho: function (codigo) {
        $localStorage.urlPentaho = codigo;
    },
    getCodigoVmoney : function () {
        return $localStorage.codigoVMoneyCedente;
    },
    setCodigoVmoney: function (codigo) {
        $localStorage.codigoVMoneyCedente = codigo;
    },
    getUserEmail : function () {
        return $localStorage.userEmail;
    },
    setUserEmail: function (email) {
        $localStorage.userEmail = email;
    },
    getUsoDeBoleto: function () {
        return $localStorage.usoDeBoleto;
    },    
    setUsoDeBoleto: function (id) {
        $localStorage.usoDeBoleto = id;
    }, 
    getHorarioLimite: function () {
        return $localStorage.horarioLimite;
    },    
    setHorarioLimite: function (horarioLimite) {
        $localStorage.horarioLimite = horarioLimite;
    },  
    getTipoDocumentoDescricao: function() {
        return tipoDocumentoDescricao;
    },
    setTipoDocumentoDescricao: function(value) {
        tipoDocumentoDescricao = value;
    },  
    getDigitarLiberado : function () {
        return $localStorage.digitarLiberado;
    },
    setDigitarLiberado: function (value) {
        $localStorage.digitarLiberado = value;
    },   
    getCnabLiberado : function () {
        return $localStorage.cnabLiberado;
    },
    setCnabLiberado: function (value) {
        $localStorage.cnabLiberado = value;
    },          
    getBoletoLiberado : function () {
        return $localStorage.boletoLiberado;
    },
    setBoletoLiberado: function (value) {
        $localStorage.boletoLiberado = value;
    },
    logout : function (data) {
        delete $localStorage.token;
        delete $localStorage.user;
        delete $localStorage.role;
        delete $localStorage.agfnPentahoLogo;
        delete $localStorage.userEmail;
        delete $localStorage.usoDeBoleto;
        delete $localStorage.horarioLimite;
        delete $localStorage.tipoDocumentoDescricao;
        delete $localStorage.boletoLiberado;
        $q.when();
    }
    };
}
angular.module('inspinia')
    .factory('AuthInterceptor', AuthInterceptor)
    .config(function($httpProvider) {
    $httpProvider.interceptors.push('AuthInterceptor');
});

function AuthInterceptor ($location, AuthService, $q) {
    return {
    request: function(config) {
        config.headers = config.headers || {};

        if (!config.skipInterceptor && AuthService.getToken() && !config.url.includes('viacep.com.br')) {
            config.headers['Authorization'] = 'Bearer ' + AuthService.getToken();
        }
        
        return config;
    },

    responseError: function(response) {
        if (response.status === 401 || response.status === 403) {
        $location.path('/login');
        }

        return $q.reject(response);
    }
    }
}
angular.module('inspinia')
  .controller('CadastroSacadoPesquisaController', ['$scope', '$state', 'toastr', 'PagerService', '$http','APP_API_FRND',
      function($scope, $state, toastr, PagerService, $http, APP_API_FRND) 
{
    var vm = this;    
    vm.registros = null;
    vm.filtro = {
        codigo: '',
        nome: '',
        cnpj: ''
    }

    vm.indexPage = 1;

    $scope.pagination = {
        current: 1,
        perPage: 15,
        maxSize: 5,
        totalItems: 0,
    };

    vm.init = function()
    {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.pesquisar = function(perPage, index, orderBy, filter)
    {
        vm.registros = null;

        var codigo = "0";
        var nome = "0";
        var cnpj = "0";

        if (vm.filtro == null)
        {
            vm.filtro = {
                codigo: '',
                nome: '',
                cnpj: '',
                index: index,
                page: perPage
            }
        }

        if (vm.filtro.codigo != null && vm.filtro.codigo != '')
        {
            codigo = vm.filtro.codigo;
        }
        if (vm.filtro.nome != null && vm.filtro.nome != '')
        {
            nome = vm.filtro.nome;
        }
        if (vm.filtro.cnpj != null && vm.filtro.cnpj != '')
        {
            cnpj = vm.filtro.cnpj;
        }

        vm.filtro.page = index;
        vm.filtro.perPage = perPage;
        
        //vm.consultarPromise = $http.get(APP_API_FRND + "/sacado/pesquisarPage/" + index + "/" + perPage + "/" + codigo + "/" + nome + "/" + cnpj);
        
        // pesquisarPage 
        vm.consultarPromise = $http.post(APP_API_FRND + "/sacado/pesquisarPagePorCedente", vm.filtro).success(function(response){
            vm.registros = response.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = (response.pages * perPage);
        }).error(function(error){
            return error;
        });

        /*
        vm.consultarPromise = $http.post(APP_API_FRND + "/sacado/pesquisarPage", vm.filtro);

        vm.consultarPromise.then(function(response)
        {             
            vm.registros = response.data.registros;
            vm.items = vm.registros;

            $scope.pagination.totalItems = response.data.pages;
        });
        */
    }
    
    $scope.onSearch = function() {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    $scope.onPerPageChange = function(result) {
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.consultar = function(sacado)
    {
        $state.go('index.cadastro_sacado_consulta', {obj: sacado});
    }

    vm.cadastrar = function()
    {
        $state.go('index.cadastro_sacado');
    }

    vm.filtrarPesquisa = function()
    {
        $scope.pagination.perPage,$scope.pagination.current = 1;
        
        vm.pesquisar($scope.pagination.perPage,$scope.pagination.current -1 ,"",$scope.pagination.search);
    }

    vm.init();

    vm.getTotalPages = function() {
        return new Array(7);   
    }

    vm.showhide = function (icon, box) {
        var icon = angular.element(document.getElementById(icon));
        icon.toggleClass('fa-chevron-up').toggleClass('fa-chevron-down');
        var elm = angular.element(document.getElementById(box));
        elm.slideToggle(200);
    };

}]);
'use strict';

angular.module('inspinia')
  .controller('MainController', ['$state', 'AuthService', 'toastr', '$cookieStore', 'APP_API_FRND', '$http', '$uibModal', '$location', 'APP_SUBDOMAIN',
    function ($state, AuthService, toastr, $cookieStore, APP_API_FRND, $http, $uibModal, $location, APP_SUBDOMAIN) {

      var vm = this;
      vm.usuario = {};
      vm.default = '';
      vm.autoRegister = true;
      vm.isConsultorNegocio = false;
      vm.clienteName = '';
      vm.usuariossuporte = [];
      vm.isUserSuporte = false;
      vm.usuarioSuporte = null;

      vm.userName = AuthService.getUser();
      vm.empresaName = AuthService.getEmpresa();
      vm.pentahoCodigoCliente = AuthService.getPentahoCodigo();
      vm.pentahoRelatorios = AuthService.getPentahoRelatorios();
      vm.pentahoLogo = AuthService.getPentahoLogo();
      vm.empresaMainId = AuthService.getEmpresaMainId();
      vm.urlPentaho = AuthService.getUrlPentaho();
      vm.usoDeBoleto = AuthService.getUsoDeBoleto();
      vm.digitarLiberado = AuthService.getDigitarLiberado();
      vm.cnabLiberado = AuthService.getCnabLiberado();
      vm.boletoLiberado = AuthService.getBoletoLiberado();

      vm.loginSuporte = function() {

      }

      vm.realizarLogin = function (login, pwd, cedenteId, host) {
        var data = {
          login: login,
          senha: pwd,
          host: host
        }

        if (cedenteId) {
          data.cedenteId = cedenteId;
        }

        if (vm.isUserSuporte) {
          if (vm.usuarioSuporte == null) {
            alert('Usuário não selecionado.');
            return;
          }
          data.loginSuporte = vm.usuarioSuporte.email;
        }

        return $http.post(APP_API_FRND + "/auth/cedente/login", data).then(
          function (response) {
            if (response.data.authenticated) {
              AuthService.setToken(response.data.accessToken);
              AuthService.setUser(response.data.userName);
              AuthService.setUserEmail(login);
              AuthService.setEmpresa(response.data.empresa);
              AuthService.setPentahoCodigo(response.data.pentahoCodigoCliente);
              AuthService.setPentahoRelatorios(response.data.pentahoRelatorios);
              AuthService.setCodigoVmoney(response.data.codigoCedenteVmoney);
              AuthService.setEmpresaMainId(response.data.empresaMainId);
              AuthService.setPentahoLogo(response.data.pentahoLogo);
              AuthService.setUrlPentaho(response.data.urlPentaho);
              AuthService.setUsoDeBoleto(response.data.usoDeBoleto);
              AuthService.setHorarioLimite(response.data.horarioLimite);
              AuthService.setDigitarLiberado(response.data.digitarLiberado);
              AuthService.setCnabLiberado(response.data.cnabLiberado);
              AuthService.setBoletoLiberado(response.data.boletoLiberado);
            }

            //AuthService.setRole(response.data.role);
            return response;
          },
          function (error) {
            return error;
          }
        )
      }

      vm.login = function () {
        if (vm.usuario.Login == null || vm.usuario.Login == '') {
          toastr.error('Informe o Login da empresa.', 'Login');
          return;
        }

        if (vm.usuario.Senha == null || vm.usuario.Senha == '') {
          toastr.error('Informe a Senha.', 'Login');
          return;
        }

        $cookieStore.put('lastLoginFornecedor', vm.usuario.Login);

        vm.loginPromise = vm.realizarLogin(vm.usuario.Login, vm.usuario.Senha, 0, vm.usuario.Host);

        vm.loginPromise.then(function (result) {
          if (result.data.multipleCedentes) {
            var modalInstance = $uibModal.open({
              templateUrl: 'app/usuario/modal/selecionar_cedente/index.html',
              controller: 'SelecionarCedenteController',
              controllerAs: 'controller',
              windowClass: 'inmodal',
              size: 'md',
              resolve: {
                cedentes: function () {
                  return result.data.cedentes;
                }
              }
            });

            modalInstance.result.then(function (selectedCedenteId) {
              if (selectedCedenteId) {
                vm.realizarLogin(vm.usuario.Login, vm.usuario.Senha, selectedCedenteId, vm.usuario.Host).then(function (newResult) {
                  vm.processarLogin(newResult);
                });
              }
            });
          }
          else {
            vm.processarLogin(result);
          }
        });
      }

      vm.processarLogin = function (result) {
        if (result.data.error == null && result.data.authenticated) {
          vm.default = result.data.default;

          vm.userName = AuthService.getUser();
          vm.empresaName = AuthService.getEmpresa();
          vm.menus = AuthService.getMenu();
          vm.pentahoCodigoCliente = AuthService.getPentahoCodigo();
          vm.pentahoRelatorios = AuthService.getPentahoRelatorios();

          // console.log("relatorios", vm.pentahoRelatorios);

          vm.pentahoLogo = AuthService.getPentahoLogo();
          vm.codigoCedenteVmoney = AuthService.getCodigoVmoney();
          vm.empresaMainId = AuthService.getEmpresaMainId();
          vm.usoDeBoleto = AuthService.getUsoDeBoleto();
          vm.digitarLiberado = AuthService.getDigitarLiberado();
          vm.cnabLiberado = AuthService.getCnabLiberado();
          vm.boletoLiberado = AuthService.getBoletoLiberado();

          //vm.role = AuthService.getRole();      

          if (result.data.status == 0) {
            $state.go("completar_cadastro.finalizar");
          }
          else if (result.data.status == 1) {
            $state.go("completar_cadastro.finalizar");
          }
          else if (result.data.status == 2) {
            $state.go("aguardar_aprovacao.finalizar");
            //$state.go("completar_cadastro.finalizar");
          }
          else if (result.data.status == 3) {
            $state.go("aguardar_aprovacao.finalizar");
          }
          else if (result.data.status == 4) {
            $state.go("aguardar_aprovacao.finalizar");
          }
          else {
            $state.go("index.main");
          }
        }
        else {
          if (result.data.usersuporte) {
            vm.isUserSuporte = true;
            vm.usuariossuporte = result.data.usuarios || [];
            vm.usuarioSuporte = vm.usuariossuporte.length > 0 ? vm.usuariossuporte[0] : null;
          }
          else {
            toastr.error(result.data.message, 'Login');
          }
        }
      }

      vm.init = function () {
        try {
          var emailParam = $location.search().e;
          var pwdParam = $location.search().p;

          if (emailParam != null && emailParam != '' && pwdParam != null && pwdParam != '') {
            var email = atob(emailParam);
            var senha = atob(pwdParam);

            if (email != null && senha != null) {
              vm.usuario = {
                Login: email,
                Senha: senha,
              };

              vm.login();
            }
          }
        }
        catch (erro) {

        }

        //alert($location.absUrl().split(':')[1].replace('//',''));

        if ($cookieStore.get('lastLoginFornecedor') != null) {
          vm.usuario.Login = $cookieStore.get('lastLoginFornecedor');
        }

        vm.s_subdomain();
        vm.consultarLogo();

      }

      vm.consultarLogo = function () {
        return $http.get(APP_API_FRND + "/empresa/consultarlogo", { responseType: 'arraybuffer' })
          .then(function (response) {

            if (response.data) {
              var blob = new Blob([response.data], { type: 'image/png' });
              vm.logoUrl = (window.URL || window.webkitURL).createObjectURL(blob);
            } else {
              vm.logoUrl = null;
            }
          }, function (error) {
            vm.logoUrl = 'assets/images/icons/icon_rb.png';

          });
      };

      vm.s_subdomain = function () {
        var host = $location.host();
        if (host == 'localhost') {
          host = APP_SUBDOMAIN;
        }

        if (host.indexOf('.') < 0) {
          vm.usuario.Host = host;
          vm.logoempresa = 'assets/images/icons/logo.png';
        }
        else {
          var subdomain = host.split('.')[0];
          vm.usuario.Host = subdomain;

          vm.logoempresa = 'assets/images/icons/logo.png';

          if (subdomain == 'mondocapital') {
            vm.logoempresa = 'assets/images/icons/logo_mondo_capital.png';
            vm.autoRegister = true;
            vm.clienteName = 'mondocapital';
          }
          else if (subdomain == 'mansbank') {
            vm.logoempresa = 'assets/images/icons/mansbank.png';
            vm.autoRegister = false;
            vm.isConsultorNegocio = true;
          }
          else if (subdomain == 'cnegocios') {
            vm.autoRegister = false;
            vm.isConsultorNegocio = true;
          }
          else if (subdomain == 'araguaya' || subdomain == 'hmgaraguaya') {
            vm.autoRegister = true;
            vm.isConsultorNegocio = false;
            vm.clienteName = 'araguaya';
          }
          else if (subdomain == 'mlbank' || subdomain == 'hmgmlbank') {
            vm.autoRegister = true;
            vm.isConsultorNegocio = false;
            vm.clienteName = 'mlbank';
          }
        }
      }

      vm.init();

      vm.criarConta = function () {
        $state.go("novo_cadastro.usuario_nova_conta");
      }

      vm.esqueciSenha = function () {
        var modalInstance = $uibModal.open({
          templateUrl: 'app/usuario/modal/solicitar_reset_senha/index.html',
          controller: 'EsqueciMinhaSenhaController',
          controllerAs: 'controller',
          windowClass: 'inmodal',
          size: 'md',
        }).closed.then(function () {

        });
      }



    }]);

angular
  .module('inspinia')
  .controller('SelecionarCedenteController', ['$uibModalInstance', 'cedentes', function ($uibModalInstance, cedentes) {
    var vm = this;
    vm.cedentes = cedentes;
    vm.selectedCedenteId = null;

    if (vm.cedentes && vm.cedentes.length > 0) {
      vm.selectedCedenteId = vm.cedentes[0].id; // Default to first
    }

    vm.confirm = function () {
      if (vm.selectedCedenteId) {
        $uibModalInstance.close(vm.selectedCedenteId);
      }
    };

    vm.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };
  }]);

'use strict';

angular.module('inspinia')
  .controller('HomeController', ['$state', '$scope', 'toastr', '$uibModal', 'AuthService',
  function ($state, $scope, toastr, $uibModal, AuthService) {

    var vm = this;

    vm.init = function()
    {
      vm.userName = AuthService.getUser();
      vm.empresaName = AuthService.getEmpresa();

      /*
      vm.indicadoresPromise = AntecipacaoService.getIndicadoresPrincipal();

      vm.indicadoresPromise.then(function(result) {  
        if (result.status)
        {
          vm.indicadores = result.data;
        }
      });

      vm.operacoesPendentesPromise = AntecipacaoService.listarPendentes();

      vm.operacoesPendentesPromise.then(function(result) {  
        if (result.status)
        {
          vm.operacoesPendentes = result.data;
        }
      });
      */
    }

    vm.modalDetalheSolicitacao = function()
    {
      var modalInstance = $uibModal.open({
        templateUrl: 'app/home/modal/detalhesSolicitacao.html',
        controllerAs: 'arquivoInfo',
        windowClass: 'inmodal',
        size: 'lg',
        resolve: {
         }
      });
    }

    vm.init();

  }]);

angular
.module('inspinia').factory("HomeService", ['$http', 'APP_ROOT', 'AuthService', 
    function ($http, APP_ROOT, AuthService) {
    return {
        getQuantidade: function () {
            return $http.get(APP_ROOT + "/home/GetQuantidade")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getAtendimentosMapa: function () {
            return $http.get(APP_ROOT + "/home/GetAtendimentosMapa")
            .then(function(response)
            { 
                return response.data;
            });
        },
        getContatosMaps: function () {
            return $http.get(APP_ROOT + "/home/GetContatosMapa")
            .then(function(response)
            { 
                return response.data;
            });
        }
    }
}]);
angular
.module('inspinia').factory("FomentoService", ['$http', 'APP_ROOT', 'AuthService', 
    function ($http, APP_ROOT, AuthService) {
    return {
        login: function(login, pwd){
            var data = {
                login: login,
                password: pwd
            }
            return $http.post(APP_ROOT + "/cliente/login", data).then(
                function(response){
                    AuthService.setToken(response.data.accessToken);
                    AuthService.setUser(response.data.userName);
                    AuthService.setEmpresa(response.data.empresa);
                    AuthService.setRole(response.data.role);
                    return response;
                },
                function (error) {
                    return error;
                }
            )
        }
    }
}]);
angular
.module('inspinia').factory("CepService", ['$http',
    function ($http) {
    return {
        consultarCep: function (cep) {
            return $http.get("https://viacep.com.br/ws/" + cep + "/json/")
            .then(function(response)
            { 
                return response.data;
            });
        },
    }
}]);
  angular.module('inspinia')
   .factory('modalService', ['$uibModal', '$sce', function($uibModal, $sce) {
       return {
           openModal: function(url) {
               var trustedUrl = $sce.trustAsResourceUrl(url);  // Marca a URL como segura
               
               $uibModal.open({
                   animation: true,
                   templateUrl: 'app/modal-template.html',
                   controller: ['$scope', '$uibModalInstance', function($scope, $uibModalInstance) {
                       $scope.urlToLoad = trustedUrl;  // Passa a URL segura para o modal

                       $scope.closeModal = function() {
                           $uibModalInstance.dismiss('close');
                       };
                   }],
                   size: 'lg',
                   backdrop: 'static',
                   keyboard: true
               });
           }
       };
   }]);


/**
 * INSPINIA - Responsive Admin Theme
 * 2.7.1
 *
 * Custom scripts
 */

angular.element(document).ready(function ($timeout) {


  // Full height of sidebar
  function fix_height() {
    var heightWithoutNavbar = angular.element("body > #wrapper").height() - 61;
    angular.element(".sidebar-panel").css("min-height", heightWithoutNavbar + "px");

    var navbarHeight = angular.element('nav.navbar-default').height();
    var wrapperHeight = angular.element('#page-wrapper').height();

    if(navbarHeight > wrapperHeight){
      angular.element('#page-wrapper').css("min-height", navbarHeight + "px");
    }

    if(navbarHeight < wrapperHeight){
      angular.element('#page-wrapper').css("min-height", angular.element(window).height()  + "px");
    }

    if (angular.element('body').hasClass('fixed-nav')) {
      if (navbarHeight > wrapperHeight) {
        angular.element('#page-wrapper').css("min-height", navbarHeight  + "px");
      } else {
        angular.element('#page-wrapper').css("min-height", angular.element(window).height() - 60 + "px");
      }
    }

  }

  angular.element(window).bind("load resize scroll", function() {
    if(!angular.element("body").hasClass('body-small')) {
      fix_height();
    }
  });

  // Move right sidebar top after scroll
  angular.element(window).scroll(function(){
    if (angular.element(window).scrollTop() > 0 && !angular.element('body').hasClass('fixed-nav') ) {
      angular.element('#right-sidebar').addClass('sidebar-top');
    } else {
      angular.element('#right-sidebar').removeClass('sidebar-top');
    }
  });

  $timeout(function(){
    fix_height();
  });

  // Minimalize menu when screen is less than 768px
  angular.element(window).bind("load resize", function() {
    if (angular.element(document).width() < 769) {
      angular.element('body').addClass('body-small')
    } else {
      angular.element('body').removeClass('body-small')
    }
  })

});

(function() {
  'use strict';

  angular
    .module('inspinia')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log) {

    $log.debug('runBlock end');
  }

})();

(function() {
  'use strict';

  angular
    .module('inspinia')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider

      .state('login', {
        abstract: true,
        url: "/login",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })

      // Novo Cadastro
      .state('novo_cadastro', {
        abstract: true,
        url: "/novo_cadastro",
        templateUrl: "app/usuario/nova_conta.html",
        controller: 'UsuarioNovaContaController',
        controllerAs: 'controller',
      })
      .state('novo_cadastro.usuario_nova_conta', {        
        url: "/usuario_nova_conta",        
      })

      // Ativar conta
      .state('account', {
        abstract: true,
        url: "/account",
        templateUrl: "app/usuario/ativacao_conta.html",
        controller: 'UsuarioConfirmarEmailController',
        controllerAs: 'controller',
      })
      .state('account.confirm', {        
        url: "/confirm/:codigo", 
        params: {
          codigo: null
        }       
      })

      // Reset senha
      .state('password', {
        abstract: true,
        url: "/password",
        templateUrl: "app/cadastro/reset_senha/index.html",
        controller: 'UsuarioResetSenhaController',
        controllerAs: 'controller',
      })
      .state('password.reset', {        
        url: "/reset/:codigo", 
        params: {
          codigo: null
        }       
      })

      // Confirmar Cadastro
      .state('confirmar_cadastro', {
        abstract: true,
        url: "/confirmar_cadastro",
        templateUrl: "app/usuario/confirmar_cadastro.html",
        controller: 'UsuarioNovaContaController',
        controllerAs: 'controller',
      })
      .state('confirmar_cadastro.finalizar', {        
        url: "/finalizar",
      })

      // Finalizar Cadastro
      .state('completar_cadastro', {
        abstract: true,
        url: "/completar_cadastro",
        templateUrl: "app/usuario/completar_cadastro.html",
        controller: 'UsuarioCompletarCadastroController',
        controllerAs: 'controller',
      })
      .state('completar_cadastro.finalizar', {        
        url: "/finalizar",
      })

      .state('aguardar_aprovacao', {
        abstract: true,
        url: "/aguardar_aprovacao",
        templateUrl: "app/cadastro/aguardar_aprovacao/index.html",
        controller: 'UsuarioAguardarAprovacaoController',
        controllerAs: 'controller',
      })
      .state('aguardar_aprovacao.finalizar', {        
        url: "/finalizar",
      })

      .state('index.main', {
        url: "/main",
        templateUrl: "app/main/main.html",
        controller: 'HomeController',
        controllerAs: 'home',
        data: { pageTitle: 'Dashboard de Projetos' }
      })

      .state('index.alterarsenha', {
        url: "/alterarsenha",
        templateUrl: "app/usuario/alterarsenha.html",
        controller: 'UsuarioAlteracaoSenhaController',
        controllerAs: 'controller',
        data: { pageTitle: 'Alterar Senha' }
      })

      // Email > Carteira Dinamica
      .state('index.email_carteira_dinamica', {
        url: "/email_carteira_dinamica",
        templateUrl: "app/email/carteira/dinamica/index.html",
        controller: 'EmailCarteiraDinamicaController',
        controllerAs: 'controller'
      })

      // Retorno ao Cliente > Carteira Dinamica
      .state('index.retorno_cnab_cliente', {
        url: "/retorno_cnab_cliente",
        templateUrl: "app/cnab/retornocliente/index.html",
        controller: 'RetornoCnabsController',
        controllerAs: 'controller'
      })      

      // Login
      .state('login.autenticar', {
        url: "/autenticar",
        controller: 'UsuarioLoginController',
        controllerAs: 'usuarioLogin',
        templateUrl: "app/usuario/autenticar.html"
      })

      // INVOICE > IMPORTAR TITULOS LOTE
      .state('index.recebiveis_importacao_lote', {
        url: "/recebiveis_importacao_lote",
        templateUrl: "app/invoice/importarLote/index.html",
        controller: 'InvoiceNfeImportarLoteController',
        controllerAs: 'controller'
      })

       // INVOICE > IMPORTAR TITULOS CNAB
       .state('index.recebiveis_importacao_cnab', {
        url: "/recebiveis_importacao_cnab",
        templateUrl: "app/invoice/importarCnab/index.html",
        controller: 'ImportarCnabController',
        controllerAs: 'controller'
      })     

      // INVOICE > DIGITACAO DE TITULOS
      .state('index.recebiveis_digitacao_titulo', {
        url: "/recebiveis_digitacao_titulo",
        templateUrl: "app/invoice/digitacao/index.html",
        controller: 'InvoiceDigitacaoTituloController',
        controllerAs: 'controller'
      })
      /*
      // INVOICE > CNAB Sincronizado
      .state('index.cnabSincronizado', {
        url: '/cnab-sincronizado',
        templateUrl: 'app/invoice/cnabSincronizado/index.html',
        controller: 'CnabSincronizadoController',
        controllerAs: 'controller',
        data: {
            pageTitle: 'CNAB Sincronizado'
        }
      })
      */


      // Fornecedor / Recebiveis / Importacao
      .state('index.fornecedor_importacao_faturas', {
        url: "/fornecedor_importacao_faturas",
        templateUrl: "app/fornecedor/recebiveis/importacao/index.html",
        controller: 'RecebiveisImportacaoController',
        controllerAs: 'controller'
      })
      // Fornecedor / Recebiveis / Faturas
      .state('index.fornecedor_recebiveis_faturas', {
        url: "/fornecedor_recebiveis_faturas",
        templateUrl: "app/fornecedor/recebiveis/faturas/index.html",
        controller: 'FaturasDisponiveisController',
        controllerAs: 'controller'
      })
      // Fornecedor / Antecipacoes / Minhas antecipacoes
      .state('index.fornecedor_antecipacao_minhasantec', {
        url: "/fornecedor_antecipacao_minhasantec",
        templateUrl: "app/fornecedor/antecipacao/minhas_antecipacoes/index.html",
        controller: 'MinhasAntecipacoesController',
        controllerAs: 'controller'
      })

      // RELATORIOS
      .state('index.relatorio_pentaho', {
        url: "/relatorio_pentaho/:report/:name",
        templateUrl: "app/relatorio/teste/index.html",
        controller: 'RelatorioTesteController',
        controllerAs: 'controller',
        params: {
          report: null,
          name: null
        },
      })

      // CADASTRO > SACADO > INDEX
      .state('index.cadastro_sacado', {
        url: "/cadastro_sacado",
        templateUrl: "app/sacado/cadastro/index.html",
        controller: 'SacadoCadastroController',
        controllerAs: 'controller'
      })
      .state('index.cadastro_sacado_pesquisa', {
        url: "/cadastro_sacado_pesquisa",
        templateUrl: "app/sacado/index.html",
        controller: 'CadastroSacadoPesquisaController',
        controllerAs: 'controller'
      })
      .state('index.cadastro_sacado_consulta', {
        url: "/cadastro_sacado_consulta",
        templateUrl: "app/sacado/consulta/index.html",
        controller: 'SacadoConsultaController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.sacado_cadastro_usuario', {
        url: "/sacado_cadastro_usuario",
        templateUrl: "app/sacado/consulta/usuario/cadastro/index.html",
        controller: 'SacadoCadastrarUsuarioController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })
      .state('index.sacado_consulta_usuario', {
        url: "/sacado_consulta_usuario",
        templateUrl: "app/sacado/consulta/usuario/consulta/index.html",
        controller: 'SacadoConsultarUsuarioController',
        controllerAs: 'controller',
        params: {
          obj: null
        },
      })

      // Usuarios      
      /*
      .state('index.pesquisar_usuario', {
        url: "/pesquisar_usuario",
        templateUrl: "app/admin/usuario/pesquisar/index.html",
        controller: 'AdminUsuarioPesquisarController',
        controllerAs: 'controller',
      })
      .state('index.cadastrarusuario', {
        url: "/cadastrarusuario",
        templateUrl: "app/usuario/cadastrar.html",
        controller: 'UsuarioCadastroController',
        controllerAs: 'usuarioCadastro',
      })
      */

      /*
      .state('index.pesquisarusuario', {
        url: "/pesquisarusuario",
        templateUrl: "app/usuario/pesquisar.html",
        controller: 'UsuarioPesquisaController',
        controllerAs: 'usuarioPesquisa',
        data: { pageTitle: 'Pesquisar usuários' }
      })
      .state('index.cadastrarusuario', {
        url: "/cadastrarusuario",
        templateUrl: "app/usuario/cadastrar.html",
        controller: 'UsuarioCadastroController',
        controllerAs: 'usuarioCadastro',
        data: { pageTitle: 'Cadastrar Usuário' }
      })
      .state('index.alterarusuario', {
        url: "/alterarusuario",
        templateUrl: "app/usuario/alterar.html",
        controller: 'UsuarioAlteracaoController',
        controllerAs: 'usuarioAlteracao',
        params: {
          obj: null
        },
        data: { pageTitle: 'Editar Usuário' }
      })
      */

      // Index
      .state('index', {
        abstract: true,
        url: "/index",
        templateUrl: "app/components/common/content.html"
      })

      // landing
      .state('landing', {
        url: "/landing",
        templateUrl: "app/landing/landing.html",
        data: { pageTitle: 'Landing page', specialClass: 'landing-page' }
      })

      // Tests
      .state('index.minor', {
        url: "/minor",
        templateUrl: "app/minor/minor.html",
        data: { pageTitle: 'Example view' }
      });

      $urlRouterProvider.otherwise('/login/autenticar');
  }

})();

angular
    .module('inspinia')
    .factory('PagerService', PagerService)
    // SUBDOMAIN
    .constant('APP_SUBDOMAIN', "")

    // LOCAL
    //.constant('APP_API_FRND', "https://localhost:44370/api")

    // PRODUCAO
    .constant('APP_API_FRND', "https://producao.moneynow.com.br/api")


//.constant('APP_API_FRND', "https://apimoneynowv3-gkctdga9fncddea8.brazilsouth-01.azurewebsites.net/api")

function PagerService() {
    // service definition
    var service = {};

    service.GetPager = GetPager;

    return service;

    // service implementation
    function GetPager(totalItems, currentPage, pageSize) {
        // default to first page
        currentPage = currentPage || 1;

        // default page size is 5
        pageSize = pageSize || 20;

        // calculate total pages
        var totalPages = Math.ceil(totalItems / pageSize);

        var startPage, endPage;
        if (totalPages <= 10) {
            // less than 10 total pages so show all
            startPage = 1;
            endPage = totalPages;
        } else {
            // more than 10 total pages so calculate start and end pages
            if (currentPage <= 6) {
                startPage = 1;
                endPage = 10;
            } else if (currentPage + 4 >= totalPages) {
                startPage = totalPages - 9;
                endPage = totalPages;
            } else {
                startPage = currentPage - 5;
                endPage = currentPage + 4;
            }
        }

        // calculate start and end item indexes
        var startIndex = (currentPage - 1) * pageSize;
        var endIndex = Math.min(startIndex + pageSize - 1, totalItems - 1);

        // create an array of pages to ng-repeat in the pager control
        var pages = _.range(startPage, endPage + 1);

        // return object with all pager properties required by the view
        return {
            totalItems: totalItems,
            currentPage: currentPage,
            pageSize: pageSize,
            totalPages: totalPages,
            startPage: startPage,
            endPage: endPage,
            startIndex: startIndex,
            endIndex: endIndex,
            pages: pages
        };
    }
};

angular.module('inspinia').value('cgBusyDefaults', {
    message: 'Carregando',
    templateUrl: 'app/components/common/loading.html'
});

angular.module('inspinia').directive('icheck', icheck);

angular.module('inspinia')
    .config([
        '$compileProvider',
        function ($compileProvider) {
            $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|chrome-extension|data|image):/);
            // Angular before v1.2 uses $compileProvider.urlSanitizationWhitelist(...)
        }
    ])
    .config(['$provide', function ($provide) {
        $provide.decorator('$locale', ['$delegate', function ($delegate) {
            $delegate.NUMBER_FORMATS.DECIMAL_SEP = ',';
            $delegate.NUMBER_FORMATS.GROUP_SEP = '.';
            return $delegate;
        }]);
    }]);

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function ($scope, element, $attrs, ngModel) {
            return $timeout(function () {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function (newValue) {
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function (event) {
                    if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                        $scope.$apply(function () {
                            return ngModel.$setViewValue(event.target.checked);
                        });
                    }
                    if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                        return $scope.$apply(function () {
                            return ngModel.$setViewValue(value);
                        });
                    }
                });
            });
        }
    };
}

var angles = angular.module("angles", []);

angles.chart = function (type) {
    return {
        restrict: "A",
        scope: {
            data: "=",
            options: "=",
            id: "@",
            width: "=",
            height: "=",
            resize: "=",
            chart: "@",
            segments: "@",
            responsive: "=",
            tooltip: "=",
            legend: "="
        },
        link: function ($scope, $elem) {
            var ctx = $elem[0].getContext("2d");
            var autosize = false;

            $scope.size = function () {
                if ($scope.width <= 0) {
                    $elem.width($elem.parent().width());
                    ctx.canvas.width = $elem.width();
                } else {
                    ctx.canvas.width = $scope.width || ctx.canvas.width;
                    autosize = true;
                }

                if ($scope.height <= 0) {
                    $elem.height($elem.parent().height());
                    ctx.canvas.height = ctx.canvas.width / 2;
                } else {
                    ctx.canvas.height = $scope.height || ctx.canvas.height;
                    autosize = true;
                }
            }

            $scope.$watch("data", function (newVal, oldVal) {
                if (chartCreated)
                    chartCreated.destroy();

                // if data not defined, exit
                if (!newVal) {
                    return;
                }
                if ($scope.chart) { type = $scope.chart; }

                if (autosize) {
                    $scope.size();
                    chart = new Chart(ctx);
                };

                if ($scope.responsive || $scope.resize)
                    $scope.options.responsive = true;

                if ($scope.responsive !== undefined)
                    $scope.options.responsive = $scope.responsive;

                chartCreated = chart[type]($scope.data, $scope.options);
                chartCreated.update();
                if ($scope.legend)
                    angular.element($elem[0]).parent().after(chartCreated.generateLegend());
            }, true);

            $scope.$watch("tooltip", function (newVal, oldVal) {
                if (chartCreated)
                    chartCreated.draw();
                if (newVal === undefined || !chartCreated.segments)
                    return;
                if (!isFinite(newVal) || newVal >= chartCreated.segments.length || newVal < 0)
                    return;
                var activeSegment = chartCreated.segments[newVal];
                activeSegment.save();
                activeSegment.fillColor = activeSegment.highlightColor;
                chartCreated.showTooltip([activeSegment]);
                activeSegment.restore();
            }, true);

            $scope.size();
            var chart = new Chart(ctx);
            var chartCreated;
        }
    }
}


/* Aliases for various chart types */
angles.directive("chart", function () { return angles.chart(); });
angles.directive("linechart", function () { return angles.chart("Line"); });
angles.directive("barchart", function () { return angles.chart("Bar"); });
angles.directive("radarchart", function () { return angles.chart("Radar"); });
angles.directive("polarchart", function () { return angles.chart("PolarArea"); });
angles.directive("piechart", function () { return angles.chart("Pie"); });
angles.directive("doughnutchart", function () { return angles.chart("Doughnut"); });
angles.directive("donutchart", function () { return angles.chart("Doughnut"); });
'use strict';

//Directive used to set metisMenu and minimalize button
angular.module('inspinia')
    .directive('icheck', icheck)
    .directive('sideNavigation', function ($timeout) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                // Call metsi to build when user signup
                scope.$watch('authentication.user', function() {
                    $timeout(function() {
                        element.metisMenu();
                    });
                });

                // Colapse menu in mobile mode after click on element
                var menuElement = angular.element('#side-menu a:not([href$="\\#"])');
                menuElement.click(function(){
                  if (angular.element(window).width() < 769) {
                    angular.element("body").toggleClass("mini-navbar");
                  }
                });

                // Enable initial fixed sidebar
                if (angular.element("body").hasClass('fixed-sidebar')) {
                  var sidebar = element.parent();
                  sidebar.slimScroll({
                    height: '100%',
                    railOpacity: 0.9
                  });
                }

            }
        };
    })
    .directive('moneyMask', ['$timeout', 'moneyMaskService', function($timeout, moneyMaskService) {
        return {
          require: 'ngModel',
          link: function(scope, element, attrs, ctrl) {
              var execute = function () {
                  scope.$apply(function () {
                      ctrl.$setViewValue(moneyMaskService.fromStringToMoney(ctrl.$modelValue));
                      ctrl.$render();
                  });
              };
              element.bind('keyup', function () {
                  execute();
              });
              
              $timeout(function () { 
                  execute();
              }, 500);
           }
        };
     }])
     .factory("moneyMaskService", [ "$filter", function ($filter) {
        var _otherCharacters = /[^0-9]/g;
        var _zeros = /^0+/;
        
        var _fromStringToMoney = function (string) {
            return $filter("currency")((_fromStringToNumber(string)/100).toFixed(2)).replaceAll('R$', 'R$ ');
        };
        
        var _fromStringToNumber = function (string) {
            if (!string) return 0;
            return string.toString().replace(_otherCharacters, '').replace(_zeros, '') || 0;
        }
        
        return {
            fromStringToMoney: _fromStringToMoney
        };
    }])
    .directive('minimalizaSidebar', function ($timeout) {
        return {
            restrict: 'A',
            template: '<a class="navbar-minimalize minimalize-styl-2 btn btn-success " href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
            controller: function ($scope) {
                $scope.minimalize = function () {
                    angular.element('body').toggleClass('mini-navbar');
                    if (!angular.element('body').hasClass('mini-navbar') || angular.element('body').hasClass('body-small')) {
                        // Hide menu in order to smoothly turn on when maximize menu
                        angular.element('#side-menu').hide();
                        // For smoothly turn on menu
                        $timeout(function () {
                            angular.element('#side-menu').fadeIn(400);
                        }, 200);
                    } else {
                        // Remove all inline style from jquery fadeIn function to reset menu state
                        angular.element('#side-menu').removeAttr('style');
                    }
                };
            }
        };
    })
    .directive("fileread", [function () {
        return {
            scope: {
                fileread: "="
            },
            link: function (scope, element, attributes) {
                element.bind("change", function (changeEvent) {
                    var reader = new FileReader();
                    reader.onload = function (loadEvent) {
                        scope.$apply(function () {
                            scope.fileread = loadEvent.target.result;
                        });
                    }
                    reader.readAsDataURL(changeEvent.target.files[0]);
                });
            }
        }
    }])
    .directive("setModelOnChange", function() {
        return {
            require: "ngModel",
            link: function postLink(scope,elem,attrs,ngModel) {
            elem.on("change", function(e) {
                console.log("on change (from directive)", e);  
                var files = elem[0].files;
                ngModel.$setViewValue(files);
            })
            }
        }
    })
;

/**
 * icheck - Directive for custom checkbox icheck
 */
function icheck($timeout) {
    return {
        restrict: 'A',
        require: 'ngModel',
        link: function($scope, element, $attrs, ngModel) {
            return $timeout(function() {
                var value;
                value = $attrs['value'];

                $scope.$watch($attrs['ngModel'], function(newValue){
                    $(element).iCheck('update');
                })

                return $(element).iCheck({
                    checkboxClass: 'icheckbox_square-green',
                    radioClass: 'iradio_square-green'

                }).on('ifChanged', function(event) {
                        if ($(element).attr('type') === 'checkbox' && $attrs['ngModel']) {
                            $scope.$apply(function() {
                                return ngModel.$setViewValue(event.target.checked);
                            });
                        }
                        if ($(element).attr('type') === 'radio' && $attrs['ngModel']) {
                            return $scope.$apply(function() {
                                return ngModel.$setViewValue(value);
                            });
                        }
                    });
            });
        }
    };
}
angular.module("inspinia").run(["$templateCache", function($templateCache) {$templateCache.put("app/modal-template.html","<div class=\"modal-dialog\" style=\"width: 90%; margin: 2vh auto; height: 90vh;\"><div class=\"modal-content\" style=\"height: 100%; display: flex; flex-direction: column;\"><div class=\"modal-header\"><h3 class=\"modal-title\">Visualização do Documento</h3></div><div class=\"modal-body\" style=\"flex: 1; padding: 0;\"><iframe ng-src=\"{{urlToLoad}}\" style=\"width: 100%; height: 100%; border: none;\"></iframe></div><div class=\"modal-footer\"><button class=\"btn btn-success\" style=\"width: 100px\" ng-click=\"closeModal()\">Fechar</button></div></div></div>");
$templateCache.put("app/cadastro/index.html","");
$templateCache.put("app/main/main.html","");
$templateCache.put("app/minor/minor.html","<div class=\"wrapper wrapper-content animated fadeInRight\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"text-center m-t-lg\"><h1>Simple example of second view</h1><small>Configure in app.js as index.minor state.</small></div></div></div></div>");
$templateCache.put("app/sacado/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Pesquisar Sacado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Sacado</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"><button ng-click=\"controller.cadastrar()\" class=\"btn btn-success\"><i class=\"fa fa-plus\"></i> Cadastrar Sacado</button></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"number\" ng-model=\"controller.filtro.codigo\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome/Razão Social</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF/CNPJ</label> <input type=\"text\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-success\" style=\"width: 140px;\" ng-click=\"controller.filtrarPesquisa()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Sacados</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 10px;\">#</th><th>Nome/Razão Social</th><th>CPF/CNPJ</th><th>Data de cadastro</th><th>Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.id}}</td><td>{{p.razaoSocial}}</td><td>{{p.cnpj}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</td><td>Ativo</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" num-pages=\"pagination.numPages\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\"></ul></div></div></footer></div></div></div></div></div>");
$templateCache.put("app/usuario/alterar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Alterar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Alterar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Informações</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Nome\" placeholder=\"Nome completo\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Login\" placeholder=\"Login para acesso\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.Email\" placeholder=\"E-mail\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Telegram</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioAlteracao.usuario.TelegramUser\" placeholder=\"Usuário do Telegram\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"usuarioAlteracao.alterar()\">ATUALIZAR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/alterarsenha.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Alterar Senha</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Alterar Senha</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Alteração de Senha</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha antiga</label><div class=\"col-lg-10\"><input type=\"password\" maxlength=\"12\" ng-model=\"controller.oldPassword\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nova senha</label><div class=\"col-lg-10\"><input type=\"password\" maxlength=\"12\" ng-model=\"controller.newPassword\" class=\"form-control\"></div></div><div class=\"form-group\" style=\"margin-bottom: 0px;\"><div class=\"col-lg-12\" style=\"text-align: right\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\">ATUALIZAR</button></div></div></form></div></div></div></div></div>");
$templateCache.put("app/usuario/ativacao_conta.html","<style>\r\n    /*\r\n    body \r\n    {\r\n        zoom: 100%;\r\n        background-image: url(\'https://i2.wp.com/crat.org/wp-content/uploads/2018/08/Webpage-backdrop.jpg\');\r\n        background-repeat:no-repeat;\r\n        background-size:cover;\r\n    }\r\n    */\r\n    body \r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"wrapper wrapper-content ng-scope\" style=\"margin-right: 10%; margin-left: 10%;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 5px\"><div class=\"ibox-content\" style=\"padding-bottom: 10px; margin-top: 10px;\"><div style=\"padding-right: 35px; padding-left: 35px; text-align: center;\"><div ng-if=\"controller.resultado == 0\"><h3>Processando solicitação...</h3></div><div ng-if=\"controller.resultado == 1\"><h2><b>SEU CADASTRO FOI CONFIRMADO COM SUCESSO!</b></h2><br><h3>Volte para a página de login e informe seu e-mail e senha cadastrados.</h3></div><div ng-if=\"controller.resultado == 2\"><h3 style=\"color: red;\">E-mail de confirmação inválido. Favor tentar novamente ou entrar em contato com o administrador do sistema.</h3></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.incluirPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><a href=\"#\" class=\"btn btn-md btn-success\" type=\"button\">IR PARA A PÁGINA DE LOGIN</a></div></div></div></div></div>");
$templateCache.put("app/usuario/autenticar.html","<style>\r\n    /*\r\n    body \r\n    {\r\n        zoom: 100%;\r\n        background-image: url(\'https://i2.wp.com/crat.org/wp-content/uploads/2018/08/Webpage-backdrop.jpg\');\r\n        background-repeat:no-repeat;\r\n        background-size:cover;\r\n    }\r\n    */\r\n    body \r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"middle-box text-center animated fadeInDown\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px; margin-top: 80px;\"><div style=\"padding-right: 35px; padding-left: 35px;\"><div style=\"margin-top: 30px;\"><img width=\"270px\" style=\"margin-bottom: 0px; margin-top: 20px; margin-bottom: 20px;\" src=\"{{main.logoempresa}}\"></div><br><br><h3>ACESSO FORNECEDOR</h3><p>Informe seu login (e-mail) e senha para autenticar</p><form class=\"m-t\" role=\"form\" cg-busy=\"main.loginPromise\"><div ng-if=\"main.isUserSuporte == false\"><div class=\"form-group\"><input ng-model=\"main.usuario.Login\" type=\"text\" class=\"form-control normal-text\" placeholder=\"E-mail\" required=\"\"></div><div class=\"form-group\" style=\"text-align: right;\"><input ng-model=\"main.usuario.Senha\" type=\"password\" class=\"form-control normal-text\" placeholder=\"Senha\" required=\"\"> <a style=\"padding-top: 2px; font-size: 11px;\" ng-click=\"main.esqueciSenha()\">Esqueci minha senha</a></div><button type=\"submit\" ng-click=\"main.login()\" class=\"btn btn-success block full-width m-b\">Login</button> <small ng-if=\"main.autoRegister\">Novo na plataforma?</small> <button ng-if=\"main.autoRegister\" type=\"button\" ng-click=\"main.criarConta()\" class=\"btn btn-warning block full-width m-b\">Quero criar uma conta</button></div><div ng-if=\"main.isUserSuporte == true\"><div class=\"form-group\"><select class=\"form-control\" ng-model=\"main.usuarioSuporte\" ng-options=\'item as ((item.nomeFantasia ? item.nomeFantasia.toUpperCase() + \" — \" : \"\") + item.email) for item in main.usuariossuporte\'></select></div><button type=\"submit\" ng-click=\"main.login()\" class=\"btn btn-success block full-width m-b\">Acessar</button></div></form></div></div></div></div></div></div>");
$templateCache.put("app/usuario/cadastrar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Informações</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Nome\" placeholder=\"Nome completo\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Login\" placeholder=\"Login para acesso\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Email\" placeholder=\"E-mail\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"usuarioCadastro.usuario.Password\" placeholder=\"Senha\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"usuarioCadastro.incluir()\">SALVAR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/completar_cadastro.html","<style>\r\n    body \r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"wrapper wrapper-content ng-scope\" style=\"margin-right: 10%; margin-left: 10%;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-content\" style=\"padding-bottom: 10px; margin-top: 0px;\"><div style=\"padding-right: 35px; padding-left: 35px; text-align: center;\"><h3>PREENCHA OS DADOS ABAIXO PARA FINALIZAR SEU CADASTRO</h3></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Informações complementares da empresa</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" disabled=\"\" style=\"background-color: #F1F1F1;\" ng-model=\"controller.fornecedor.cnpj\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" disabled=\"\" style=\"background-color: #F1F1F1;\" ng-model=\"controller.fornecedor.razaoSocial\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Fundação <span class=\"red\">*</span></label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.fornecedor.complemento.dataFundacao\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Capital Social</label> <input type=\"text\" ui-number-mask=\"\" ng-model=\"controller.fornecedor.complemento.capitalSocial\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Contato Secundário</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.nomeContatoSecundario\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail do Contato Secundário</label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.emailContatoSecundario\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Ramo de Atividade <span class=\"red\">*</span></label> <input type=\"text\" maxlength=\"100\" ng-model=\"controller.fornecedor.complemento.ramoAtividade\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Faturamento/Médio/Mês (Brasil)</label> <input type=\"text\" ui-number-mask=\"\" ng-model=\"controller.fornecedor.complemento.faturamentoMedioBrasil\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Faturamento/Médio/Mês (Exterior)</label> <input type=\"text\" ui-number-mask=\"\" ng-model=\"controller.fornecedor.complemento.faturamentoMedioExterior\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Imóvel Próprio (Informar Descrição/Valor/Metragem)</label> <textarea rows=\"3\" maxlength=\"250\" ng-model=\"controller.fornecedor.complemento.dadosImovelProprio\" class=\"form-control inputDisabledModal\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência Bancos (Banco/Agência/Contato)</label> <textarea rows=\"3\" maxlength=\"250\" ng-model=\"controller.fornecedor.complemento.dadosReferenciaBancos\" class=\"form-control inputDisabledModal\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência - Comerciais/Fornecedores (Informar % Participação)</label> <textarea rows=\"3\" maxlength=\"250\" ng-model=\"controller.fornecedor.complemento.dadosReferenciaComercial\" class=\"form-control inputDisabledModal\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Principais Clientes (Informar % Faturamento)</label> <textarea rows=\"3\" maxlength=\"250\" ng-model=\"controller.fornecedor.complemento.dadosPrincipaisClientes\" class=\"form-control inputDisabledModal\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><span class=\"red\" style=\"font-size: 11px;\">* Campos de preenchimento obrigatórios.</span></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-users\"></i> Controle Acionário/Societário</h5></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table ng-if=\"controller.fornecedor.socios.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Nome</th><th class=\"white-bg\">CPF</th><th class=\"white-bg\">Data Nascimento</th><th class=\"white-bg\">RG</th><th class=\"white-bg\">% Participação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.fornecedor.socios\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.cpf }}</td><td class=\"ng-binding\">{{ p.dataNascimento }}</td><td class=\"ng-binding\">{{ p.rg == null || p.rg == \'\' ? \'não informado\' : p.rg }}</td><td class=\"ng-binding\">{{ p.percentualParticipacao }}%</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.editarSocio(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-edit\"></i> Editar</button> <button ng-click=\"controller.excluirSocio(p, $index)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirSocio()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-users\"></i> Procurador (ES)</h5></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table ng-if=\"controller.fornecedor.procuradores.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Nome</th><th class=\"white-bg\">CPF</th><th class=\"white-bg\">Data Nascimento</th><th class=\"white-bg\">RG</th><th class=\"white-bg\">% Participação</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.fornecedor.procuradores\"><td class=\"ng-binding\">{{ p.nome }}</td><td class=\"ng-binding\">{{ p.cpf }}</td><td class=\"ng-binding\">{{ p.dataNascimento }}</td><td class=\"ng-binding\">{{ p.rg == null || p.rg == \'\' ? \'não informado\' : p.rg }}</td><td class=\"ng-binding\">{{ p.percentualParticipacao }}%</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.editarProcurador(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-edit\"></i> Editar</button> <button ng-click=\"controller.excluirProcurador(p, $index)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirProcurador()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-users\"></i> Empresas Coligadas/Controladas</h5></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><div style=\"overflow: auto; max-height: 370px;\"><table ng-if=\"controller.fornecedor.empresas.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"min-width: 200px\">Razão Social</th><th class=\"white-bg\">CNPJ</th><th class=\"white-bg\">Sócios</th><th class=\"white-bg\">Fundação</th><th class=\"white-bg\">% Participação</th><th class=\"white-bg\">Data Entrada</th></tr></thead><tbody><tr class=\"ng-scope\" style=\"\" ng:repeat=\"p in controller.fornecedor.empresas\"><td class=\"ng-binding\">{{ p.razaoSocial }}</td><td class=\"ng-binding\">{{ p.cnpj }}</td><td class=\"ng-binding\">{{ p.socios == null ? \'não informado\' : p.socios }}</td><td class=\"ng-binding\">{{ p.dataFundacao == null ? \'não informado\' : p.dataFundacao }}</td><td class=\"ng-binding\">{{ p.percentualParticipacao == null ? 0 : p.percentualParticipacao }}%</td><td class=\"ng-binding\">{{ p.dataEntrada == null ? \'não informado\' : p.dataEntrada }}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.editarEmpresa(p, $index)\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-edit\"></i> Editar</button> <button ng-click=\"controller.excluirEmpresa(p, $index)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</button></td></tr></tbody></table><button type=\"button\" class=\"btn btn-sm btn-success\" ng-click=\"controller.incluirEmpresa()\"><span><i class=\"fa fa-plus\"></i> Adicionar novo registro</span></button></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-users\"></i> Documentos</h5></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-12\"><div style=\"overflow: auto; max-height: 410px;\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Documento</th><th class=\"white-bg\" style=\"width: 50px;\">Arquivo</th></tr></thead><tbody><tr class=\"ng-scope\"><td class=\"ng-binding\">Cadastro Pessoa Jurídica</td><td><input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(1)\" name=\"...\"></td><td ng-if=\"controller.arquivos.arq1 != \'\'\">{{controller.arquivos.arq1}}</td></tr><tr class=\"ng-scope\"><td class=\"ng-binding\">Contrato/Estatuto Social</td><td><input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-change=\"controller.adicionarDocumento(2)\" name=\"...\"></td><td ng-if=\"controller.arquivos.arq2 != \'\'\">{{controller.arquivos.arq2}}</td></tr></tbody></table></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.consultarPromise\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxContaBancaria\', \'boxContaBancaria\')\"><h5><i class=\"fa fa-users\"></i> DECLARAÇÃO DE PESSOA POLITICAMENTE EXPOSTA</h5></div><div class=\"ibox-content\" id=\"boxContaBancaria\" cg-busy=\"controller.consultar\"><div class=\"row\"><div class=\"col-lg-10\"><b>DECLARAÇÃO DE PESSOA POLITICAMENTE EXPOSTA, NOS TERMOS DA CIRCULAR Nº 3.461/2009 DO BANCO CENTRAL DO BRASIL</b><br><br>Desempenha ou já desempenhou nos últimos 05 (cinco) anos, no Brasil ou em países, territórios e dependências estrangeiros, cargos, empregos ou funções públicas relevantes, assim como seus representantes, familiares e outras pessoas de seu relacionamento próximo?<br><select class=\"form-control inputDisabledModal\" ng-model=\"controller.fornecedor.complemento.pessoaPoliticamenteExposta\"><option value=\"0\">NÃO</option><option value=\"1\">SIM</option></select><br>Em caso positivo informar: a pessoa, o cargo ou função que exerce ou desempenhou, o período e, qual esfera do Poder: <input type=\"text\" ng-model=\"controller.fornecedor.complemento.politicamenteExpostaFuncao\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.incluir()\"><i class=\"fa fa-arrow-right\"></i> CONCLUIR</button></div></div></div></div></div>");
$templateCache.put("app/usuario/confirmar_cadastro.html","<style>\r\n    /*\r\n    body \r\n    {\r\n        zoom: 100%;\r\n        background-image: url(\'https://i2.wp.com/crat.org/wp-content/uploads/2018/08/Webpage-backdrop.jpg\');\r\n        background-repeat:no-repeat;\r\n        background-size:cover;\r\n    }\r\n    */\r\n    body \r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" style=\"margin-right: 10%; margin-left: 10%;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-content\"><div style=\"margin-top: 30px; margin-bottom: 20px;\"><img width=\"210px\" style=\"margin-bottom: 0px\" src=\"assets/images/icons/logo.png\"><br><br><br><h1>Seu cadastro foi efetuado com sucesso!</h1><br><h3>Antes de realizar o acesso ao sistema, realize a ativação de sua conta utilizando o e-mail que enviamos. Caso não encontre o e-mail, verifique sua caixa de SPAM.</h3></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><a class=\"btn btn-md btn-success\" href=\"#/login\"><i class=\"fa fa-arrow-left\"></i> VOLTAR PARA A TELA LOGIN</a></div></div></div></div></div>");
$templateCache.put("app/usuario/nova_conta.html","<style>    \r\n    body \r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" style=\"margin-right: 10%; margin-left: 10%;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados da Empresa</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ <span class=\"red\">*</span></label> <input type=\"text\" mask=\"99.999.999/9999-99\" maxlength=\"20\" ng-model=\"controller.fornecedor.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.fornecedor.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome Fantasia <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.nomeFantasia\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Responsável <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.responsavelCadastro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CPF do Responsável <span class=\"red\">*</span></label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.fornecedor.complemento.responsavelCadastroCpf\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Celular <span class=\"red\">*</span></label> <input type=\"text\" mask=\"(99)99999-9999\" ng-model=\"controller.fornecedor.complemento.celular\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone</label> <input type=\"text\" mask=\"(99)9999-9999\" ng-model=\"controller.fornecedor.complemento.telefone\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.fornecedor.complemento.emailCadastro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Confirmar E-mail <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.fornecedor.confimarEmailCadastro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Senha de Acesso <span class=\"red\">*</span></label> <input type=\"password\" ng-model=\"controller.fornecedor.complemento.senha\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Confirmar Senha <span class=\"red\">*</span></label> <input type=\"password\" ng-model=\"controller.fornecedor.confirmarSenha\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><span class=\"red\" style=\"font-size: 11px;\">* Campos de preenchimento obrigatórios.</span></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px\"><div class=\"ibox-title bg-warning\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP <span class=\"red\">*</span></label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-change=\"controller.consultarCep()\" ng-model=\"controller.fornecedor.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.fornecedor.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Estado <span class=\"red\">*</span></label><select ng-model=\"controller.fornecedor.endereco.uf\" class=\"form-control inputDisabledModal\"><option value=\"AC\">ACRE</option><option value=\"AL\">ALAGOAS</option><option value=\"AP\">AMAPÁ</option><option value=\"AM\">AMAZONAS</option><option value=\"BA\">BAHIA</option><option value=\"CE\">CEARÁ</option><option value=\"DF\">DISTRITO FEDERAL</option><option value=\"ES\">ESPÍRITO SANTO</option><option value=\"GO\">GOIÁS</option><option value=\"MA\">MARANHÃO</option><option value=\"MT\">MATO GROSSO</option><option value=\"MS\">MATO GROSSO DO SUL</option><option value=\"MG\">MINAS GERAIS</option><option value=\"PA\">PARÁ</option><option value=\"PB\">PARAÍBA</option><option value=\"PR\">PARANÁ</option><option value=\"PE\">PERNAMBUCO</option><option value=\"PI\">PIAUÍ</option><option value=\"RJ\">RIO DE JANEIRO</option><option value=\"RN\">RIO GRANDE DO NORTE</option><option value=\"RS\">RIO GRANDE DO SUL</option><option value=\"RO\">RONDÔNIA</option><option value=\"RR\">RORAIMA</option><option value=\"SC\">SANTA CATARINA</option><option value=\"SP\">SÃO PAULO</option><option value=\"SE\">SERGIPE</option><option value=\"TO\">TOCANTINS</option><option value=\"EX\">ESTRANGEIRO</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><span class=\"red\" style=\"font-size: 11px;\">* Campos de preenchimento obrigatórios.</span></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" cg-busy=\"controller.incluirPromise\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.incluir()\">ENVIAR CADASTRO</button></div></div></div></div></div>");
$templateCache.put("app/usuario/pesquisar.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"><a class=\"btn btn-sm btn-success\" ng-click=\"usuarioPesquisa.incluir()\">NOVO USUÁRIO</a></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Resultado</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 40%\">Nome</th><th style=\"width: 30%\">Login</th><th style=\"width: 30%\">E-mail</th></tr></thead><tbody><tr ng:repeat=\"p in usuarioPesquisa.items\"><td>{{p.nome}}</td><td>{{p.login}}</td><td>{{p.Email}}</td><td style=\"text-align: center;\"><a ng-click=\"usuarioPesquisa.alterar(p)\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"usuarioPesquisa.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in usuarioPesquisa.pager.pages\" ng-class=\"{active:usuarioPesquisa.pager.currentPage === page}\"><a ng-click=\"usuarioPesquisa.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cadastro/aguardar_aprovacao/index.html","<style>\r\n    /*\r\n    body \r\n    {\r\n        zoom: 100%;\r\n        background-image: url(\'https://i2.wp.com/crat.org/wp-content/uploads/2018/08/Webpage-backdrop.jpg\');\r\n        background-repeat:no-repeat;\r\n        background-size:cover;\r\n    }\r\n    */\r\n    body \r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\" style=\"margin-right: 10%; margin-left: 10%;\"><div class=\"row\" ng-if=\"controller.fornecedor.statusCadastro == 2\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-content\"><div style=\"margin-top: 30px; margin-bottom: 20px;\"><img width=\"210px\" style=\"margin-bottom: 0px\" src=\"assets/images/icons/logo.png\"><br><br><br><h1>Seus dados foram enviados com sucesso!</h1><br><h3>Estaremos realizando a análise dos dados cadastrais da sua empresa e enviaremos um retorno em breve!</h3></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.statusCadastro == 3\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-content\"><div style=\"margin-top: 15px; margin-bottom: 20px;\"><br><br><br><h1>Sua solicitação está na etapa de Assinatura Digital</h1><br><h4>Clique no botão verde para acessar o portal de Assinatura Digital Assina.Net.Br e utilize as mesmas credencias (email e senha) ou o seu certificado digital para acessar a plataforma.</h4><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Razão Social</th><th>CNPJ</th><th>Data da Solicitação</th></tr></thead><tbody><tr><td>{{controller.fornecedor.razaoSocial}}</td><td>{{controller.fornecedor.cnpj}}</td><td>{{controller.fornecedor.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a target=\"_blank\" href=\"https://www.assina.net.br/documento/assinadocto\" class=\"btn btn-primary btn-xs btn-block\">ASSINATURA DIGITAL</a></td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.statusCadastro == 4\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-content\"><div style=\"margin-top: 15px; margin-bottom: 20px;\"><br><br><br><h1>Sua solicitação está na etapa de Abertura de Conta</h1><br><h4>Aguarde a aprovação da abertura de conta para ter acesso ao sistema.</h4><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Razão Social</th><th>CNPJ</th><th>Data da Solicitação</th><th>Situação</th></tr></thead><tbody><tr><td>{{controller.fornecedor.razaoSocial}}</td><td>{{controller.fornecedor.cnpj}}</td><td>{{controller.fornecedor.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><button class=\"btn btn-warning btn-xs btn-block\">AGUARDANDO ABERTURA DE CONTA</button></td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.fornecedor.statusCadastro == 2\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><a class=\"btn btn-md btn-success\" href=\"#/login\"><i class=\"fa fa-arrow-left\"></i> VOLTAR PARA A TELA LOGIN</a></div></div></div></div></div>");
$templateCache.put("app/cadastro/modal/cadastrar_empresa.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\"><h5 class=\"modal-title\">Cadastrar Empresa Coligada/Controlada</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.empresa.razaoSocial\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" mask=\"99.999.999/9999-99\" ng-model=\"controller.empresa.cnpj\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Sócios</label> <input type=\"text\" ng-model=\"controller.empresa.socios\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data Fundação</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.empresa.dataFundacao\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">% Participação</label> <input type=\"number\" ng-model=\"controller.empresa.percentualParticipacao\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Entrada</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.empresa.dataEntrada\" class=\"form-control\"></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\" ng-if=\"controller.empresa.viewId == null\"><i class=\"fa fa-send\"></i> Incluir</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\" ng-if=\"controller.empresa.viewId != null\"><i class=\"fa fa-send\"></i> Atualizar</button></div>");
$templateCache.put("app/cadastro/modal/cadastrar_socio.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\" style=\"padding-top: 10px; padding-bottom: 10px;\"><h5 class=\"modal-title\">Cadastrar {{ controller.tipoPessoa }}</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\" style=\"padding-bottom: 5px;\"><div ng-if=\"controller.etapa == 1 || controller.etapa == 3\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome <span class=\"red\">*</span></label> <input type=\"text\" ng-model=\"controller.pessoa.nome\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Nascimento <span class=\"red\">*</span></label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.pessoa.dataNascimento\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Entrada</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.pessoa.dataEntrada\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">CPF <span class=\"red\">*</span></label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.pessoa.cpf\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">RG/Emissor/UF ou RNE</label> <input type=\"text\" ng-model=\"controller.pessoa.rg\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.pessoa.email\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">% Participação</label> <input type=\"number\" ng-model=\"controller.pessoa.percentualParticipacao\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Assina pela empresa?</label><select class=\"form-control\" ng-model=\"controller.pessoa.assinaPelaEmpresaText\"><option value=\"1\" selected=\"\">Sim</option><option value=\"2\">Não</option></select></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Telefone</label> <input type=\"text\" mask=\"(99)99999-9999\" ng-model=\"controller.pessoa.telefone1\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Celular</label> <input type=\"text\" mask=\"(99)99999-9999\" ng-model=\"controller.pessoa.celular\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência Banco/Agência/Contato/Fone</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.referenciaBanco1\" class=\"form-control\"></textarea></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Referência Pessoais Contato/Fone/Parentesco</label> <textarea ng-model=\"controller.pessoa.referenciaPessoal1\" class=\"form-control\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-change=\"controller.consultarCep()\" ng-model=\"controller.pessoa.enderecoDados.cep\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.logradouro\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.numero\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.complemento\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.bairro\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.pessoa.enderecoDados.cidade\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Estado</label><select ng-model=\"controller.pessoa.enderecoDados.uf\" class=\"form-control\"><option value=\"AC\">Acre</option><option value=\"AL\">Alagoas</option><option value=\"AP\">Amapá</option><option value=\"AM\">Amazonas</option><option value=\"BA\">Bahia</option><option value=\"CE\">Ceará</option><option value=\"DF\">Distrito Federal</option><option value=\"ES\">Espírito Santo</option><option value=\"GO\">Goiás</option><option value=\"MA\">Maranhão</option><option value=\"MT\">Mato Grosso</option><option value=\"MS\">Mato Grosso do Sul</option><option value=\"MG\">Minas Gerais</option><option value=\"PA\">Pará</option><option value=\"PB\">Paraíba</option><option value=\"PR\">Paraná</option><option value=\"PE\">Pernambuco</option><option value=\"PI\">Piauí</option><option value=\"RJ\">Rio de Janeiro</option><option value=\"RN\">Rio Grande do Norte</option><option value=\"RS\">Rio Grande do Sul</option><option value=\"RO\">Rondônia</option><option value=\"RR\">Roraima</option><option value=\"SC\">Santa Catarina</option><option value=\"SP\">São Paulo</option><option value=\"SE\">Sergipe</option><option value=\"TO\">Tocantins</option><option value=\"EX\">Estrangeiro</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Pai</label> <input type=\"text\" ng-model=\"controller.pessoa.nomePai\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nome da Mãe</label> <input type=\"text\" ng-model=\"controller.pessoa.nomeMae\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Nome do Conjugê</label> <input type=\"text\" ng-model=\"controller.pessoa.conjugeNome\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">CPF</label> <input type=\"text\" mask=\"999.999.999-99\" ng-model=\"controller.pessoa.conjugeCpf\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Regime</label> <input type=\"text\" ng-model=\"controller.pessoa.conjugeRegime\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">RG/Emissor/UF ou RNE</label> <input type=\"text\" ng-model=\"controller.pessoa.conjugeRg\" class=\"form-control\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data</label> <input type=\"text\" mask=\"99/99/9999\" ng-model=\"controller.pessoa.conjugeData\" class=\"form-control unstyled\"></div></div></div><div class=\"row\"><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Patrimônio Imóveis (Descrição/Valor/Metragem)</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.patrimonioImoveis\" class=\"form-control\"></textarea></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Patrimônio Móveis (Descrição/Valor)</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.patrimonioMoveis\" class=\"form-control\"></textarea></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Faixa de Renda Mensal</label> <textarea rows=\"2\" ng-model=\"controller.pessoa.faixaRendaMensal\" class=\"form-control\"></textarea></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><span class=\"red\" style=\"font-size: 11px;\">* Campos de preenchimento obrigatórios.</span></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\" ng-if=\"controller.etapa == 2\"><i class=\"fa fa-send\"></i> Concluir</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\" ng-if=\"controller.pessoa.viewId == null\"><i class=\"fa fa-send\"></i> Incluir</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\" ng-if=\"controller.pessoa.viewId != null && controller.etapa != 2\"><i class=\"fa fa-send\"></i> Atualizar</button></div>");
$templateCache.put("app/cadastro/reset_senha/index.html","<style>\r\n    /*\r\n    body \r\n    {\r\n        zoom: 100%;\r\n        background-image: url(\'https://i2.wp.com/crat.org/wp-content/uploads/2018/08/Webpage-backdrop.jpg\');\r\n        background-repeat:no-repeat;\r\n        background-size:cover;\r\n    }\r\n    */\r\n    body \r\n    {\r\n        background-color: #f3f3f4 !important;\r\n    }\r\n</style><div class=\"wrapper wrapper-content ng-scope\" style=\"margin-right: 10%; margin-left: 10%;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\" style=\"margin-bottom: 10px;\"><div class=\"ibox-title bg-success\"><h5>Alteração de Senha</h5></div><div class=\"ibox-content\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nova Senha</label><div class=\"col-lg-4\"><input type=\"password\" ng-model=\"controller.usuario.senha\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Confirmar Senha</label><div class=\"col-lg-4\"><input type=\"password\" ng-model=\"controller.usuario.confirmPassword\" class=\"form-control\"></div></div></form></div></div></div></div><div class=\"row\" cg-busy=\"controller.resetPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.enviar()\">ATUALIZAR</button></div></div></div></div></div>");
$templateCache.put("app/cadastro/sacado/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Pesquisar Sacado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Sacado</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"><button ng-click=\"controller.cadastrar()\" class=\"btn btn-success\"><i class=\"fa fa-plus\"></i> Cadastrar Sacado</button></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"number\" ng-model=\"controller.filtro.codigo\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome/Razão Social</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF/CNPJ</label> <input type=\"text\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-success\" style=\"width: 140px;\" ng-click=\"controller.filtrarPesquisa()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Sacados</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 10px;\">#</th><th>Nome/Razão Social</th><th>CPF/CNPJ</th><th>Data de cadastro</th><th>Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td>{{p.id}}</td><td>{{p.razaoSocial}}</td><td>{{p.cnpj}}</td><td>{{p.dataCadastro | date:\'dd/MM/yyyy HH:mm\'}}</td><td>Ativo</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.consultar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Visualizar</a></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" num-pages=\"pagination.numPages\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\"></ul></div></div></footer></div></div></div></div></div>");
$templateCache.put("app/cnab/retornocliente/index.html","<div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Arquivos Cnabs</h5><div class=\"ibox-tools\"><a ng-click=\"controller.redirectToURL(); $event.stopPropagation()\" title=\"Manual: Retorno de Cnab\"><i class=\"fa fa-book\" style=\"color: white; font-size: 22px;\"></i></a> <a ng-click=\"controller.listarArquivos()\"><i class=\"fa fa-refresh\" style=\"color: white; font-size: 22px;\"></i></a></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Data da Geração</th><th>Nome do Arquivo</th><th>Ações</th></tr></thead><tbody><tr ng:repeat=\"p in controller.arquivosPag\"><td>{{p.dataGeracao | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{p.nomeCnabRetorno}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.downloadArquivo(p.nomeCnabRetorno)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-download\"></i> Download</a></td></tr></tbody></table></div><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\" style=\"margin: 0;\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cnab/retornocliente/indexOLD.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Pesquisar Sacado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Retorno Cnab</a></li><li class=\"active\"><strong>Listagem</strong></li></ol></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\" cg-busy=\"controller.consultarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Arquivos Cnabs</h5><div class=\"ibox-tools\"><a ng-click=\"controller.listarArquivos()\"><i class=\"fa fa-refresh\" style=\"color: white; font-size: 22px;\"></i></a></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th>Data da Geração</th><th>Nome do Arquivo</th><th>Ações</th></tr></thead><tbody><tr ng:repeat=\"p in controller.arquivos.retornoCnabs\"><td>{{p.dataGeracao | date:\'dd/MM/yyyy HH:mm\'}}</td><td>{{p.nomeCnabRetorno}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.downloadArquivo(p.nomeCnabRetorno)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-download\"></i> Download</a></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" num-pages=\"pagination.numPages\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\"></ul></div></div></footer></div></div></div></div></div>");
$templateCache.put("app/components/common/content.html","<div id=\"wrapper\"><div ng-include=\"\'app/components/common/navigation.html\'\"></div><div id=\"page-wrapper\" class=\"gray-bg {{$state.current.name}}\"><div ng-include=\"\'app/components/common/topnavbar.html\'\"></div><div ui-view=\"\"></div><div ng-include=\"\'app/components/common/footer.html\'\"></div></div></div>");
$templateCache.put("app/components/common/footer.html","");
$templateCache.put("app/components/common/ibox_tools.html","<div class=\"ibox-tools\" uib-dropdown=\"\"><a ng-click=\"showhide()\"><i class=\"fa fa-chevron-up\"></i></a> <a uib-dropdown-toggle=\"\" href=\"\"><i class=\"fa fa-wrench\"></i></a><ul uib-dropdown-menu=\"\"><li><a href=\"\">Config option 1</a></li><li><a href=\"\">Config option 2</a></li></ul><a ng-click=\"closebox()\"><i class=\"fa fa-times\"></i></a></div>");
$templateCache.put("app/components/common/loading.html","<div style=\"background-image:url(\'assets/images/icons/loading.gif\');background-size: 50px 50px;margin: 0 auto;background-position:50% 20px;background-repeat:no-repeat\"></div>");
$templateCache.put("app/components/common/navigation.html","<nav class=\"navbar-default navbar-static-side\" role=\"navigation\"><div class=\"sidebar-collapse\"><ul side-navigation=\"\" class=\"nav metismenu\" id=\"side-menu\"><li class=\"nav-header\"><div class=\"profile-element\" uib-dropdown=\"\"><div style=\"text-align: center;\"><img alt=\"image\" width=\"100px\" class=\"img-circle\" ng-src=\"{{main.logoUrl}}\"> <span class=\"block m-t-md\"><strong class=\"font-bold\" style=\"color: white;\">{{main.userName}}</strong></span> <span class=\"text-muted text-xs block\">{{main.empresaName}}</span></div></div><div class=\"logo-element\">MN</div></li><li ui-sref-active=\"active\"><a ui-sref=\"index.main\" href=\"#/index/main\"><i class=\"fa fa-home\"></i> <span class=\"nav-label\">Home - IF</span></a></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.empresaMainId != \'XXX\'\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-tasks\"></i> <span class=\"nav-label\">NFe\'s</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.fornecedor_importacao_faturas\">Importação de NFe\'s</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.recebiveis_importacao_lote\">Importação em Lote</a></li><! -- Somente exibe se Flag do Cedente cnabLiberado for true --><li ui-sref-active=\"active\" ng-if=\"main.cnabLiberado && ( main.empresaMainId == \'76aff93e-1619-4000-8e0c-71f88a9347e4\' || main.empresaMainId == \'894e2ea4-c9fa-47e2-bc7c-f59cd0850536\' || main.empresaMainId == \'bb1dc199-3c67-4fff-9aea-11f6055bdace\' || main.empresaMainId == \'cfcb6e04-3bd3-4b2f-b319-1346a0c7e9bf\')\"><a ui-sref=\"index.recebiveis_importacao_cnab\">Importação de CNAB</a></li><! -- Somente exibe se Flag do Cedente digitarLiberado for true --><li ui-sref-active=\"active\" ng-if=\"main.digitarLiberado\"><a ui-sref=\"index.recebiveis_digitacao_titulo\">Digitação de Títulos</a></li><li ui-sref-active=\"active\"><a ui-sref=\"index.fornecedor_recebiveis_faturas\">Estoque de Títulos</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.empresaMainId != \'XXX\'\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-tasks\"></i> <span class=\"nav-label\">Antecipações</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.fornecedor_antecipacao_minhasantec\">Minhas Antecipações</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.empresaMainId != \'10093ff5-fd99-42d8-8c4b-33306f29afdf\' && main.empresaMainId != \'836c9e79-3d37-4a9c-a618-9925f1136e3d\'\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-users\"></i> <span class=\"nav-label\">Cadastro</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.cadastro_sacado_pesquisa\">Sacados</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.boletoLiberado\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-inbox\"></i> <span class=\"nav-label\">Gestão de Carteira</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.email_carteira_dinamica\">Geração de Boletos</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.empresaMainId != \'836c9e79-3d37-4a9c-a618-9925f1136e3d\'\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-area-chart\"></i> <span class=\"nav-label\">Relatórios</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ng-if=\"main.pentahoRelatorios.includes(\'[17]\') || main.pentahoRelatorios.includes(\'[18]\') || main.pentahoRelatorios.includes(\'[19]\')\"><a href=\"#\" id=\"damian\">Cadastrais <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[17]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RelatorioCedentes\', name: \'Cadastral Cedentes\'})\">Cadastral Cedentes</a></li><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[18]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RelatorioCadastralSacado\', name: \'Cadastral Sacados\'})\">Cadastral Sacados</a></li><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[19]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RelatorioContaCedentes\', name: \'Contas dos Cedentes\'})\">Contas dos Cedentes</a></li></ul></li><li ng-if=\"main.pentahoRelatorios.includes(\'[2]\') || main.pentahoRelatorios.includes(\'[3]\') || main.pentahoRelatorios.includes(\'[4]\')\"><a href=\"#\" id=\"damian\">Operacionais <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[2]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'ResumoOperacaoOper\', name: \'Resumo de Operações por Operador\'})\">Resumo de Operações Operador</a></li><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[3]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'ResumoOperacaoCed\', name: \'Resumo de Operações por Cedente\'})\">Resumo de Operações Cedente</a></li><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[4]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RelatorioIof\', name: \'Relatório de IOF\'})\">Relatório de IOF</a></li></ul></li><li><a href=\"#\" id=\"damian\">Carteira de Títulos <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ng-if=\"main.pentahoRelatorios.includes(\'[20]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'Boleto\', name: \'Boleto\'})\">Boleto</a></li><li ng-if=\"main.pentahoRelatorios.includes(\'[6]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraCedenteAVencer\', name: \'Posição de Carteira Por Cedente a Vencer\'})\">Por Cedente a Vencer</a></li><li ng-if=\"main.pentahoRelatorios.includes(\'[7]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraCedenteVencido\', name: \'Posição de Carteira Por Cedente Vencido\'})\">Por Cedente Vencido</a></li><li ng-if=\"main.pentahoRelatorios.includes(\'[8]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraCedenteLiquidado\', name: \'Posição de Carteira Por Cedente Liquidado\'})\">Por Cedente Liquidado</a></li><li ng-if=\"main.pentahoRelatorios.includes(\'[9]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraSacadoAVencer\', name: \'Posição de Carteira Por Sacado a Vencer\'})\">Por Sacado a Vencer</a></li><li ng-if=\"main.pentahoRelatorios.includes(\'[10]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraSacadoVencido\', name: \'Posição de Carteira Por Sacado Vencido\'})\">Por Sacado Vencido</a></li><li ng-if=\"main.pentahoRelatorios.includes(\'[11]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'PosicaoCarteiraSacadoLiquidado\', name: \'Posição de Carteira Por Sacado Liquidado\'})\">Por Sacado Liquidado</a></li><li ng-if=\"main.pentahoRelatorios.includes(\'[12]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'LiquidadosAlfaPag\', name: \'Títulos Liquidados Por Data de Pagamento\'})\">Liquidados - Data Pagamento</a></li><li ng-if=\"main.pentahoRelatorios.includes(\'[13]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'LiquidadosAlfaProc\', name: \'Títulos Liquidados Por Data de Processamento\'})\">Liquidados - Data Processamento</a></li><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[21]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'BoletimAnaliseCanhotos\', name: \'Relatório de Canhotos\'})\">Relatório de Canhotos</a></li></ul></li><li ng-if=\"main.pentahoRelatorios.includes(\'[1]\') || main.pentahoRelatorios.includes(\'[5]\')\"><a href=\"#\" id=\"damian\">Conta Gráfica <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[1]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'ExtratoContaGrafica\', name: \'Extrato Conta Gráfica\'})\">Extrato</a></li><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[5]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'ExtratoRealizado\', name: \'Conta Gráfica Realizado\'})\">Extrato Realizado</a></li></ul></li><li ng-if=\"main.pentahoRelatorios.includes(\'[14]\') || main.pentahoRelatorios.includes(\'[15]\') || main.pentahoRelatorios.includes(\'[16]\')\"><a href=\"#\" id=\"damian\">Gerenciais <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\"><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[14]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RiscoSinteticoCedente\', name: \'Risco Sintético Cedente\'})\">Risco Sintético Cedente</a></li><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[15]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RiscoSinteticoCedenteCtaGrafica\', name: \'Risco Sintético Cedente Cta Gráfica\'})\">Risco Sintético Cedente Cta Gráfica</a></li><li ui-sref-active=\"active\" ng-if=\"main.pentahoRelatorios.includes(\'[16]\')\"><a ui-sref=\"index.relatorio_pentaho({report: \'RiscoSinteticoOperador\', name: \'Risco Sintético Operador\'})\">Risco Sintético Operador</a></li></ul></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\" ng-if=\"main.empresaMainId == \'76aff93e-1619-4000-8e0c-71f88a9347e4\' || main.empresaMainId == \'cfcb6e04-3bd3-4b2f-b319-1346a0c7e9bf\' || main.empresaMainId == \'10093ff5-fd99-42d8-8c4b-33306f29afdf\' || main.empresaMainId == \'894e2ea4-c9fa-47e2-bc7c-f59cd0850536\' || main.empresaMainId == \'e9dedde9-ed7a-4284-a492-b495f24a8594\' || main.empresaMainId == \'bb1dc199-3c67-4fff-9aea-11f6055bdace\' || main.empresaMainId == \'0a15c7eb-062a-4d7f-8e7f-9a9fa4910bc9\' || main.empresaMainId == \'e9059856-429a-4633-b1c0-8efe23cc27d0\'\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-bandcamp\"></i> <span class=\"nav-label\">Processos</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.retorno_cnab_cliente\">Retorno de Cnabs</a></li></ul></li><li ng-class=\"{active: $state.includes(\'index\')}\"><a href=\"#\" aria-expanded=\"true\"><i class=\"fa fa-user\"></i> <span class=\"nav-label\">Meu Perfil</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level collapse\" ng-class=\"{in: $state.includes(\'index\')}\"><li ui-sref-active=\"active\"><a ui-sref=\"index.alterarsenha\">Alterar Senha</a></li></ul></li></ul></div></nav>");
$templateCache.put("app/components/common/topnavbar.html","<div class=\"row border-bottom\"><nav class=\"navbar navbar-static-top white-bg\" role=\"navigation\" style=\"margin-bottom: 0\"><div class=\"navbar-header\"><span minimaliza-sidebar=\"\"></span><form role=\"search\" class=\"navbar-form-custom\" method=\"post\" action=\"\"><div class=\"form-group\"><input type=\"text\" placeholder=\"Gestão de Talentos\" class=\"form-control\" name=\"top-search\" id=\"top-search\"></div></form></div><ul class=\"nav navbar-top-links navbar-right\"><li><a ui-sref=\"login.autenticar\"><i class=\"fa fa-sign-out\"></i> Log out</a></li></ul></nav></div>");
$templateCache.put("app/home/modal/detalhesSolicitacao.html","<div class=\"modal-content\"><div class=\"modal-header\"><button type=\"button\" class=\"close\" data-dismiss=\"modal\"><span aria-hidden=\"true\">×</span><span class=\"sr-only\">Fechar</span></button><h4 class=\"modal-title\">Empresa ABCD Ltda.</h4><small class=\"font-bold\">Detalhes da solicitação de antecipação de recebíveis.</small></div><div class=\"modal-body\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" value=\"Empresa ABCD Ltda.\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" value=\"01.203.423/0001-45\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" value=\"010002-100\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Endereço</label> <input type=\"text\" value=\"Rua Boa Vista, 230\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" value=\"São Paulo\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">UF</label> <input type=\"text\" value=\"SP\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"text\" value=\"R$ 50.000,00\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Prazo</label> <input type=\"text\" value=\"90 dias\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Descrição da proposta</label> <input type=\"text\" value=\"\" class=\"form-control\"></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\">Enviar Proposta</button></div></div>");
$templateCache.put("app/invoice/cnabSincronizado/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n    .btn-remove {\r\n        color: #fff;\r\n        background-color: #7910c5;\r\n        border-color: #862cc6;\r\n    }\r\n    .btn-remove:focus,\r\n    .btn-remove.focus {\r\n        color: #fff;\r\n        background-color: #e11273;\r\n        border-color: #e03786;\r\n    }\r\n    .btn-remove:hover {\r\n        color: #fff;\r\n        background-color: #b60d5c;\r\n        border-color: #944a68;\r\n    }\r\n    .status-success {\r\n        color: #1ab394;\r\n        font-weight: bold;\r\n    }\r\n    .status-error {\r\n        color: #ed5565;\r\n        font-weight: bold;\r\n    }\r\n    .status-processing {\r\n        color: #f8ac59;\r\n        font-weight: bold;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>CNAB Sincronizado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>NFe\'s</a></li><li class=\"active\"><strong>CNAB Sincronizado</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"text-right\" style=\"margin-top: 20px;\"><span ng-if=\"controller.conexaoAssinaNet\" class=\"label label-success\"><i class=\"fa fa-check\"></i> AssinaNet Online</span> <span ng-if=\"!controller.conexaoAssinaNet\" class=\"label label-danger\"><i class=\"fa fa-times\"></i> AssinaNet Offline</span></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.processandoPromise\"><div class=\"row\" ng-if=\"!controller.arquivoProcessado\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-cloud-upload\"></i> Sincronizar CNAB com AssinaNet</h5></div><div class=\"ibox-content\"><form name=\"cnabForm\" novalidate=\"\"><div class=\"row\"><div class=\"col-md-4\"><div class=\"form-group\"><label>ID do Cedente *</label> <input type=\"text\" class=\"form-control\" ng-model=\"controller.dadosEmpresa.idCedente\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>ID Cedente AssinaNet *</label> <input type=\"text\" class=\"form-control\" ng-model=\"controller.dadosEmpresa.idCedenteAssinaNet\" required=\"\"></div></div><div class=\"col-md-4\"><div class=\"form-group\"><label>&nbsp;</label><div><button type=\"button\" class=\"btn btn-info btn-sm\" ng-click=\"controller.testarConexao()\"><i class=\"fa fa-refresh\"></i> Testar Conexão</button></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group\"><label>Arquivo CNAB *</label><div class=\"dropzone dz-clickable\"><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-sm btn-success btn-file\" style=\"font-size: 14px;\"><span class=\"fileinput-new\"><i class=\"fa fa-file-archive-o\"></i> Selecione um arquivo CNAB (.ret, .rem, .cnab)</span> <input type=\"file\" accept=\".ret,.rem,.cnab\" set-model-on-change=\"\" ng-model=\"controller.selectedFile\" ng-change=\"controller.onArquivoSelecionado()\" name=\"arquivo\"></span> <span class=\"fileinput-filename\" ng-if=\"controller.nomeArquivo\">{{controller.nomeArquivo}}</span> <a href=\"#\" class=\"close fileinput-exists\" ng-if=\"controller.nomeArquivo\" ng-click=\"controller.limparArquivo()\" style=\"float: none\">×</a></div></div></div></div></div></div><div class=\"row\"><div class=\"col-md-12\"><div class=\"form-group text-right\"><button type=\"button\" class=\"btn btn-success btn-lg\" ng-click=\"controller.sincronizarCnab()\" ng-disabled=\"!controller.podeEnviar()\"><i class=\"fa fa-cloud-upload\" ng-if=\"!controller.processando\"></i> <i class=\"fa fa-spinner fa-spin\" ng-if=\"controller.processando\"></i> {{controller.processando ? \'Processando...\' : \'Sincronizar CNAB\'}}</button></div></div></div></form></div></div></div></div><div class=\"row\" ng-if=\"controller.arquivoProcessado\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title\" ng-class=\"controller.resultado.sucesso ? \'bg-success\' : \'bg-danger\'\"><h5><i class=\"fa fa-check\" ng-if=\"controller.resultado.sucesso\"></i> <i class=\"fa fa-times\" ng-if=\"!controller.resultado.sucesso\"></i> Resultado do Processamento</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-md-6\"><dl class=\"dl-horizontal\"><dt>Arquivo:</dt><dd>{{controller.resultado.nomeArquivo}}</dd><dt>Status:</dt><dd><span ng-class=\"controller.getStatusClass(controller.resultado.statusProcessamento)\">{{controller.resultado.statusProcessamento}}</span></dd><dt>Data Envio:</dt><dd>{{controller.resultado.dataHoraEnvio | date:\'dd/MM/yyyy HH:mm:ss\'}}</dd><dt>Data Retorno:</dt><dd>{{controller.resultado.dataHoraRetorno | date:\'dd/MM/yyyy HH:mm:ss\'}}</dd></dl></div><div class=\"col-md-6\"><div ng-if=\"controller.resultado.detalhes\"><h4>Detalhes:</h4><div class=\"alert alert-info\">{{controller.resultado.detalhes}}</div></div><div ng-if=\"controller.resultado.erros && controller.resultado.erros.length > 0\"><h4>Erros:</h4><div class=\"alert alert-danger\"><ul><li ng-repeat=\"erro in controller.resultado.erros\">{{erro}}</li></ul></div></div><div ng-if=\"controller.resultado.temArquivoProcessado\"><button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.baixarArquivoProcessado()\"><i class=\"fa fa-download\"></i> Baixar Arquivo Processado</button></div></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.arquivoProcessado\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: center; padding: 10px;\"><button class=\"btn btn-primary btn-lg\" type=\"button\" ng-click=\"controller.novoProcessamento()\"><i class=\"fa fa-plus\"></i> Novo Processamento</button> <button class=\"btn btn-info btn-lg\" type=\"button\" ng-click=\"controller.verLogs()\" style=\"margin-left: 10px;\"><i class=\"fa fa-list\"></i> Ver Histórico</button></div></div></div></div><div class=\"row\" ng-if=\"controller.mostrarLogs && controller.logs.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-info\" ng-click=\"controller.showhide(\'iconBoxLogs\', \'boxLogs\')\"><h5><i class=\"fa fa-history\"></i> Histórico de Processamentos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxLogs\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxLogs\" class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover\"><thead><tr><th>Data</th><th>Módulo</th><th>Status</th><th>Mensagem</th><th>Ações</th></tr></thead><tbody><tr ng-repeat=\"log in controller.logs\"><td>{{log.data | date:\'dd/MM/yyyy HH:mm:ss\'}}</td><td>{{log.modulo}}</td><td><span class=\"label\" ng-class=\"log.isSucesso ? \'label-success\' : \'label-danger\'\">{{log.isSucesso ? \'Sucesso\' : \'Erro\'}}</span></td><td>{{log.mensagem}}</td><td><button type=\"button\" class=\"btn btn-xs btn-info\" ng-click=\"controller.verDetalhesLog(log.id)\"><i class=\"fa fa-eye\"></i> Detalhes</button></td></tr></tbody></table></div></div></div></div></div></div>");
$templateCache.put("app/invoice/digitacao/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Digitação de Título</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>NFe\'s</a></li><li class=\"active\"><strong>Inclusão Manual</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.concluirPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDuplicatas\', \'boxDuplicatas\')\"><h5><i class=\"fa fa-tags\"></i> Títulos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDuplicatas\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDuplicatas\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-lg-12 m-b\" style=\"text-align: right;\"><button class=\"btn btn-success\" ng-click=\"controller.validarEPrevenir($event)\" style=\"width: 200px;\"><i class=\"fa fa-plus\"></i> Adicionar Título</button></div></div><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Título</th><th class=\"white-bg\">Cedente</th><th class=\"white-bg\">Sacado</th><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.titulos\"><td>{{p.numero}}</td><td>{{p.cedente.cnpj}} - {{p.cedente.razaoSocial}}</td><td>{{p.sacado.cnpj}} - {{p.sacado.razaoSocial}}</td><td>{{p.dataVencimento | date:\'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{p.valor | currency:\'R$ \'}}</td><td style=\"text-align: center; width: 1px;\"><a ng-click=\"controller.removerTitulo(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody><tfoot><tr style=\"background-color: white\"><td><b>{{controller.titulos.length}} título(s)</b></td><td colspan=\"3\"></td><td style=\"white-space: nowrap;\"><b class=\"ng-binding\">R$ {{ (controller.total | number:2) }}</b></td></tr></tfoot></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.titulos.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-6\" style=\"text-align: left;\"></div><div class=\"col-lg-6\"><button class=\"btn btn-md btn-primary\" type=\"button\" style=\"width: 200px;\" ng-click=\"controller.concluir()\"><i class=\"fa fa-save\"></i> Concluir</button></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/importarCnab/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n    .btn-remove {\r\n        color: #fff;\r\n        background-color: #7910c5;\r\n        border-color: #862cc6;\r\n    }\r\n    .btn-remove:focus,\r\n    .btn-remove.focus {\r\n        color: #fff;\r\n        background-color: #e11273;\r\n        border-color: #e03786;\r\n    }\r\n    .btn-remove:hover {\r\n        color: #fff;\r\n        background-color: #b60d5c;\r\n        border-color: #944a68;\r\n    }    \r\n \r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Importação de CNAB</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>NFe\'s</a></li><li class=\"active\"><strong>Importar CNAB</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.concluirPromise\"><div class=\"row\" cg-busy=\"controller.validarPromise\" ng-if=\"controller.duplicatas.length == 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Importar CNAB de Títulos para o Estoque</h5><div ibox-tools=\"\" class=\"ng-scope\"></div></div><div class=\"ibox-content\"><form action=\"#\" class=\"dropzone dz-clickable ng-pristine ng-valid\" dropzone=\"\" id=\"dropzone\"><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-sm btn-success btn-file\" style=\"font-size: 14px;\"><span class=\"fileinput-new\"><i class=\"fa fa-file-archive-o\"></i> Selecione um arquivo no padrão (CNAB) para importar seus Títulos</span> <span class=\"fileinput-exists\"></span> <input type=\"file\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-click=\"controller.validarEPrevenir($event)\" ng-change=\"controller.adicionarItem()\" name=\"...\"></span> <span class=\"fileinput-filename\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none\">×</a></div></div></form></div></div></div></div><div class=\"row\" ng-if=\"controller.duplicatas.length > 0\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDuplicatas\', \'boxDuplicatas\')\"><h5><i class=\"fa fa-tags\"></i> Títulos</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDuplicatas\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDuplicatas\" class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Título</th><th class=\"white-bg\">Sacado</th><th class=\"white-bg\">Emissão</th><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.duplicatas\"><td>{{p.numeroTitulo}}</td><td>{{p.cnpjSacado}} - {{p.nomeSacado}}</td><td>{{p.dataEmissao | date:\'dd/MM/yyyy\'}}</td><td ng-if=\"p.situacao == 3\" ng-style=\"{\'color\': p.situacao == 3 ? \'crimson\' : \'\'}\">{{p.dataVencimento | date:\'dd/MM/yyyy\'}}</td><td ng-if=\"p.situacao != 3\">{{p.dataVencimento | date:\'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{p.valor | currency:\'R$ \'}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 1\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-check\"></i> Normal</a> <a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 2\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-info\"></i> Informativo</a> <a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 3\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-bell\"></i> Inválido</a></td><td style=\"text-align: center; width: 1px;\"><a ng-click=\"controller.removerTitulo(p)\" class=\"btn btn-remove btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody><tfoot><tr style=\"background-color: white\"><td><b>{{controller.duplicatas.length}} título(s)</b></td><td><b>Cnab Padrão: {{controller.headerarquivo.nomeBanco}}</b></td><td colspan=\"2\"></td><td style=\"white-space: nowrap;\"><b class=\"ng-binding\">R$ {{ (controller.total | number:2) }}</b></td></tr></tfoot></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.falhas.length > 0\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-danger\" ng-click=\"controller.showhide(\'iconBoxFalhas\', \'boxFalhas\')\"><h5><i class=\"fa fa-tags\"></i> Falhas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFalhas\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFalhas\" class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Nfe</th><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Título</th><th class=\"white-bg\">Mensagem</th><th class=\"white-bg\">Cedente</th></tr></thead><tbody><tr ng:repeat=\"p in controller.falhas\" ng-style=\"p.statusCadastro == 1 && {\'background-color\':\'yellow\'}\"><td>{{p.numeroNfe}}</td><td>{{p.titulo.numeroTitulo}}</td><td>{{p.mensagem}}</td><td>{{p.titulo.notaFiscal.cedente.cnpj}} - {{p.titulo.notaFiscal.cedente.razaoSocial}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.duplicatas.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-6\" style=\"text-align: left;\"><button class=\"btn btn-md btn-danger\" type=\"button\" style=\"width: 200px;\" ng-click=\"controller.novo()\"><i class=\"fa fa-retweet\"></i> Nova Importação</button></div><div class=\"col-lg-6\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 200px;\" ng-click=\"controller.concluir()\"><i class=\"fa fa-save\"></i> Enviar Títulos</button></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/importarLote/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Importação em Lote</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>NFe\'s</a></li><li class=\"active\"><strong>Importação em Lote</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.concluirPromise\"><div class=\"row\" cg-busy=\"controller.validarPromise\" ng-if=\"controller.duplicatas.length == 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Notas Fiscais (NF-e)</h5><div ibox-tools=\"\" class=\"ng-scope\"></div></div><div class=\"ibox-content\"><form action=\"#\" class=\"dropzone dz-clickable ng-pristine ng-valid\" dropzone=\"\" id=\"dropzone\"><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-sm btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-file-archive-o\"></i> Selecione o arquivo no formato .ZIP contendo as NFe\'s</span> <span class=\"fileinput-exists\">Alterar</span> <input type=\"file\" accept=\".zip\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-click=\"controller.validarEPrevenir($event)\" ng-change=\"controller.adicionarItem()\" name=\"...\"></span> <span class=\"fileinput-filename\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none\">×</a></div></div></form></div></div></div></div><div class=\"row\" ng-if=\"controller.duplicatas.length > 0\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxDuplicatas\', \'boxDuplicatas\')\"><h5><i class=\"fa fa-tags\"></i> Duplicatas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxDuplicatas\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxDuplicatas\" class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Nfe</th><th class=\"white-bg\">Cedente</th><th class=\"white-bg\">Sacado</th><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Título</th><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.duplicatas\" ng-style=\"p.statusCadastro == 1 && {\'background-color\':\'yellow\'}\"><td>{{p.numeroNfe}}</td><td>{{p.titulo.notaFiscal.cedente.cnpj}} - {{p.titulo.notaFiscal.cedente.razaoSocial}}</td><td>{{p.titulo.notaFiscal.sacado.razaoSocial}}</td><td>{{p.titulo.numeroTitulo}}</td><td>{{p.titulo.dataVencimento | date:\'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\">{{p.titulo.valorTexto}}</td><td>{{p.titulo.situacaoMotivo}}</td><td style=\"text-align: center; width: 1px;\"><a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.titulo.situacao == 3\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-bell\"></i> Inválido</a> <a ng-click=\"controller.removerTitulo(p)\" ng-if=\"p.titulo.situacao != 3\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody><tfoot><tr style=\"background-color: white\"><td colspan=\"1\"></td><td ng-if=\"(controller.getTotalDuplicatasInvalidas()) == 1\" style=\"color: brown\"><b>ATENÇÃO: {{ (controller.getTotalDuplicatasInvalidas()) }} Título está inválido e não irá para o estoque!</b></td><td ng-if=\"(controller.getTotalDuplicatasInvalidas()) > 1\" style=\"color: brown\"><b>ATENÇÃO: {{ (controller.getTotalDuplicatasInvalidas()) }} Títulos estão inválidos e não irão para o estoque!</b></td><td ng-if=\"!(controller.getTotalDuplicatasInvalidas())\"></td><td colspan=\"3\"></td><td style=\"white-space: nowrap;\"><b class=\"ng-binding\">R$ {{ (controller.getTotalDuplicatas() | number:2) }}</b></td></tr></tfoot></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.falhas.length > 0\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins collapsed\"><div class=\"ibox-title bg-danger\" ng-click=\"controller.showhide(\'iconBoxFalhas\', \'boxFalhas\')\"><h5><i class=\"fa fa-tags\"></i> Falhas</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFalhas\" class=\"fa fa-chevron-up\"></i></a></div></div><div id=\"boxFalhas\" class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Nfe</th><th class=\"white-bg\" style=\"white-space: nowrap;\">Nº Título</th><th class=\"white-bg\">Mensagem</th><th class=\"white-bg\">Cedente</th></tr></thead><tbody><tr ng:repeat=\"p in controller.falhas\" ng-style=\"p.statusCadastro == 1 && {\'background-color\':\'yellow\'}\"><td>{{p.numeroNfe}}</td><td>{{p.titulo.numeroTitulo}}</td><td>{{p.mensagem}}</td><td>{{p.titulo.notaFiscal.cedente.cnpj}} - {{p.titulo.notaFiscal.cedente.razaoSocial}}</td></tr></tbody></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.duplicatas.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-6\" style=\"text-align: left;\"><button class=\"btn btn-md btn-danger\" type=\"button\" style=\"width: 200px;\" ng-click=\"controller.novo()\"><i class=\"fa fa-retweet\"></i> Nova Importação</button></div><div class=\"col-lg-6\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 200px;\" ng-click=\"controller.concluir()\"><i class=\"fa fa-save\"></i> Enviar Títulos</button></div></div></div></div></div></div></div>");
$templateCache.put("app/relatorio/teste/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>{{controller.name}}</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Relatórios</a></li><li class=\"active\"><strong>{{controller.name}}</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><iframe id=\"frameID\" width=\"100%\" height=\"1000\" frameborder=\"0\" ng-src=\"{{controller.iFrameUrl}}\"></iframe></div></div></div>");
$templateCache.put("app/sacado/cadastro/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Cadastrar Sacado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Sacado</a></li><li class=\"active\"><strong>Cadastro</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados do Sacado</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome / Razão Social</label> <input type=\"text\" ng-model=\"controller.sacado.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF / CNPJ</label> <input type=\"text\" mask=\"{{ controller.sacado.cnpj.length > 14 ? \'99.999.999/9999-99\' : \'999.999.999-999999999\' }}\" ng-model=\"controller.sacado.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.sacado.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Estado</label><select ng-model=\"controller.sacado.endereco.uf\" class=\"form-control inputDisabledModal\"><option value=\"AC\">ACRE</option><option value=\"AL\">ALAGOAS</option><option value=\"AP\">AMAPÁ</option><option value=\"AM\">AMAZONAS</option><option value=\"BA\">BAHIA</option><option value=\"CE\">CEARÁ</option><option value=\"DF\">DISTRITO FEDERAL</option><option value=\"ES\">ESPÍRITO SANTO</option><option value=\"GO\">GOIÁS</option><option value=\"MA\">MARANHÃO</option><option value=\"MT\">MATO GROSSO</option><option value=\"MS\">MATO GROSSO DO SUL</option><option value=\"MG\">MINAS GERAIS</option><option value=\"PA\">PARÁ</option><option value=\"PB\">PARAÍBA</option><option value=\"PR\">PARANÁ</option><option value=\"PE\">PERNAMBUCO</option><option value=\"PI\">PIAUÍ</option><option value=\"RJ\">RIO DE JANEIRO</option><option value=\"RN\">RIO GRANDE DO NORTE</option><option value=\"RS\">RIO GRANDE DO SUL</option><option value=\"RO\">RONDÔNIA</option><option value=\"RR\">RORAIMA</option><option value=\"SC\">SANTA CATARINA</option><option value=\"SP\">SÃO PAULO</option><option value=\"SE\">SERGIPE</option><option value=\"TO\">TOCANTINS</option><option value=\"EX\">ESTRANGEIRO</option></select></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.salvar()\"><i class=\"fa fa-arrow-right\"></i> Concluir</button></div></div></div></div></div>");
$templateCache.put("app/sacado/consulta/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Consultar Sacado</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Sacado</a></li><li class=\"active\"><strong>Consultar</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados do Sacado</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome / Razão Social</label> <input type=\"text\" ng-model=\"controller.sacado.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF / CNPJ</label> <input type=\"text\" mask=\"{{ controller.sacado.cnpj.length > 14 ? \'99.999.999/9999-99\' : \'999.999.999-999999999\' }}\" ng-model=\"controller.sacado.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxEndereco\" class=\"fa fa-chevron-up\"></i></a></div></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.sacado.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Estado</label><select ng-model=\"controller.sacado.endereco.uf\" class=\"form-control inputDisabledModal\"><option value=\"AC\">ACRE</option><option value=\"AL\">ALAGOAS</option><option value=\"AP\">AMAPÁ</option><option value=\"AM\">AMAZONAS</option><option value=\"BA\">BAHIA</option><option value=\"CE\">CEARÁ</option><option value=\"DF\">DISTRITO FEDERAL</option><option value=\"ES\">ESPÍRITO SANTO</option><option value=\"GO\">GOIÁS</option><option value=\"MA\">MARANHÃO</option><option value=\"MT\">MATO GROSSO</option><option value=\"MS\">MATO GROSSO DO SUL</option><option value=\"MG\">MINAS GERAIS</option><option value=\"PA\">PARÁ</option><option value=\"PB\">PARAÍBA</option><option value=\"PR\">PARANÁ</option><option value=\"PE\">PERNAMBUCO</option><option value=\"PI\">PIAUÍ</option><option value=\"RJ\">RIO DE JANEIRO</option><option value=\"RN\">RIO GRANDE DO NORTE</option><option value=\"RS\">RIO GRANDE DO SUL</option><option value=\"RO\">RONDÔNIA</option><option value=\"RR\">RORAIMA</option><option value=\"SC\">SANTA CATARINA</option><option value=\"SP\">SÃO PAULO</option><option value=\"SE\">SERGIPE</option><option value=\"TO\">TOCANTINS</option><option value=\"EX\">ESTRANGEIRO</option></select></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.sacado.email\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"text-align: right; padding-bottom: 10px;\"><button class=\"btn btn-md btn-success\" type=\"button\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-arrow-right\"></i> Atualizar</button></div></div></div></div></div>");
$templateCache.put("app/sacado/selecionar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Sacado</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"number\" ng-model=\"controller.filtro.codigo\" class=\"form-control\"></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF/CNPJ</label> <input type=\"text\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-success\" style=\"width: 140px;\" ng-click=\"controller.filtrarPesquisa()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.pesquisarPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>CNPJ</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.razaoSocial}}</td><td>{{p.cnpj}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" num-pages=\"pagination.numPages\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\"></ul></div></div></footer></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/admin/usuario/pesquisar/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Pesquisar Usuário</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Usuário</a></li><li class=\"active\"><strong>Pesquisar</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"><a class=\"btn btn-sm btn-success\" ng-click=\"usuarioPesquisa.incluir()\">NOVO USUÁRIO</a></div></div></div><div class=\"wrapper wrapper-content animated fadeInRight ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Resultado</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 40%\">Nome</th><th style=\"width: 30%\">Login</th><th style=\"width: 30%\">E-mail</th></tr></thead><tbody><tr ng:repeat=\"p in usuarioPesquisa.items\"><td>{{p.nome}}</td><td>{{p.login}}</td><td>{{p.Email}}</td><td style=\"text-align: center;\"><a ng-click=\"usuarioPesquisa.alterar(p)\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-edit\"></i> Editar</a></td></tr></tbody></table></div><ul ng-if=\"usuarioPesquisa.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === 1}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in usuarioPesquisa.pager.pages\" ng-class=\"{active:usuarioPesquisa.pager.currentPage === page}\"><a ng-click=\"usuarioPesquisa.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:usuarioPesquisa.pager.currentPage === usuarioPesquisa.pager.totalPages}\"><a ng-click=\"usuarioPesquisa.setPage(usuarioPesquisa.pager.totalPages)\">Última</a></li></ul></div></div></div></div></div>");
$templateCache.put("app/cadastro/sacado/selecionar/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Selecionar Sacado</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding-top: 20px;\"><div class=\"row\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Código</label> <input type=\"number\" ng-model=\"controller.filtro.codigo\" class=\"form-control\"></div></div><div class=\"col-sm-5\"><div class=\"form-group\"><label class=\"col-form-label\">Nome</label> <input type=\"text\" ng-model=\"controller.filtro.nome\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF/CNPJ</label> <input type=\"text\" ng-model=\"controller.filtro.cnpj\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><button class=\"btn btn-primary\" style=\"width: 140px;\" ng-click=\"controller.cadastrarSacado()\"><i class=\"fa fa-plus\"></i> Novo</button> <button class=\"btn btn-success\" style=\"width: 140px;\" ng-click=\"controller.filtrarPesquisa()\"><i class=\"fa fa-search\"></i> Pesquisar</button></div></div><div class=\"row\"><div class=\"col-lg-12\" cg-busy=\"controller.pesquisarPromise\" style=\"margin-bottom: 10px; margin-top: 20px;\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nome</th><th>CNPJ</th></tr></thead><tbody cg-busy=\"controller.listarPromise\" style=\"background-color: white;\"><tr ng:repeat=\"p in controller.items\"><td>{{p.razaoSocial}}</td><td>{{p.cnpj}}</td><td style=\"width: 1px; white-space: nowrap;\"><button ng-click=\"controller.selecionar(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-check\"></i> Selecionar</button></td></tr></tbody></table></div><footer class=\"table-footer\"><div class=\"row\"><div class=\"col-md-6 pagination-container\"><ul class=\"pagination-sm\" uib-pagination=\"\" previous-text=\"Anterior\" next-text=\"Próximo\" total-items=\"pagination.totalItems\" items-per-page=\"pagination.perPage\" ng-model=\"pagination.current\" num-pages=\"pagination.numPages\" max-size=\"pagination.maxSize\" boundary-link-numbers=\"true\" data-ng-change=\"onPageChange()\" rotate=\"false\"></ul></div></div></footer></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.cancelarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/email/carteira/dinamica/index.html","<div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-9\"><h2>Geração de Boletos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Gestão de Carteira</a></li><li class=\"active\"><strong>Geração de Boletos</strong></li></ol></div><div class=\"col-lg-3\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Selecionar Lançamentos</h5><div class=\"ibox-tools\"><a ng-click=\"controller.redirectToURL(); $event.stopPropagation()\" title=\"Manual: Geração de Boleto\"><i class=\"fa fa-book\" style=\"color: white; font-size: 22px;\"></i></a> <a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-2\"><label class=\"col-form-label\">Data de Vencimento</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoInicial\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoFinal\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Data da Operação</label> <input type=\"date\" ng-model=\"controller.filtro.operacaoInicial\" class=\"form-control\"></div><div class=\"col-sm-2\"><label class=\"col-form-label\">Até</label> <input type=\"date\" ng-model=\"controller.filtro.operacaoFinal\" class=\"form-control\"></div></div><br><div class=\"row\"><div class=\"col-sm-2\"><label class=\"col-form-label\">Sacado</label><select class=\"form-control\" ng-model=\"controller.filtro.tipoSacado\"><option ng-value=\"0\">Por CNPJ</option><option ng-value=\"1\">Por Grupo</option></select></div><div class=\"col-sm-6\" ng-if=\"controller.filtro.tipoSacado == 0\"><label class=\"col-form-label\">&nbsp;</label> <button ng-click=\"controller.selecionarSacadoModal()\" class=\"btn btn-success btn-block\" style=\"font-size: 12px;\">{{ controller.filtro.sacado == null ? \'Selecionar Sacado\' : ((controller.filtro.sacado.razaoSocial | limitTo: 25) + \' - \' + controller.filtro.sacado.cnpj) }}</button></div><div class=\"col-sm-4\" ng-if=\"controller.filtro.tipoSacado == 1\"><label class=\"col-form-label\">&nbsp;</label> <input type=\"text\" ng-model=\"controller.filtro.grupoSacado\" class=\"form-control\" mask=\"99.999.999\"></div></div><div class=\"row\"><div class=\"col-sm-12\" style=\"text-align: right;\"><br><button class=\"btn btn-success\" style=\"width: 200px\" ng-click=\"controller.pesquisar()\">Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.acaoTabelaPromise\" ng-if=\"controller.registros != null && controller.registros.length > 0\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Lançamentos</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"controller.selecionadoTodos\" ng-change=\"controller.selecionarTodos()\"></th><th ng-click=\"controller.ordenarResultado(\'lancamento\')\" style=\"width: 10px;\">Lançamento</th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"width: 10px;\">Título</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">Sacado</th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\">Vencimento</th><th ng-click=\"controller.ordenarResultado(\'diasvencido\')\" style=\"width: 60px;\">Dias em Atraso</th><th ng-click=\"controller.ordenarResultado(\'banco\')\">Banco</th><th ng-click=\"controller.ordenarResultado(\'valortitulo\')\">Valor Título</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td style=\"width: 1px;\"><input icheck=\"\" type=\"checkbox\" ng-model=\"p.selecionado\"></td><td>{{p.lancamento}}</td><td style=\"white-space: nowrap; width: 1px;\">{{p.numeroDocumento}}</td><td>{{p.nomeSacado}}<br>E-mail: {{p.emailDestinatario}}</td><td ng-if=\"p.isVencido\" style=\"color: red;\">{{p.dataVencimento}}</td><td ng-if=\"p.isVencido == false\">{{p.dataVencimento}}</td><td>{{p.diasVencido}}</td><td>{{p.codBanco}} - {{p.nomeBanco}}</td><td>{{p.valorTitulo | currency:\'R$ \'}}</td><td><button ng-click=\"controller.visualizarBoleto(p)\" class=\"btn btn-success btn-xs btn-block\">Visualizar</button></td></tr></tbody></table><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div><div style=\"text-align: right; margin-top: 10px;\"><table width=\"100%\" cellspacing=\"1\"><tr><td style=\"width: 99%;\" colspan=\"4\"></td><td style=\"width: 1px;\"><button ng-click=\"controller.baixarPdf()\" style=\"margin-bottom: 2px; width: 200px\" class=\"btn btn-success\">Baixar PDF</button></td></tr><tr><td colspan=\"5\"></td></tr><tr ng-if=\"controller.filtro.sacado != null\"><td style=\"width: 90%;\"></td><td style=\"text-align: right; white-space: nowrap;\"><b>E-mail Cópia:&nbsp;&nbsp;</b></td><td style=\"text-align: right;\"><input type=\"text\" ng-model=\"controller.email\" class=\"form-control\" style=\"width: 400px;\"></td><td style=\"width: 10px;\">&nbsp;&nbsp;</td><td style=\"width: 1px;\"><button ng-click=\"controller.enviarEmail()\" class=\"btn btn-success\" style=\"width: 200px\">Enviar E-mail</button></td></tr></table></div></div></div></div></div></div>");
$templateCache.put("app/fornecedor/antecipacao/minhas_antecipacoes/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n\r\n    .btn-fixed-size {\r\n        width: 200px; /* Defina a largura fixa */\r\n        height: 25px; /* Defina a altura fixa */\r\n        white-space: normal; /* Permite quebra de linha, caso o texto seja longo */\r\n        text-align: center; /* Centraliza o texto */\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Antecipações</h2><ol class=\"breadcrumb\"><li><a>Antecipações</a></li><li class=\"active\"><strong>Disponíveis</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Pesquisa</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Fornecedor</label> <input type=\"text\" ng-model=\"controller.filtro.fornecedor\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número da Antecipação</label> <input type=\"number\" ng-model=\"controller.filtro.numeroAntecipacao\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Status</label><select class=\"form-control\" ng-model=\"controller.filtro.status\" ng-change=\"controller.filtrarPesquisa()\"><option value=\"\">Todos</option><option value=\"2\">Aguardando Proposta IC (Instituição Credora)</option><option value=\"3\">Aguardando Aprovação do Fornecedor (100%)</option><option value=\"6\">Aguardando Aprovação do Fornecedor (Parcial)</option><option value=\"4\">Aguardando Formalização</option><option value=\"8\">Aguardando Assinatura</option><option value=\"10\">Em Processo de Assinatura</option><option value=\"15\">Assinatura Finalizada</option><option value=\"5\">Recusada pela IC</option><option value=\"7\">Recusada pelo Fornecedor</option><option value=\"9\">Assinado e Concluído</option><option value=\"14\">Em Analise</option><option value=\"18\">Análise finalizada</option><option value=\"23\">Concluído</option></select></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Solicitação</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"number\" ng-model=\"controller.filtro.valorDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"number\" ng-model=\"controller.filtro.valorAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Disponíveis</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 570px;\"><table class=\"table table-bordered\"><thead><tr><th>#</th><th>Data da Solicitação</th><th>Fornecedor</th><th style=\"width: 1px;\">Status</th><th>Valor</th></tr></thead><tbody><tr ng:repeat=\"p in controller.registros\"><td>{{p.numero}}</td><td>{{p.data | date: \'dd/MM/yyyy HH:mm\'}}</td><td>{{p.fornecedor}}</td><td ng-if=\"p.status == 1\"><button class=\"btn btn-success btn-xs btn-fixed-size\">Aguardando Envio para IC</button></td><td ng-if=\"p.status == 2\"><button class=\"btn btn-success btn-xs btn-fixed-size\">Aguardando Proposta IC</button></td><td ng-if=\"p.status == 3\"><button class=\"btn btn-blueviolet btn-xs btn-fixed-size\">Aguardando Aprovação do Fornecedor</button></td><td ng-if=\"p.status == 6\"><button class=\"btn btn-blueviolet btn-xs btn-fixed-size\">Aguardando Aprovação do Fornecedor</button></td><td ng-if=\"p.status == 4\"><button class=\"btn btn-brown btn-xs btn-fixed-size\">Aguardando Formalização</button></td><td ng-if=\"p.status == 8\"><button class=\"btn btn-primary btn-xs btn-fixed-size\">Aguardando Assinatura</button></td><td ng-if=\"p.status == 10\"><button class=\"btn btn-olivedrab btn-xs btn-fixed-size\">Em Processo de Assinatura</button></td><td ng-if=\"p.status == 15\"><button class=\"btn btn-seagreen btn-xs btn-fixed-size\">Assinatura Finalizada</button></td><td ng-if=\"p.status == 5\"><button class=\"btn btn-danger btn-xs btn-fixed-size\">Recusada pela IC</button></td><td ng-if=\"p.status == 7\"><button class=\"btn btn-danger btn-xs btn-fixed-size\">Recusada pelo Fornecedor</button></td><td ng-if=\"p.status == 14\"><button class=\"btn btn-warning btn-xs btn-fixed-size\">Operação em Analise</button></td><td ng-if=\"p.status == 21\"><button class=\"btn btn-warning btn-xs btn-fixed-size\">Operação em Analise</button></td><td ng-if=\"p.status == 22\"><button class=\"btn btn-chocolate btn-xs btn-fixed-size\">Análise finalizada</button></td><td ng-if=\"p.status == 18\"><button class=\"btn btn-chocolate btn-xs btn-fixed-size\">Análise finalizada</button></td><td ng-if=\"p.status == 9\"><button class=\"btn btn-cadetblue btn-xs btn-fixed-size\">Assinado e Concluído</button></td><td ng-if=\"p.status == 23\"><button class=\"btn btn-cadetblue btn-xs btn-fixed-size\">Operação Concluída</button></td><td>{{p.valor | currency:\'R$ \'}}</td><td style=\"text-align: left; white-space: nowrap; width: 1%\"><button ng-click=\"controller.verDetalhes(p)\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Títulos</button> <button ng-click=\"controller.liberarTitulos(p)\" ng-if=\"p.status == 7 || p.status == 5\" class=\"btn btn-warning btn-xs\"><i class=\"fa fa-retweet\"></i> Liberar Títulos</button> <button ng-click=\"controller.verProposta(p)\" ng-if=\"p.status == 3 || p.status == 4 || p.status == 6 || p.status == 7 || p.status >= 8\" class=\"btn btn-success btn-xs\"><i class=\"fa fa-search\"></i> Proposta</button> <button ng-click=\"controller.aprovarProposta(p)\" ng-if=\"p.status == 3 || p.status == 6\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-check\"></i> Aprovar</button> <a target=\"_blank\" href=\"https://www.assina.net.br/documento/assinadocto\" ng-if=\"p.status == 4 || p.status == 5\" class=\"btn btn-primary btn-xs\"><i class=\"fa fa-edit\"></i> Assinatura Digital</a></td></tr></tbody></table></div></div></div></div></div></div></div>");
$templateCache.put("app/fornecedor/recebiveis/faturas/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Títulos</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">NFe\'s</a></li><li class=\"active\"><strong>Estoque de Títulos</strong></li></ol></div><div class=\"col-lg-2\"><div class=\"m-t-xl\" style=\"text-align: right;\"></div></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.listarPromise\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxFiltro\', \'boxFiltro\')\"><h5><i class=\"fa fa-filter\"></i> Filtrar Resultado</h5><div class=\"ibox-tools\"><a class=\"collapse-link\" style=\"color: white;\"><i id=\"iconBoxFiltro\" class=\"fa fa-chevron-down\"></i></a></div></div><div id=\"boxFiltro\" class=\"ibox-content\" style=\"display: none;\"><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">N° NFe</label> <input type=\"text\" ng-model=\"controller.filtro.nfe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Nº Título</label> <input type=\"text\" ng-model=\"controller.filtro.titulo\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <input type=\"text\" ng-model=\"controller.filtro.sacado\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div></div><div class=\"row\"><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Vencimento</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"date\" ng-model=\"controller.filtro.vencimentoAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Data Inclusão</label> <input type=\"date\" ng-model=\"controller.filtro.dataCadastro\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">Valor</label> <input type=\"number\" ng-model=\"controller.filtro.valorDe\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-2\"><div class=\"form-group\"><label class=\"col-form-label\">até</label> <input type=\"number\" ng-model=\"controller.filtro.valorAte\" class=\"form-control\" ng-change=\"controller.filtrarPesquisa()\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Status</label><select class=\"form-control\" ng-model=\"controller.filtro.status\" ng-change=\"controller.filtrarPesquisaStatus()\"><option ng-value=\"6\">Consultando SEFAZ</option><option ng-value=\"1\">Disponíveis</option><option ng-value=\"4\">CFOP Bloqueado</option><option ng-value=\"5\">Nfe Cancelada</option><option ng-value=\"2\">Em negociação</option><option ng-value=\"3\">Já negociados</option></select></div></div></div><div class=\"row\" style=\"display: none;\"><div class=\"col-sm-12\"><button class=\"btn btn-success pull-right\" ng-click=\"controller.pesquisar()\"><span class=\"fa fa-search\"></span> Pesquisar</button></div></div></div></div></div></div><div class=\"row\" cg-busy=\"controller.listarPromise\" ng-if=\"controller.registros != null\"><div class=\"col-lg-12\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-list\"></i> Títulos</h5><div class=\"ibox-tools\" style=\"display: flex; align-items: center; justify-content: flex-end; gap: 10px;\"><a ng-click=\"controller.listar()\" style=\"display: flex; align-items: center; gap: 10px;\"><h5 style=\"margin: 0; white-space: nowrap;\"><i class=\"fa fa-comments-o\"></i> Se seu título não aparecer, clique no ícone à direita para refazer a consulta ou vá em Filtrar Resultado -> Status e pesquise: Consultando Sefaz</h5><i class=\"fa fa-refresh\" style=\"color: white; font-size: 22px;\"></i></a></div></div><div class=\"ibox-content\"><div class=\"table-responsive\"><div><table class=\"table table-bordered\" style=\"margin-bottom: 0px;\"><thead><tr><th style=\"width: 1px;\"></th><th style=\"white-space: nowrap; width: 1px;\">Origem</th><th ng-click=\"controller.ordenarResultado(\'nfe\')\" style=\"white-space: nowrap;\">Nº NFe<i ng-if=\"controller.orderSelected == \'nfe\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'titulo\')\" style=\"white-space: nowrap;\">Nº Título<i ng-if=\"controller.orderSelected == \'titulo\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th style=\"white-space: nowrap;\">NFe</th><th ng-click=\"controller.ordenarResultado(\'sacado\')\">Sacado<i ng-if=\"controller.orderSelected == \'sacado\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'fornecedor\')\">Fornecedor<i ng-if=\"controller.orderSelected == \'fornecedor\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'cnpjNfe\')\">Cnpj Nfe<i ng-if=\"controller.orderSelected == \'cnpjNfe\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'datacadastro\')\" style=\"white-space: nowrap;\">Dt. Inclusão<i ng-if=\"controller.orderSelected == \'datacadastro\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'vencimento\')\">Vencimento<i ng-if=\"controller.orderSelected == \'vencimento\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th ng-click=\"controller.ordenarResultado(\'valor\')\">Valor<i ng-if=\"controller.orderSelected == \'valor\'\" style=\"float: right\" class=\"fa fa-sort-amount-asc\"></i></th><th>Status</th></tr></thead><tbody><tr ng:repeat=\"p in controller.items\"><td style=\"width: 1px;\"><div ng-if=\"!p.isPossuiCartaoCorrecao || (p.isPossuiCartaoCorrecao && !p.checarCartaCorrecao) || (p.isPossuiCartaoCorrecao && p.statusCartaCorrecao && p.statusCartaCorrecao != 0 && p.statusCartaCorrecao != \'0\')\"><input ng-if=\"p.status == 1 && (p.isPendenteSefaz == false && p.statusNfe != \'101\' && p.cfopBloqueado == null)\" icheck=\"\" type=\"checkbox\" ng-change=\"controller.calcularTotal()\" ng-model=\"p.selecionadoAntecipar\"> <input ng-if=\"p.status != 1\" disabled=\"\" icheck=\"\" type=\"checkbox\" ng-change=\"controller.calcularTotal()\" ng-model=\"p.selecionadoAntecipar\"></div><div ng-if=\"p.isPossuiCartaoCorrecao && p.checarCartaCorrecao && (!p.statusCartaCorrecao || p.statusCartaCorrecao == 0 || p.statusCartaCorrecao == \'0\')\" style=\"text-align: center;\"><span style=\"color: red; font-weight: bold; cursor: help; font-size: 10px;\" title=\"Contate a IC para liberar\">Carta</span></div></td><td style=\"text-align: center; width: 1px;\"><i ng-if=\"p.tipoOrigem == 0\" class=\"fa fa-certificate\" title=\"Nfe\"></i> <i ng-if=\"p.tipoOrigem == 1\" class=\"fa fa-file-zip-o\" title=\"Lote Nfe\"></i> <i ng-if=\"p.tipoOrigem == 2\" class=\"fa fa-user\" title=\"Digitado\"></i> <i ng-if=\"p.tipoOrigem == 3\" class=\"fa fa-cog\" title=\"CNAB\"></i></td><td ng-class=\"{\'text-warning font-bold\': p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\">{{p.numero}}</td><td ng-class=\"{\'text-warning font-bold\': p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\">{{p.titulo}}</td><td style=\"text-align: center;\"><i ng-if=\"p.tipoDocumento == null\" class=\"fa fa-check\" style=\"color: green;\"></i> <i ng-if=\"p.tipoDocumento != null\" class=\"fa fa-times\" style=\"color: red;\"></i></td><td title=\"{{p.sacado}}\">{{p.sacado | limitTo: 30 }}{{p.sacado.length > 30 ? \'...\' : \'\'}}</td><td title=\"{{p.cedente}}\">{{p.cedente | limitTo: 35 }}{{p.cedente.length > 35 ? \'...\' : \'\'}}</td><td>{{p.cnpjNfe}}</td><td>{{p.dataCadastro | date: \'dd/MM/yyyy\'}}</td><td ng-class=\"{\'text-warning font-bold\': p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'1\') !== -1}\">{{p.dataVencimento | date: \'dd/MM/yyyy\'}}</td><td style=\"white-space: nowrap;\" ng-class=\"{\'text-warning font-bold\': p.statusCartaCorrecao && p.statusCartaCorrecao.toString().indexOf(\'2\') !== -1}\">{{p.valor | currency:\'R$ \'}}</td><td ng-if=\"p.status == 1\" style=\"width: 1px;\"><button class=\"btn btn-danger btn-xs btn-block\" ng-if=\"p.isPendenteSefaz\">Consultando SEFAZ</button> <button class=\"btn btn-danger btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.statusNfe == \'101\'\">Nfe Cancelada</button> <button class=\"btn btn-danger btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.cfopBloqueado != null\" title=\"{{p.cfopBloqueado}}\">CFOP Bloqueado</button> <button class=\"btn btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.statusNfe != \'101\' && p.cfopBloqueado == null && p.isPossuiCartaoCorrecao && (!p.statusCartaCorrecao || p.statusCartaCorrecao == 0 || p.statusCartaCorrecao == \'0\')\" style=\"background-color: #9b59b6; border-color: #8e44ad; color: white;\">Carta Correção</button> <button class=\"btn btn-primary btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.statusNfe != \'101\' && p.cfopBloqueado == null && p.isPossuiCartaoCorrecao && p.statusCartaCorrecao && p.statusCartaCorrecao != 0 && p.statusCartaCorrecao != \'0\'\">Liberado C/C</button> <button class=\"btn btn-success btn-xs btn-block\" ng-if=\"p.isPendenteSefaz == false && p.statusNfe != \'101\' && p.cfopBloqueado == null && !p.isPossuiCartaoCorrecao\">Disponível</button></td><td ng-if=\"p.status == 2\" style=\"width: 1px;\"><btn class=\"btn btn-warning btn-xs\">EM NEGOCIAÇÃO</btn></td><td ng-if=\"p.status == 3\" style=\"width: 1px;\"><btn class=\"btn btn-primary btn-xs\">JÁ NEGOCIADO</btn></td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><button class=\"btn btn-warning btn-xs\" ng-click=\"controller.consultarTitulo(p)\"><i class=\"fa fa-search\"></i> Visualizar</button></td></tr></tbody></table><ul ng-if=\"controller.pager.pages.length\" class=\"pagination\"><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(1)\">Primeira</a></li><li ng-class=\"{disabled:controller.pager.currentPage === 1}\"><a ng-click=\"controller.setPage(controller.pager.currentPage - 1)\">Anterior</a></li><li ng-repeat=\"page in controller.pager.pages\" ng-class=\"{active:controller.pager.currentPage === page}\"><a ng-click=\"controller.setPage(page)\">{{page}}</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.currentPage + 1)\">Próxima</a></li><li ng-class=\"{disabled:controller.pager.currentPage === controller.pager.totalPages}\"><a ng-click=\"controller.setPage(controller.pager.totalPages)\">Última</a></li></ul></div></div><div><span style=\"font-weight: bold;\">TOTAL: {{controller.total.valorTotal | currency:\'R$ \'}} <span ng-if=\"controller.total.valorTotal > 0\">em {{controller.total.quantidade}} título{{(controller.total.quantidade > 1 ? \'s \' : \'\')}} selecionado{{(controller.total.quantidade > 1 ? \'s \' : \'\')}}</span></span> <span ng-if=\"controller.existemTitulosPendentesCorrecao\" style=\"color: red; font-weight: bold; margin-left: 10px;\">Solicite a IC liberar título com carta de Correção</span></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-content\" style=\"padding-bottom: 10px;\"><div class=\"row\"><div class=\"col-lg-6\"><button ng-click=\"controller.marcarTodos()\" class=\"btn btn-md btn-primary\" type=\"button\"><i class=\"fa fa-check-square\"></i> MARCAR TODOS</button> <button ng-click=\"controller.desmarcarTodos()\" class=\"btn btn-md btn-warning\" type=\"button\"><i class=\"fa fa-minus-square\"></i> DESMARCAR TODOS</button></div><div class=\"col-lg-6\" style=\"text-align: right;\"><button ng-click=\"controller.validarEPrevenir($event)\" class=\"btn btn-md btn-success\" type=\"button\"><i class=\"fa fa-arrow-right\"></i> ANTECIPAR SELECIONADOS</button></div></div></div></div></div></div>");
$templateCache.put("app/fornecedor/recebiveis/importacao/index.html","<style>\r\n    .ibox {\r\n        margin-bottom: 10px !important;\r\n    }\r\n</style><div class=\"row wrapper border-bottom white-bg page-heading ng-scope\"><div class=\"col-lg-10\"><h2>Importação de Recebíveis</h2><ol class=\"breadcrumb\"><li><a href=\"index.html\">Home</a></li><li><a>Recebíveis</a></li><li class=\"active\"><strong>Importação</strong></li></ol></div><div class=\"col-lg-2\"></div></div><div class=\"wrapper wrapper-content ng-scope\" cg-busy=\"controller.concluirPromise\"><div class=\"row\" cg-busy=\"controller.validarPromise\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5>Envio de Notas Fiscais (NF-e)</h5><div ibox-tools=\"\" class=\"ng-scope\"></div></div><div class=\"ibox-content\"><form action=\"#\" class=\"dropzone dz-clickable ng-pristine ng-valid\" dropzone=\"\" id=\"dropzone\"><div class=\"dz-default dz-message\"><div class=\"fileinput fileinput-new\" data-provides=\"fileinput\"><span class=\"btn btn-sm btn-success btn-file\"><span class=\"fileinput-new\"><i class=\"fa fa-send\"></i> Clique aqui para enviar sua NFE no formato XML</span> <span class=\"fileinput-exists\"></span> <input type=\"file\" accept=\"text/xml\" set-model-on-change=\"\" ng-model=\"controller.selectedTempFile\" ng-click=\"controller.validarEPrevenir($event)\" ng-change=\"controller.adicionarItem()\" name=\"...\"></span> <span class=\"fileinput-filename\"></span> <a href=\"#\" class=\"close fileinput-exists\" data-dismiss=\"fileinput\" style=\"float: none\">×</a></div></div><div><div class=\"table-responsive\"><table ng-if=\"controller.nfe.length > 0\" class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Número Nfe/Série</th><th class=\"white-bg\">Destinatario</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Chave</th></tr></thead><tbody><tr ng:repeat=\"p in controller.nfe\"><td>{{p.numeroNfe + \'/\' + p.serieNfe}}</td><td>{{p.sacado.razaoSocial}}</td><td>{{p.valorNfe}}</td><td>{{p.chaveNfe}}</td><td style=\"text-align: center; width: 1px;\"><a ng-click=\"controller.removerNfe(p)\" class=\"btn btn-danger btn-xs\"><i class=\"fa fa-trash\"></i> Remover</a></td></tr></tbody><tfoot></tfoot></table></div></div></form><div style=\"text-align: right; padding-top: 15px;\" ng-if=\"controller.emitente != null\"><button class=\"btn btn-md btn-success\" type=\"button\" style=\"width: 200px;\" ng-click=\"controller.concluir()\"><i class=\"fa fa-save\"></i> Enviar Títulos</button></div></div></div></div></div><div class=\"row\" ng-if=\"controller.emitente != null\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-tags\"></i> Duplicatas</h5></div><div class=\"ibox-content\"><div class=\"table-responsive\"><table class=\"table table-striped table-bordered table-hover dataTables-example ng-isolate-scope dataTable no-footer\"><thead><tr><th class=\"white-bg\">Número Nfe/Série</th><th class=\"white-bg\">Destinatario</th><th class=\"white-bg\">Duplicata</th><th class=\"white-bg\">Vencimento</th><th class=\"white-bg\">Valor</th><th class=\"white-bg\">Situação</th></tr></thead><tbody><tr ng:repeat=\"p in controller.duplicatas\" ng-style=\"p.statusCadastro == 1 && {\'background-color\':\'yellow\'}\"><td>{{p.notaFiscal.numeroNfe + \'/\' + p.notaFiscal.serieNfe}}</td><td>{{p.notaFiscal.sacado.razaoSocial}}</td><td>{{p.numeroTitulo}}</td><td>{{p.dataVencimento | date:\'dd/MM/yyyy\'}}</td><td>{{p.valorTexto}}</td><td>{{p.situacaoMotivo}}</td><td style=\"text-align: center; white-space: nowrap; width: 1%\"><a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 1\" class=\"btn btn-xs btn-primary\"><i class=\"fa fa-check\"></i> Normal</a> <a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 2\" class=\"btn btn-xs btn-warning\"><i class=\"fa fa-info\"></i> Informativo</a> <a ng-click=\"controller.exibirMotivoTitulo(p)\" ng-if=\"p.situacao == 3\" class=\"btn btn-xs btn-danger\"><i class=\"fa fa-bell\"></i> Inválido</a></td></tr></tbody><tfoot><tr style=\"background-color: white\"></tr><td ng-if=\"(controller.getTotalDuplicatasInvalidas()) == 1\" style=\"color: brown\"><b>ATENÇÃO: {{ (controller.getTotalDuplicatasInvalidas()) }} Título está inválido e não irá para o estoque!</b></td><td ng-if=\"(controller.getTotalDuplicatasInvalidas()) > 1\" style=\"color: brown\"><b>ATENÇÃO: {{ (controller.getTotalDuplicatasInvalidas()) }} Títulos estão inválidos e não irão para o estoque!</b></td><td ng-if=\"!(controller.getTotalDuplicatasInvalidas())\"></td><td colspan=\"3\"></td><td><b class=\"ng-binding\">R$ {{ (controller.getTotalDuplicatas() | number:2) }}</b></td></tfoot></table></div></div></div></div></div></div><div class=\"row\" ng-if=\"controller.emitente != null\"><div class=\"col-lg-12\"><div><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Cedente</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Razão Social</label> <input type=\"text\" ng-model=\"controller.emitente.razaoSocial\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome Fantasia</label> <input type=\"text\" ng-model=\"controller.emitente.nomeFantasia\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ</label> <input type=\"text\" ng-model=\"controller.emitente.cnpj\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Inscrição Estadual</label> <input type=\"text\" ng-model=\"controller.emitente.inscricaoEstadual\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Inscrição Municipal</label> <input type=\"text\" ng-model=\"controller.emitente.inscricaoMunicipal\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">E-mail</label> <input type=\"text\" ng-model=\"controller.emitente.email\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">CNAE</label> <input type=\"text\" ng-model=\"controller.emitente.cnaeDescricao\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CRT</label> <input type=\"text\" ng-model=\"controller.emitente.crtDescricao\" disabled=\"\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/invoice/digitacao/cadastro/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\"><h5 class=\"modal-title\">Incluir Título</h5></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nº do Título</label> <input type=\"text\" ng-model=\"controller.registro.numero\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <button class=\"btn btn-block btn-default\" style=\"font-size: 12px;\" ng-click=\"controller.selecionarSacadoModal()\">{{ controller.registro.sacado == null ? \'Selecionar Sacado\' : controller.registro.sacado.razaoSocial }}</button></div></div><div class=\"col-sm-6\" ng-if=\"controller.tiposDocumento != null\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Documento</label><select class=\"form-control\" ng-model=\"controller.registro.tipoDocumento\" ng-change=\"controller.tipoDocumentoEscolhido()\" ng-options=\"item as item.descricao for item in controller.tiposDocumento track by item.id\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Emissão</label> <input type=\"date\" ng-model=\"controller.registro.dataRecebimento\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Vencimento</label> <input type=\"date\" ng-model=\"controller.registro.dataVencimento\" class=\"form-control\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Valor do Título</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.registro.valor\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\" ng-if=\"controller.registro.tipoDocumento.descricao == \'Cheque\'\"><div class=\"form-group\"><label class=\"col-form-label\">Banco do Cheque</label><select class=\"form-control\" ng-model=\"controller.registro.bancoCheque\" ng-options=\"banco.codigo as banco.nome for banco in controller.bancos\" ng-change=\"controller.bancoChequeEscolhido()\"></select></div></div><div class=\"col-sm-6\" ng-if=\"controller.registro.tipoDocumento.descricao == \'Cheque\'\"><div class=\"form-group\"><label class=\"col-form-label\">Crc-7</label> <input type=\"text\" ng-model=\"controller.registro.crc7\" class=\"form-control\"></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoDocumento.descricao == \'Duplicata\'\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Nota Fiscal</label> <input type=\"text\" ng-model=\"controller.registro.notaFiscalNumero\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Série</label> <input type=\"text\" maxlength=\"2\" ng-model=\"controller.registro.notaFiscalSerie\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Chave Nfe</label> <input type=\"text\" ng-model=\"controller.registro.notaFiscalChave\" class=\"form-control\"></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" style=\"width: 200px;\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Incluir Título</button></div>");
$templateCache.put("app/invoice/digitacao/sacado/index.html","<style>\r\n    .unstyled::-webkit-inner-spin-button,\r\n    .unstyled::-webkit-calendar-picker-indicator {\r\n    display: none;\r\n    -webkit-appearance: none;\r\n}\r\n</style><div class=\"modal-header\"><h5 class=\"modal-title\">Incluir Título</h5></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Nº do Título</label> <input type=\"text\" ng-model=\"controller.registro.numero\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <button class=\"btn btn-block btn-default\" style=\"font-size: 12px;\" ng-click=\"controller.selecionarSacadoModal()\">{{ controller.registro.sacado == null ? \'Selecionar Sacado\' : controller.registro.sacado.razaoSocial }}</button></div></div><div class=\"col-sm-6\" ng-if=\"controller.tiposDocumento != null\"><div class=\"form-group\"><label class=\"col-form-label\">Tipo de Documento</label><select class=\"form-control\" ng-model=\"controller.registro.tipoDocumento\" ng-options=\"item as item.descricao for item in controller.tiposDocumento\"></select></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Emissão</label> <input type=\"date\" ng-model=\"controller.registro.dataRecebimento\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Vencimento</label> <input type=\"date\" ng-model=\"controller.registro.dataVencimento\" class=\"form-control\"></div></div></div><div class=\"row\"><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Valor do Título</label> <input type=\"text\" money-mask=\"\" ng-model=\"controller.registro.valor\" class=\"form-control\"></div></div><div class=\"col-sm-6\" ng-if=\"controller.registro.tipoDocumento.descricao == \'Cheque\'\"><div class=\"form-group\"><label class=\"col-form-label\">Crc-7</label> <input type=\"text\" ng-model=\"controller.registro.crc7\" class=\"form-control\"></div></div></div><div class=\"row\" ng-if=\"controller.registro.tipoDocumento.descricao == \'Duplicata\'\"><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Nota Fiscal</label> <input type=\"text\" ng-model=\"controller.registro.notaFiscalNumero\" class=\"form-control\"></div></div><div class=\"col-sm-3\"><div class=\"form-group\"><label class=\"col-form-label\">Série</label> <input type=\"text\" ng-model=\"controller.registro.notaFiscalSerie\" class=\"form-control\"></div></div><div class=\"col-sm-6\"><div class=\"form-group\"><label class=\"col-form-label\">Chave Nfe</label> <input type=\"text\" ng-model=\"controller.registro.notaFiscalChave\" class=\"form-control\"></div></div></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" style=\"width: 200px;\" class=\"btn btn-success\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Incluir Título</button></div>");
$templateCache.put("app/usuario/modal/solicitar_reset_senha/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Esqueci minha senha</h5><small class=\"font-bold\">Informe os dados abaixo para executar o procedimento de alteração de senha.</small></div><div class=\"modal-body\" style=\"background-color: white;\" cg-busy=\"controller.aprovarProposta\"><div class=\"row\"><div class=\"col-sm-12\"><div class=\"form-group\"><label class=\"col-form-label\">Informe o E-mail Cadastrado</label> <input type=\"text\" maxlength=\"200\" ng-model=\"controller.usuario.email\" class=\"form-control normal-text\"></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.aprovarProposta\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.enviar()\"><i class=\"fa fa-check\"></i> Solicitar</button></div>");
$templateCache.put("app/usuario/modal/selecionar_cedente/index.html","<div class=\"inmodal\"><div class=\"modal-header\"><h4 class=\"modal-title\">Selecione o Fornecedor</h4><small class=\"font-bold\">Este usuário está associado a múltiplos fornecedores. Selecione um para continuar.</small></div><div class=\"modal-body\"><div class=\"form-group\"><div ng-repeat=\"cedente in controller.cedentes\"><div class=\"radio radio-info radio-inline\"><input type=\"radio\" id=\"cedente_{{cedente.id}}\" value=\"{{cedente.id}}\" name=\"radioCedente\" ng-model=\"controller.selectedCedenteId\"> <label for=\"cedente_{{cedente.id}}\">{{cedente.nomeFantasia}} ({{cedente.razaoSocial}})</label></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-white\" ng-click=\"controller.cancel()\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.confirm()\">Continuar</button></div></div>");
$templateCache.put("app/cadastro/sacado/selecionar/novo/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Novo Sacado</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding: 15px;\"><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\"><h5><i class=\"fa fa-bank\"></i> Dados do Sacado</h5></div><div class=\"ibox-content\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Nome / Razão Social</label> <input type=\"text\" ng-model=\"controller.sacado.razaoSocial\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CPF / CNPJ</label> <input type=\"text\" mask=\"{{ controller.sacado.cnpj.length > 14 ? \'99.999.999/9999-99\' : \'999.999.999-999999999\' }}\" ng-model=\"controller.sacado.cnpj\" class=\"form-control inputDisabledModal\"></div></div></div></div></div></div></div><div class=\"row\"><div class=\"col-lg-12\"><div class=\"ibox float-e-margins\"><div class=\"ibox-title bg-success\" ng-click=\"controller.showhide(\'iconBoxEndereco\', \'boxEndereco\')\"><h5><i class=\"fa fa-map-marker\"></i> Endereço</h5></div><div class=\"ibox-content\" id=\"boxEndereco\" cg-busy=\"controller.atualizarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CEP</label> <input type=\"text\" mask=\"99999-999\" maxlength=\"10\" ng-model=\"controller.sacado.endereco.cep\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Logradouro XXXX</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.logradouro\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Número</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.numero\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Complemento</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.complemento\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Bairro</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.bairro\" class=\"form-control inputDisabledModal\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Cidade</label> <input type=\"text\" ng-model=\"controller.sacado.endereco.cidade\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Estado</label><select ng-model=\"controller.sacado.endereco.uf\" class=\"form-control inputDisabledModal\"><option value=\"AC\">ACRE</option><option value=\"AL\">ALAGOAS</option><option value=\"AP\">AMAPÁ</option><option value=\"AM\">AMAZONAS</option><option value=\"BA\">BAHIA</option><option value=\"CE\">CEARÁ</option><option value=\"DF\">DISTRITO FEDERAL</option><option value=\"ES\">ESPÍRITO SANTO</option><option value=\"GO\">GOIÁS</option><option value=\"MA\">MARANHÃO</option><option value=\"MT\">MATO GROSSO</option><option value=\"MS\">MATO GROSSO DO SUL</option><option value=\"MG\">MINAS GERAIS</option><option value=\"PA\">PARÁ</option><option value=\"PB\">PARAÍBA</option><option value=\"PR\">PARANÁ</option><option value=\"PE\">PERNAMBUCO</option><option value=\"PI\">PIAUÍ</option><option value=\"RJ\">RIO DE JANEIRO</option><option value=\"RN\">RIO GRANDE DO NORTE</option><option value=\"RS\">RIO GRANDE DO SUL</option><option value=\"RO\">RONDÔNIA</option><option value=\"RR\">RORAIMA</option><option value=\"SC\">SANTA CATARINA</option><option value=\"SP\">SÃO PAULO</option><option value=\"SE\">SERGIPE</option><option value=\"TO\">TOCANTINS</option><option value=\"EX\">ESTRANGEIRO</option></select></div></div></div></div></div></div></div></div><div class=\"modal-footer\" cg-busy=\"controller.salvarPromise\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" style=\"width: 190px;\" class=\"btn btn-primary\" ng-click=\"controller.salvar()\"><i class=\"fa fa-save\"></i> Salvar</button></div>");
$templateCache.put("app/email/carteira/modal/boleto/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Visualizar Boleto</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\" style=\"text-align: center;\"><div class=\"row\"><div class=\"col-lg-12\"><iframe ng-src=\"{{controller.filePdf}}\" frameborder=\"0\" type=\"application/pdf\" width=\"100%\" height=\"580px\" style=\"overflow: auto;\"></iframe></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/email/carteira/dinamica/vencido/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Boleto</h5></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\" style=\"text-align: center;\"><div class=\"row\"><div ng-if=\"controller.usoDeBoleto === 1 || controller.usoDeBoleto === 0\" ng-class=\"{ \'col-sm-12\': controller.usoDeBoleto === 1 , \'col-sm-6\': controller.usoDeBoleto === 0 }\"><button class=\"btn btn-primary btn-block\" ng-mouseenter=\"controller.mostrarParagrafo = true\" ng-mouseleave=\"controller.mostrarParagrafo = false\" ng-click=\"controller.visualizarBoleto()\" ng-style=\"{\'margin\': controller.usoDeBoleto === 1 ? \'0 auto\' : \'\', \'width\': controller.usoDeBoleto === 1 ? \'50%\' : \'\'}\">Boleto Original</button></div><div ng-if=\"controller.usoDeBoleto === 2 || controller.usoDeBoleto === 0\" ng-class=\"{ \'col-sm-12\': controller.usoDeBoleto === 2, \'col-sm-6\': controller.usoDeBoleto === 0 }\"><button class=\"btn btn-success btn-block\" ng-click=\"controller.visualizarBoletoAtualizado()\" ng-style=\"{\'margin\': controller.usoDeBoleto === 2 ? \'0 auto\' : \'\', \'width\': controller.usoDeBoleto === 2 ? \'50%\' : \'\'}\">Boleto Atualizado</button></div></div><div class=\"row\" style=\"text-align: center;\"><br><p ng-show=\"controller.mostrarParagrafo\" style=\"color: brown; padding: 5px; padding-top: 5px;\"><b>Atenção! Desde 10/11/2018, a NPC (Nova Plataforma de Cobrança) desenvolvida pela FEBRAN (Federação Brasileira de Bancos) passou a exigir o registro de todos os boletos, permitindo que o recebimento dos boletos vencidos possam ser pagos respeitando todas as instruções que contenham encargos, independente do banco emissor e/ou do banco de pagamento. Portanto, mesmo que a segunda via do boleto que já está vencido, seja gerada com os dados originais, no momento do pagamento a NPC irá realizar a atualização dos valores de forma automática.</b></p></div><br></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/fornecedor/antecipacao/minhas_antecipacoes/modal/aprovar_proposta.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Aprovar Proposta</h5><small class=\"font-bold\">Faça a análise da proposta recebida e em seguida realize a aprovação.</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px; background-color: white;\" cg-busy=\"controller.aprovarProposta\"><div class=\"col-lg-12\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Negociação</label><table class=\"table table-bordered\"><thead><tr><th>Tipo</th><th>Valor</th></tr></thead><tbody style=\"background-color: white;\"><tr><td>Face</td><td>{{controller.proposta.retornoProposta.valorFace | currency:\'R$ \' }}</td></tr><tr><td>Deságio</td><td>{{(controller.proposta.retornoProposta.valorFace - controller.proposta.retornoProposta.valorCompra) | currency:\'R$ \' }}</td></tr><tr><td>Compra</td><td>{{controller.proposta.retornoProposta.valorCompra | currency:\'R$ \' }}</td></tr><tr><td>Despesas</td><td>{{controller.proposta.retornoProposta.valorOutrasDespesas | currency:\'R$ \'}}</td></tr><tr><td>Acertos</td><td>{{controller.proposta.retornoProposta.valorDebitoCredito | currency:\'R$ \' }}</td></tr><tr><td>Valor Líquido</td><td>{{controller.proposta.retornoProposta.valorCompra | currency:\'R$ \' }}</td></tr></tbody></table></div></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.aprovarProposta\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-warning\" ng-click=\"controller.recusar()\"><i class=\"fa fa-close\"></i> Recusar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.enviar()\"><i class=\"fa fa-check\"></i> Confirmar</button></div>");
$templateCache.put("app/fornecedor/antecipacao/minhas_antecipacoes/modal/consultar_retorno.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consultar Detalhes</h5><small class=\"font-bold\"></small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px; background-color: white;\"><div class=\"col-lg-12\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"ibox float-e-margins\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">N° Lote</label> <input type=\"text\" disabled=\"\" ng-model=\"controller.proposta.retornoProposta.numeroLote\" class=\"form-control inputDisabledModal\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Vl. Face</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.proposta.retornoProposta.valorFace | currency:\'R$ \'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Vl. Compra</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.proposta.retornoProposta.valorCompra | currency:\'R$ \'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Vl. Despesas</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.proposta.retornoProposta.valorOutrasDespesas | currency:\'R$ \'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Vl. Acertos</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.proposta.retornoProposta.valorDebitoCredito | currency:\'R$ \'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Vl. Líquido</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.proposta.retornoProposta.valorCompra | currency:\'R$ \'}}\"></div></div></div></div></div><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nº Título</th><th>Sacado</th><th>Recusa</th><th>Valor</th><th>Valor Compra</th><th style=\"width: 1px;\">Status</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.proposta.retornoProposta.itens\"><td>{{p.documento}}</td><td>{{p.cnpjCpfSacado}}</td><td>{{p.recusaCodigos == \'\' ? \'não se aplica\' : p.recusaCodigos}}</td><td>{{p.valor | currency:\'R$ \'}}</td><td>{{p.valorCompra | currency:\'R$ \'}}</td><td><button ng-if=\"p.recusado == \'\'\" class=\"btn btn-primary btn-xs\">Aprovado</button> <button ng-if=\"p.recusado != \'\'\" class=\"btn btn-danger btn-xs\">Recusado</button></td></tr></tbody></table></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/fornecedor/antecipacao/minhas_antecipacoes/modal/consultar_titulos.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consultar Títulos</h5><small class=\"font-bold\">Lista de títulos da proposta selecionada.</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\"><div class=\"col-lg-12\" cg-busy=\"controller.consultaPromise\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nº NFe</th><th>Nº Título</th><th>Sacado</th><th>Vencimento</th><th style=\"white-space: nowrap;\">Importação XML</th><th>Valor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.titulos\"><td>{{p.numero}}</td><td>{{p.titulo}}</td><td>{{p.sacado}}</td><td>{{p.dataVencimento | date: \'dd/MM/yyyy\'}}</td><td>{{p.dataImportacaoTitulo | date: \'dd/MM/yyyy\'}}</td><td>{{p.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/fornecedor/recebiveis/faturas/modal/antecipar.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Solicitar Nova Antecipação</h5><small class=\"font-bold\">Após a solicitação, o agente financeiro será notificado para a elaboração da proposta.</small></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th>Nº NFe</th><th>Título</th><th>Sacado</th><th>Vencimento</th><th>Valor</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.registros\"><td>{{p.numero}}</td><td>{{p.titulo}}</td><td>{{p.sacado}}</td><td>{{p.dataVencimento | date: \'dd/MM/yyyy\'}}</td><td>{{p.valor | currency:\'R$ \'}}</td></tr></tbody></table></div></div><div><span style=\"font-weight: bold\">TOTAL: {{controller.total.valorTotal | currency:\'R$ \'}} <span ng-if=\"controller.total.valorTotal > 0\">em {{controller.total.quantidade}} título{{(controller.total.quantidade > 1 ? \'s \' : \'\')}} selecionado{{(controller.total.quantidade > 1 ? \'s \' : \'\')}}</span></span><br><br></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" ng-click=\"controller.enviar()\"><i class=\"fa fa-check\"></i> Confirmar</button></div>");
$templateCache.put("app/sacado/consulta/usuario/consulta/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Consultar Usuário</h5><small class=\"font-bold\">Detalhes do usuário selecionado.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Login</label><div class=\"col-lg-4\"><input type=\"text\" ng-model=\"controller.usuario.login\" class=\"form-control\"></div><label class=\"col-lg-1 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.usuario.senha\" class=\"form-control\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.atualizar()\"><i class=\"fa fa-send\"></i> Atualizar</button></div>");
$templateCache.put("app/sacado/consulta/usuario/cadastro/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Incluir Novo Usuário</h5><small class=\"font-bold\">Informe os dados para cadastro.</small></div><div class=\"modal-body\" cg-busy=\"controller.inserirPessoa\"><div class=\"col-lg-12\"><form class=\"form-horizontal ng-pristine ng-valid\"><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Nome</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.nome\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">E-mail</label><div class=\"col-lg-10\"><input type=\"text\" ng-model=\"controller.usuario.email\" class=\"form-control\"></div></div><div class=\"form-group\"><label class=\"col-lg-2 control-label\">Senha</label><div class=\"col-lg-5\"><input type=\"text\" ng-model=\"controller.usuario.senha\" class=\"form-control\"></div></div></form></div><div style=\"clear: both\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.incluir()\"><i class=\"fa fa-send\"></i> Incluir</button></div>");
$templateCache.put("app/email/carteira/dinamica/itau/boletovencido/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Boleto</h5></div><div class=\"modal-body\" style=\"padding: 0px; padding-top: 20px;\" cg-busy=\"controller.consultaPromise\"><div class=\"col-lg-12\" style=\"text-align: center;\"><div class=\"row\"><div class=\"col-sm-6\"><button class=\"btn btn-primary btn-block\" ng-click=\"controller.visualizarBoleto()\">Boleto Original</button></div><div class=\"col-sm-6\"><form method=\"POST\" action=\"https://ww2.itau.com.br/2viabloq/pesquisa.asp\" name=\"form\" target=\"novajanela\"><input type=\"hidden\" name=\"DC\" value=\"{{controller.codigo}}\"> <input type=\"submit\" class=\"btn btn-success btn-block\" name=\"2via\" value=\"Boleto Atualizado\"></form></div></div><br></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div>");
$templateCache.put("app/fornecedor/recebiveis/faturas/modal/detalhar_titulo/index.html","<div class=\"modal-header\"><h5 class=\"modal-title\">Detalhes do Título</h5><small class=\"font-bold\">Informações detalhadas do título selecionado.</small></div><style>\r\n    .text-warning.form-control {\r\n        color: #f8ac59 !important;\r\n    }\r\n</style><div class=\"modal-body\" style=\"padding-top: 20px; background-color: white;\" cg-busy=\"controller.consultarPromise\"><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><input type=\"text\" disabled=\"\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\" ng-model=\"controller.titulo.numeroNfe\" class=\"form-control inputDisabledModal\"> <label class=\"col-form-label\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\">N° Nfe</label></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\">N° Título</label> <input type=\"text\" disabled=\"\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'3\') !== -1}\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.numero}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Fornecedor</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.cedente.razaoSocial}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ do Fornecedor</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.cedente.cnpj}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Sacado</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.sacado.razaoSocial}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">CNPJ do Sacado</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.sacado.cnpj}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data de Emissão</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.notaFiscalDto.dataRecebimento | date: \'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data da Fatura</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.notaFiscalDto.dataRecebimento | date: \'dd/MM/yyyy\'}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'1\') !== -1}\">Data de Vencimento</label> <input type=\"text\" disabled=\"\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'1\') !== -1}\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.dataVencimento | date: \'dd/MM/yyyy\'}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Chave de Acesso da NF-e</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.notaFiscalDto.chaveNfe }}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'2\') !== -1}\">Valor</label> <input type=\"text\" disabled=\"\" ng-class=\"{\'text-warning font-bold\': controller.titulo.statusCartaCorrecao && controller.titulo.statusCartaCorrecao.toString().indexOf(\'2\') !== -1}\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.valor | currency:\'R$ \'}}\"></div></div></div><div class=\"row\"><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Banco Cheque</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.bancoCheque }}\"></div></div><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">CMC-7 {{}}</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.cmc7 }}\"></div></div></div><div class=\"row\"><div class=\"col-sm-8\"><div class=\"form-group\"><label class=\"col-form-label\">Situação</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.nfeValidacao.documentoDTO.documentos[0].ultimoStatus}} - {{controller.titulo.nfeValidacao.documentoDTO.documentos[0].nfeStatusSefaz.descricao}}\"></div></div><div class=\"col-sm-4\"><div class=\"form-group\"><label class=\"col-form-label\">Data Atualização</label> <input type=\"text\" disabled=\"\" class=\"form-control inputDisabledModal\" value=\"{{controller.titulo.nfeValidacao.documentoDTO.documentos[0].dataUltimoStatus}}\"></div></div></div><div class=\"row\" ng-if=\"controller.titulo.nfeValidacao.documentoDTO.documentos[0].eventos.length > 0\"><div class=\"col-sm-12\"><div class=\"table-responsive\"><div style=\"overflow: auto; max-height: 270px;\"><table class=\"table table-bordered\"><thead><tr><th style=\"width: 150px; white-space: nowrap;\">Data Evento</th><th style=\"width: 100px\">Código</th><th>Evento</th></tr></thead><tbody style=\"background-color: white;\"><tr ng:repeat=\"p in controller.titulo.nfeValidacao.documentoDTO.documentos[0].eventos\"><td>{{p.dataEvento}}</td><td>{{p.tipoEvento}}</td><td ng-if=\"p.descrEvento == null\">{{p.nfeEventoStatusSefaz.nome}}</td><td ng-if=\"p.descrEvento != null\">{{p.nfeEventoStatusSefaz.nome}}:<br>{{p.descrEvento}}</td></tr></tbody></table></div></div></div></div><div style=\"clear: both;\"></div></div><div class=\"modal-footer\" cg-busy=\"controller.inserirPessoa\"><div style=\"float: left;\"><button type=\"button\" class=\"btn btn-danger\" ng-click=\"controller.excluir()\" ng-if=\"controller.titulo.status == 1\"><i class=\"fa fa-trash\"></i> Excluir</button> <button type=\"button\" class=\"btn btn-success\" ng-click=\"controller.fechar()\"><i class=\"fa fa-close\"></i> Fechar</button></div><div style=\"float: right; margin-top: 8px; margin-right: 10px;\" ng-if=\"controller.titulo.statusCartaCorrecao === 0 && controller.titulo.checarCartaCorrecao\"><span style=\"color: red; font-weight: bold;\">Solicite a IC para liberar esse título</span></div><div style=\"float: right; margin-top: 8px; margin-right: 10px;\" ng-if=\"controller.titulo.statusCartaCorrecao !== 0\"><span style=\"color: green; font-weight: bold;\">Liberado pela IC</span></div></div>");}]);